<template >
  <div class="block-layout questionnaire que_tmp_parent" id="scrollableques" v-if="isEveryThingLoaded">
    <button  v-if="isEdit" :disabled="updating"  class="questionary_save right130" @click="saveMe(true)">Update
      <span class="loader" v-if="updating" ><img src="@/assets/images/main/loader.gif" /></span>
    </button> 
    <div
      class="vx-col w-full wizard-container form_section questionnairesection pad0 case-form-v2"
    >
      <div class="questionnaire_page" id="questionnaire_page">
        <div class="questionnaire_sec">
          <div class="questionnaire_titles">
            <div class="questionnaire_titles_info">
              <h2>Questionnaire</h2>
              <!-- <h2 v-if="entityType == 'l2'">L2 Questionnaire</h2> 
              <h2 v-else>H4 Questionnaire</h2>  -->

              <p>Please take a few moments to complete this short registration form</p>
              
              <ul class="qs-list-count">
                
                <template  v-if=" !isEdit " >
                    <template  v-if=" (canRenderField('educations', dbFields ,false,'beneficiaryInfo.educations') || canRenderField('prevEmploymentInfo', dbFields ,false,'beneficiaryInfo.prevEmploymentInfo'))" >
                      <template  v-if=" (canRenderField('educations', dbFields ,false,'beneficiaryInfo.educations') && canRenderField('prevEmploymentInfo', dbFields ,false,'beneficiaryInfo.prevEmploymentInfo'))">
                          <li  :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                          <li v-if="false" :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info' ,'Parents Info'].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>2</span><a>Educational Info</a></li>
                          <li v-if="false" :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info','ASSOCIATIONS/GROUPS Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>3</span><a>Employment Info</a></li>
                          <li v-if="false"  :class="{'active':['Documents Info' ,'Dependents Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>4</span><a>Parents Info</a></li>
                          <li :class="{'active':['Documents Info' ,'Dependents Info', ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>5</span><a>Documents Info</a></li>
                          <li  :class="{'active':['Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>6</span><a>Dependents Info </a></li>
                  
                        </template>
                        <template v-else>

                          <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                          <li v-if="false && canRenderField('educations', dbFields ,false,'beneficiaryInfo.educations')" :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>2</span><a>Educational Info</a></li>
                          <li v-if="false && canRenderField('prevEmploymentInfo', dbFields ,false,'beneficiaryInfo.prevEmploymentInfo')" :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>3</span><a>Employment Info</a></li>
                          <li v-if="false" :class="{'active':['Documents Info' ,'Dependents Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>4</span><a>Parents Info</a></li>
                          <li :class="{'active':['Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>5</span><a>Documents Info</a></li>
                          <li  :class="{'active':['Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>6</span><a>Dependents Info </a></li>
                  

                        </template>
                      
                    </template>
                    <template v-else>
                      <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                            <li v-if="false" :class="{'active':['Documents Info' ,'Dependents Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>3</span><a>Parents Info</a></li>
                           <li :class="{'active':['Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>4</span><a>Documents Info</a></li>
                          <li  :class="{'active':['Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>5</span><a>Dependents Info </a></li>
              

                    </template>

                </template>
                <template v-else>

                    <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  class="active"><span>1</span><a>Personal Info</a></li>
                    <li v-if="false"  :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>2</span><a>Educational Info</a></li>
                    <li  v-if="false"  :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>3</span><a>Employement Info</a></li>
                        <li v-if="false"  :class="{'active':['Documents Info' ,'Dependents Info','Parents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Parents Info'"><span>4</span><a>Parents Info</a></li>
                        <li :class="{'active':['Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>5</span><a>Documents Info</a></li>
                        <li   :class="{'active':['Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>6</span><a>Dependents Info </a></li>
              
                </template>   
              
              
           
            </ul>

              

            </div> 
            <figure><img src="@/assets/images/main/content-bottom-image.svg" /></figure>
          </div>
          <div class="questionnaire_form questionnaire_template_form">
             <div v-if="currentTab=='Personal Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and  accurately. Kindly read the instructions carefully.</vs-alert>
                </vs-col>
                <template v-if="false">
                <vs-col  class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                  <div class="form-container pt-10 form-container-questionnaire">
                      <div class="vx-row">
                        <div class="vx-col w-full mb-0 mt-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverEmployed'})">
                                <div class="form_group">
                                
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Have you ever been employed?<em v-if="beneficiaryInfo.haveYouEverEmployed">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverEmployed'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverEmployed'})}" >
                                                  <span class="checkmark" >
                                                    <i class="material-icons">check</i>
                                                  </span>
                                                </span>
                                                <div class="tooltip_cnt">
                                                  <p>Field is required</p>
                                                </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverEmployed'})">
                                                <vs-checkbox
                                              
                                                v-model="beneficiaryInfo.haveYouEverEmployed"
                                                  @change="
                                                    selectCheck({
                                                      section: 'beneficiaryInfo',
                                                      key: 'haveYouEverEmployed',
                                                    })
                                                  "
                                                ></vs-checkbox>
                                                <div class="tooltip_cnt">
                                                  <p>Validation is required</p>
                                                </div>
                                              </div>
                                              </div>
                                    
                                  </div>
                                  <div class="form_radio_btns">
                                    <vs-button class="yes mr-5" color="success" type="border">
                                      Yes</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >No</vs-button
                                    >
                                  </div>
                                </div>
                      </div> 
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'empInUsIfANumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">A-number, if any<em v-if="beneficiaryInfo.empInUsIfANumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'empInUsIfANumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'empInUsIfANumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'empInUsIfANumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.empInUsIfANumber"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'empInUsIfANumber' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'h1bSpouseApprNumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">H-1B Spouse’s most recent approval number<em v-if="beneficiaryInfo.h1bSpouseApprNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'h1bSpouseApprNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'h1bSpouseApprNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'h1bSpouseApprNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.h1bSpouseApprNumber"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'h1bSpouseApprNumber' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                    </div>
                  </div>
                </vs-col>
                </template>
                
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT"> 
                    <div class="vx-row">
                      <template v-if="false">
                       
                       <div class="vx-col w-full" >
                         <template v-if="showOrHideField({section: 'beneficiaryInfo',key: 'adjustmentOfI485Status'}) || showOrHideField({section: 'beneficiaryInfo',key: 'consularProcessing'})">
                           <label class="switch-label">Would you like to apply for adjustment of status (I-485) or consular processing? </label>
                         </template>
                          <template v-if="showOrHideField({section: 'beneficiaryInfo',key: 'adjustmentOfI485Status'})">
                            <div class="d-flex align-center">
                              <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                              <vs-checkbox :disabled="true"> Adjustment of Status (I-485)<p>When your Priority Date is current, and you have a valid status in the U.S. by then, you may file I-485 to get your Green&nbsp;Card</p> </vs-checkbox>
                              </div>
                              <div class="check_box_container mart30" v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'adjustmentOfI485Status'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'adjustmentOfI485Status'})}"  >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'adjustmentOfI485Status'})">
                                  <vs-checkbox
                              
                                      v-model="beneficiaryInfo.adjustmentOfI485Status"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo',
                                          key: 'adjustmentOfI485Status',
                                        })
                                      "
                                    ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                       </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'consularProcessing'})">
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox :disabled="true"> Consular Processing
                            <p>When your Priority Date is current, and you would like to go to a U.S. consulate 
                            abroad to apply for an immigrant visa to get your Green Card</p> </vs-checkbox>
                          </div>
                          <div class="check_box_container mart30" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'consularProcessing'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'consularProcessing'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'consularProcessing'})">
                              <vs-checkbox
                                
                                  v-model="beneficiaryInfo.consularProcessing"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'consularProcessing',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'areYouUnderRemoveOfIndOrUscis'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Are you currently under removal proceedings by the INS/USCIS? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'areYouUnderRemoveOfIndOrUscis'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'areYouUnderRemoveOfIndOrUscis'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'areYouUnderRemoveOfIndOrUscis'})">
                              <vs-checkbox
                              
                                v-model="beneficiaryInfo.areYouUnderRemoveOfIndOrUscis"
                                @change="
                                  selectCheck({
                                    section: 'beneficiaryInfo',
                                    key: 'areYouUnderRemoveOfIndOrUscis',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'immPetitionPriorityDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Your priority date obtained from your previous immigrant petition<em v-if="beneficiaryInfo.immPetitionPriorityDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'immPetitionPriorityDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'immPetitionPriorityDate'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'immPetitionPriorityDate'})">
                              <vs-checkbox
                              
                              v-model="beneficiaryInfo.immPetitionPriorityDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',
                                  key: 'immPetitionPriorityDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                                :disabled="true"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                     </template>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'currentlyInUS'}) && false" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Are you currently in USA? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'currentlyInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'currentlyInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'currentlyInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.currentlyInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'currentlyInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
       
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveOwnershipInterest'}) && false">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Do you have ownership interest in this Company?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'haveOwnershipInterest'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveOwnershipInterest'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveOwnershipInterest'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.haveOwnershipInterest"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'haveOwnershipInterest',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'ownershipInterestDesc'}) && false">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Ownership Details<em v-if="beneficiaryInfo.ownershipInterestDesc">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'ownershipInterestDesc'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'ownershipInterestDesc'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'ownershipInterestDesc'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.ownershipInterestDesc"
                               @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'ownershipInterestDesc',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-textarea w-full vs-textarea-primary">
                           <textarea class="vs-textarea" :disabled="true"></textarea>
                         </div>
                       </div>
                     </div>




                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverAppliedH1bCase'}) && false">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                          Have you ever applied for a H1B petition earlier?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverAppliedH1bCase'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverAppliedH1bCase'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverAppliedH1bCase'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.haveYouEverAppliedH1bCase"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'haveYouEverAppliedH1bCase',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'prevH1bCaseDesc'}) && false">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Please mention Receipt Number, whether Approved, Denied or not Used.
                            <em v-if="beneficiaryInfo.prevH1bCaseDesc">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'prevH1bCaseDesc'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'prevH1bCaseDesc'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'prevH1bCaseDesc'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.prevH1bCaseDesc"
                               @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'prevH1bCaseDesc',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-textarea w-full vs-textarea-primary">
                           <textarea class="vs-textarea" :disabled="true"></textarea>
                         </div>
                       </div>
                     </div>    
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'h4EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >H4 EAD required for spouse?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'h4EADRequired'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'h4EADRequired'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'h4EADRequired'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.h4EADRequired"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',

                                  key: 'h4EADRequired',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'doYouAlreadyH4EAD'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Do you already have H4 EAD?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'doYouAlreadyH4EAD'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'doYouAlreadyH4EAD'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'doYouAlreadyH4EAD'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.doYouAlreadyH4EAD"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',

                                  key: 'doYouAlreadyH4EAD',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'l2EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >L2 EAD required for spouse?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'l2EADRequired'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'l2EADRequired'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'l2EADRequired'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.l2EADRequired"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',

                                  key: 'l2EADRequired',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'doYouAlreadyL2EAD'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Do you already have L2 EAD?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'doYouAlreadyL2EAD'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'doYouAlreadyL2EAD'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'doYouAlreadyL2EAD'})">
                              <vs-checkbox
                            
                              v-model="beneficiaryInfo.doYouAlreadyL2EAD"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',

                                  key: 'doYouAlreadyL2EAD',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>




                     <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'gender'})">
                       <div class="d-flex align-end mb-1">
                         <label class="form_label">Gender<em v-if="beneficiaryInfo.gender">*</em></label>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'gender'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'gender'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'gender'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.gender"
                             @change="
                             selectCheck({ section: 'beneficiaryInfo', key: 'gender' })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                       <vx-input-group class="form-input-group FML">
                         <vs-button
                           class="btn male-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Male</vs-button
                         >
                         <vs-button
                           class="btn female-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Female</vs-button
                         >
                         <vs-button
                           class="btn others-btn"
                           icon-pack="feather"
                           icon="icon-circle"
                           type="border"
                           :disabled="true"
                           >Others</vs-button
                         >
                       </vx-input-group>
                     </div>
                     <div class="divider full-divider mb-10"></div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'firstName'})">
                       <div class="vx-input-group flex form-input-group FML">
                         <div class="vx-input-group-default flex-grow">
                           <div class="vx-col w-full md:w-1/2">
                             <div class="form_group">
                               <div class="d-flex align-end mb-1">
                                 <label class="form_label">First Name<em v-if="beneficiaryInfo.firstName">*</em></label>
                                 <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'firstName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'firstName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'firstName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.firstName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'firstName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>

                               </div>
                               <div class="vs-input w-full vs-input-primary">
                                 <div class="vs-con-input">
                                   <input
                                     type="text"
                                     maxlength="200"
                                     class="vs-inputx vs-input--input normal" :disabled="true"
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                           <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'middleName'})">
                             <div class="form_group">
                               <div class="d-flex align-end mb-1">
                                 <label class="form_label">Middle Name<em v-if="beneficiaryInfo.middleName">*</em></label>
                                 <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'middleName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'middleName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'middleName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.middleName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'middleName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               </div>
                               <div class="vs-input w-full vs-input-primary">
                                 <div class="vs-con-input">
                                   <input
                                     type="text"
                                     maxlength="200"
                                     class="vs-inputx vs-input--input normal" :disabled="true"
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                           <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'lastName'})">
                             <div class="form_group">
                               <div class="d-flex align-end mb-1">
                                 <label class="form_label">Last Name<em v-if="beneficiaryInfo.lastName">*</em></label>
                                 <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'lastName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'lastName'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'lastName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.lastName"
                                   @change="
                                     selectCheck({
                                       section: 'beneficiaryInfo',
                                       key: 'lastName',
                                     })
                                   "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               </div>
                               <div class="vs-input w-full vs-input-primary">
                                 <div class="vs-con-input">
                                   <input
                                     type="text"
                                     maxlength="200"
                                     class="vs-inputx vs-input--input normal" :disabled="true"
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'otherNames'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Have you ever used any other names previously?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'otherNames'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'otherNames'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'otherNames'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.otherNames"
                           @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'otherNames',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>                         
                       </div>
                     </div>

                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'email'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Email<em v-if="beneficiaryInfo.email">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'email'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'email'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'email'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.email"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'email' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'cellPhoneNumber'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Phone Number<em v-if="beneficiaryInfo.cellPhoneNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'cellPhoneNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'cellPhoneNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'cellPhoneNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.cellPhoneNumber"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'cellPhoneNumber',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-component">
                           <VuePhoneNumberInput
                             icon-pack="feather"
                             class="w-full no-icon-border"
                             :no-example="false"
                             key="phone"
                             data-vv-as="Phone Number"
                             name="phone"
                             placeholder="Phone Number"
                             :preferred-countries="['US', 'IN']"
                             :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                        
                     <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'homePhoneNumber'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Home Phone Number<em v-if="beneficiaryInfo.homePhoneNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'homePhoneNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'homePhoneNumber'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'homePhoneNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.homePhoneNumber"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'homePhoneNumber',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         
                         </div>
                         <div class="vs-component">
                           <VuePhoneNumberInput
                             icon-pack="feather"
                             class="w-full no-icon-border"
                             :no-example="false"
                             key="phone"
                             data-vv-as="Phone Number"
                             name="phone"
                             placeholder="Home Phone Number"
                             :preferred-countries="['US', 'IN']"
                             :disabled="true"
                           />
                         </div>
                       </div>
                     </div>

                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'countryOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Birth<em v-if="beneficiaryInfo.countryOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'countryOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfBirth'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.countryOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'countryOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                      </div> 
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'dateOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Birth<em v-if="beneficiaryInfo.dateOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'dateOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'dateOfBirth'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'dateOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.dateOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'dateOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'applyingPetitionFor'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Applying petition for?<em v-if="beneficiaryInfo.applyingPetitionFor">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'applyingPetitionFor'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'applyingPetitionFor'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'applyingPetitionFor'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.applyingPetitionFor"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo',

                                  key: 'applyingPetitionFor',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <selectField
                            wrapclass=""
                            placeholder="Your Relationship with the dependent"
                          />
                        </div>
                      </div>
                     <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'SSN'})">
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full mb-5">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Social Security number (if applicable)<em v-if="beneficiaryInfo.SSN">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'SSN'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'SSN'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'SSN'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.SSN"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'SSN',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        name="0"
                                        placeholder="123 - 45 - 6789"
                                        data-vv-as="123 - 45 - 6789"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full"  v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'alienNumber'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Your Alien Number (if applicable)<em v-if="beneficiaryInfo.alienNumber">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'alienNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'alienNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'alienNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.alienNumber"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'alienNumber',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        name="0"
                                        placeholder="123 - 45 - 6789"
                                        data-vv-as="123 - 45 - 6789"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full"  v-if="false &&  showOrHideField({section: 'beneficiaryInfo',key: 'consulateNotifyAddress'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Consulate to Notify upon Approval of your petition (if outside the USA)<em v-if="beneficiaryInfo.consulateNotifyAddress">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'consulateNotifyAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'consulateNotifyAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'consulateNotifyAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.consulateNotifyAddress"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'consulateNotifyAddress',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        name="0"
                                        placeholder="123 - 45 - 6789"
                                        data-vv-as="123 - 45 - 6789"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                      </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'I94'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">I-94 Number<em v-if="beneficiaryInfo.I94">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'I94'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'I94'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'I94'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.I94"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'I94' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2 " v-if="showOrHideField({section: 'beneficiaryInfo',key: 'I94ExpiryDate'})">
                      <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">I-94 Expiry Date<em v-if="beneficiaryInfo.I94ExpiryDate">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.I94ExpiryDate"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'I94ExpiryDate' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'lastArrivalDate'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             >Date of most recent entry into the USA<em v-if="beneficiaryInfo.lastArrivalDate">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'lastArrivalDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'lastArrivalDate'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'lastArrivalDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.lastArrivalDate"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'lastArrivalDate',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                      </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'stateOfLastEntryInUS'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             > State of recent entry into the USA<em v-if="beneficiaryInfo.stateOfLastEntryInUS">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'stateOfLastEntryInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'stateOfLastEntryInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'stateOfLastEntryInUS'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.stateOfLastEntryInUS"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'stateOfLastEntryInUS',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if=" showOrHideField({section: 'beneficiaryInfo',key: 'placeOfLastEntryInUS'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Place of recent entry into the USA<em v-if="beneficiaryInfo.placeOfLastEntryInUS">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'placeOfLastEntryInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'placeOfLastEntryInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'placeOfLastEntryInUS'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.placeOfLastEntryInUS"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'placeOfLastEntryInUS',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-0 mt-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverEmployed'})">
                                <div class="form_group">
                                
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Have you ever been employed?<em v-if="beneficiaryInfo.haveYouEverEmployed">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverEmployed'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverEmployed'})}" >
                                                  <span class="checkmark" >
                                                    <i class="material-icons">check</i>
                                                  </span>
                                                </span>
                                                <div class="tooltip_cnt">
                                                  <p>Field is required</p>
                                                </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverEmployed'})">
                                                <vs-checkbox
                                              
                                                v-model="beneficiaryInfo.haveYouEverEmployed"
                                                  @change="
                                                    selectCheck({
                                                      section: 'beneficiaryInfo',
                                                      key: 'haveYouEverEmployed',
                                                    })
                                                  "
                                                ></vs-checkbox>
                                                <div class="tooltip_cnt">
                                                  <p>Validation is required</p>
                                                </div>
                                              </div>
                                              </div>
                                    
                                  </div>
                                  <div class="form_radio_btns">
                                    <vs-button class="yes mr-5" color="success" type="border">
                                      Yes</vs-button
                                    >
                                    <vs-button class="no" color="danger" type="border"
                                      >No</vs-button
                                    >
                                  </div>
                                </div>
                      </div> 
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'empInUsIfANumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">A-number, if any<em v-if="beneficiaryInfo.empInUsIfANumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'empInUsIfANumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'empInUsIfANumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'empInUsIfANumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.empInUsIfANumber"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'empInUsIfANumber' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'h1bSpouseApprNumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">H-1B Spouse’s most recent approval number<em v-if="beneficiaryInfo.h1bSpouseApprNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'h1bSpouseApprNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'h1bSpouseApprNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'h1bSpouseApprNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.h1bSpouseApprNumber"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'h1bSpouseApprNumber' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'l1SpouseApprNumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">L1 Spouse’s most recent approval number<em v-if="beneficiaryInfo.l1SpouseApprNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'l1SpouseApprNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'l1SpouseApprNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'l1SpouseApprNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.l1SpouseApprNumber"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'l1SpouseApprNumber' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'address'})">
                              <h3 class="small-header">
                                Current Address <em v-if="beneficiaryInfo.address">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'address'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'address'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'address'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.address"
                                  @change="
                                    selectCheck({ section: 'beneficiaryInfo', key: 'address' })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                      </div>
                      
                     <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'currentAddress'})">
                              <h3 class="small-header">
                                Mailing Address <em v-if="beneficiaryInfo.currentAddress">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'currentAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'currentAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'currentAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.currentAddress"
                                  @change="
                                    selectCheck({ section: 'beneficiaryInfo', key: 'currentAddress' })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                     </div>
                     <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'addressOutsideUS'})">
                        <h3 class="small-header">
                          Address Outside the U.S <em v-if="beneficiaryInfo.addressOutsideUS">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'addressOutsideUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUS'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.addressOutsideUS"
                            @change="
                              selectCheck({ section: 'beneficiaryInfo', key: 'addressOutsideUS' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>

                     

                     
                     




                     <!--485-->
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'birthCertHaveNamePobDob'}) " >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">Does the birth certificate have your name, place of birth, date of birth, parents’ names mentioned, and the birth was registered around the time you were born? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'birthCertHaveNamePobDob'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'birthCertHaveNamePobDob'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'birthCertHaveNamePobDob'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.birthCertHaveNamePobDob"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'birthCertHaveNamePobDob',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div> 
                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'have2AffidavitsOfBirthFamily'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">Do you have two (2) affidavits of birth from family members?</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'have2AffidavitsOfBirthFamily'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsOfBirthFamily'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsOfBirthFamily'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.have2AffidavitsOfBirthFamily"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'have2AffidavitsOfBirthFamily',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'nameDiffFromBirthCert'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> if your name is different from that stated on your birth certificate, have you had it legally changes? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'nameDiffFromBirthCert'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'nameDiffFromBirthCert'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'nameDiffFromBirthCert'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.nameDiffFromBirthCert"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'nameDiffFromBirthCert',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'previouslyMarried'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Were you married previously? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'previouslyMarried'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'previouslyMarried'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'previouslyMarried'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.previouslyMarried"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'previouslyMarried',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.height',key: 'feet'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Feet dddddddddddd<em v-if="beneficiaryInfo.height.feet">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.height',key:'feet'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.height',key:'feet'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.height',key:'feet'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.height.feet"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.height',
                                 key: 'feet',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.height',key: 'inches'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Inches<em v-if="beneficiaryInfo.height.inches">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.height',key:'inches'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.height',key:'inches'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.height',key:'inches'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.height.inches"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.height',
                                 key: 'inches',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'weight'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Weight<em v-if="beneficiaryInfo.weight">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'weight'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'weight'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'weight'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.weight"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'weight',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'race'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Race<em v-if="beneficiaryInfo.race">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'race'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'race'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'race'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.race"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'race',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'eyeColor'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">EYE COLOR<em v-if="beneficiaryInfo.eyeColor">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'eyeColor'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'eyeColor'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'eyeColor'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.eyeColor"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'eyeColor',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'hairColor'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">HAIR COLOR<em v-if="beneficiaryInfo.hairColor">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'hairColor'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hairColor'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hairColor'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.hairColor"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'hairColor',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     
                     
                     
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'noOfChildrens'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"> No of Childrens <em v-if="beneficiaryInfo.noOfChildrens">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'noOfChildrens'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'noOfChildrens'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'noOfChildrens'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.noOfChildrens"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'noOfChildrens',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'dateOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage<em v-if="beneficiaryInfo.dateOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'dateOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'dateOfMarriage'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'dateOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.dateOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'dateOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'countryOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Marriage<em v-if="beneficiaryInfo.countryOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'countryOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.countryOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'countryOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'provinceOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Province of Marriage<em v-if="beneficiaryInfo.provinceOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'provinceOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.provinceOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'provinceOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'locationOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Marriage<em v-if="beneficiaryInfo.locationOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'locationOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'locationOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'locationOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.locationOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'locationOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'doYouHaveMarriageCert'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Do you have a Marriage Certificate? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'doYouHaveMarriageCert'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'doYouHaveMarriageCert'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'doYouHaveMarriageCert'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.doYouHaveMarriageCert"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'doYouHaveMarriageCert',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'marriageCertDocs'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >Marriage Certificates<em>*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'marriageCertDocs'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'marriageCertDocs'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'marriageCertDocs'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.marriageCertDocs"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'marriageCertDocs',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'have2AffidavitsAttestingToMarriage'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Do you have two(2) affidavits attesting to the marriage? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'have2AffidavitsAttestingToMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsAttestingToMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'have2AffidavitsAttestingToMarriage'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.have2AffidavitsAttestingToMarriage"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'have2AffidavitsAttestingToMarriage',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="divider full-divider mb-10"></div>
                     <div class="vx-col w-full" v-if="false &&checkSpouseLabel({section:'beneficiaryInfo.previousSpouse'})" >
                       <div class="form_group w-full">
                         <label class="form_label"
                           ><h3 class="small-header">Previous Spouse
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})">
                                <vs-checkbox
                              
                                v-model="
                              beneficiaryInfo.previousSpouse.previousSpouse
                            "
                            @change="
                              selectCheck({
                                section: 'beneficiaryInfo.previousSpouse',
                                key: 'previousSpouse',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                            </div>
                           </h3> 
                         </label>
                       </div>
                     </div>  
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'firstName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">First Name<em v-if="beneficiaryInfo.previousSpouse.firstName">*</em></label>

                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'firstName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'firstName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'firstName'})">
                            
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.firstName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'firstName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'middleName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Middle Name<em v-if="beneficiaryInfo.previousSpouse.middleName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'middleName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'middleName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'middleName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.middleName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'middleName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'lastName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Last Name<em v-if="beneficiaryInfo.previousSpouse.lastName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'lastName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'lastName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'lastName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.lastName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'lastName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'maidenName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Maiden Name<em v-if="beneficiaryInfo.previousSpouse.maidenName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.maidenName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'maidenName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Birth<em v-if="beneficiaryInfo.previousSpouse.dateOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage<em v-if="beneficiaryInfo.previousSpouse.dateOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfMarriageEnd'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage End<em v-if="beneficiaryInfo.previousSpouse.dateOfMarriageEnd">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfMarriageEnd"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfMarriageEnd',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'countryOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Marriage<em v-if="beneficiaryInfo.previousSpouse.countryOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.countryOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'countryOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'provinceOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Marriage<em v-if="beneficiaryInfo.previousSpouse.provinceOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.provinceOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'provinceOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'locationOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Marriage<em v-if="beneficiaryInfo.previousSpouse.locationOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.locationOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'locationOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'countryOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Termination<em v-if="beneficiaryInfo.previousSpouse.countryOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.countryOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'countryOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'provinceOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Termination<em v-if="beneficiaryInfo.previousSpouse.provinceOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.provinceOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'provinceOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'locationOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Termination<em v-if="beneficiaryInfo.previousSpouse.locationOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.locationOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'locationOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'marriageEndedDueTo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Marriage Ended Due To<em v-if="beneficiaryInfo.previousSpouse.marriageEndedDueTo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.marriageEndedDueTo"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'marriageEndedDueTo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'marriageEndedOtherInfo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">If, Marriage Ended<em v-if="beneficiaryInfo.previousSpouse.marriageEndedOtherInfo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.marriageEndedOtherInfo"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'marriageEndedOtherInfo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'obtainPermResidenceThroughSpouse'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Did you obtain U.S Permanent Residence Through Spouse? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.previousSpouse.obtainPermResidenceThroughSpouse"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo.previousSpouse',
                                   key: 'obtainPermResidenceThroughSpouse',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     


                     <div class="vx-col md:w-1/2 w-full mb-5" v-if="false &&showOrHideField({section: 'beneficiaryInfo.education',key: 'highestDegree'})">
                                 <div class="form_group">
                                   <div class="d-flex align-end mb-1">
                                     <label class="form_label">Highest Degree<em v-if="beneficiaryInfo.education.highestDegree">*</em></label>
                                     <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.education',key:'highestDegree'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.education',key:'highestDegree'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.education',key:'highestDegree'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.educations.highestDegree"
                                       @change="
                                         selectCheck({
                                           section: 'beneficiaryInfo.education',
                                           key: 'highestDegree',
                                         })
                                       "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                                     
                                   </div>
                                   <selectField
                                     wrapclass=""
                                     placeholder="Highest Degree"
                                     :disabled="true"
                                   />
                                 </div>
                     </div>
                     <div class="vx-col md:w-1/2 w-full" v-if="false &&showOrHideField({section: 'beneficiaryInfo.education',key: 'majorFieldOfStudy'})">
                                 <div class="form_group">
                                   <div class="d-flex align-end mb-1">
                                     <label class="form_label"
                                       >Major Field of Study<em v-if="beneficiaryInfo.education.majorFieldOfStudy">*</em></label
                                     >
                                     <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.education',key:'majorFieldOfStudy'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.education',key:'majorFieldOfStudy'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.education',key:'majorFieldOfStudy'})">
                             <vs-checkbox
                            
                             v-model="
                                         beneficiaryInfo.education.majorFieldOfStudy
                                       "
                                       @change="
                                         selectCheck({
                                           section: 'beneficiaryInfo.education',
                                           key: 'majorFieldOfStudy',
                                         })
                                       "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                                     
                                   </div>
                                   <div class="vs-con-input">
                                     <input
                                       type="text"
                                       class="vs-inputx vs-input--input normal" :disabled="true"
                                     />
                                   </div>
                                 </div>
                     </div>
                     <!---->
                  
                    
                     
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'provinceOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Province of Birth<em v-if="beneficiaryInfo.provinceOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'provinceOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfBirth'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.provinceOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'provinceOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'locationOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Birth<em v-if="beneficiaryInfo.locationOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'locationOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'locationOfBirth'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'locationOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.locationOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'locationOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'countryOfCitizenship'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label"
                             >Country of Citizenship<em v-if="beneficiaryInfo.countryOfCitizenship">*</em></label
                           >
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'countryOfCitizenship'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfCitizenship'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfCitizenship'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.countryOfCitizenship"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'countryOfCitizenship',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'enterInUSUnderCaseWaiverProgram'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Did you enter the U.S. under the Visa waiver program?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'enterInUSUnderCaseWaiverProgram'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'enterInUSUnderCaseWaiverProgram'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'enterInUSUnderCaseWaiverProgram'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.enterInUSUnderCaseWaiverProgram"
                             @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'enterInUSUnderCaseWaiverProgram',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'curNonImmigrantVisaNumber'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Current nonimmigrant visa number<em v-if="beneficiaryInfo.curNonImmigrantVisaNumber">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curNonImmigrantVisaNumber'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaNumber'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaNumber'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.curNonImmigrantVisaNumber"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'curNonImmigrantVisaNumber',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     
                    
                     
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'inspectedByAnyImmOfficer'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Were you inspected by an immigration officer?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'inspectedByAnyImmOfficer'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'inspectedByAnyImmOfficer'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'inspectedByAnyImmOfficer'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.inspectedByAnyImmOfficer"
                             @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'inspectedByAnyImmOfficer',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                     </div>

                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'issuedAnyEADFromUSCIS'})">
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">
                           Have you ever been issued an Employement Authorization Document(EAD) from the USCIS?
                         </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'issuedAnyEADFromUSCIS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'issuedAnyEADFromUSCIS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'issuedAnyEADFromUSCIS'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.issuedAnyEADFromUSCIS"
                             @change="
                             selectCheck({
                               section: 'beneficiaryInfo',
                               key: 'issuedAnyEADFromUSCIS',
                             })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false &&showOrHideField({section: 'documents',key: 'eadCard'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >Please provide a copy of the EAD CARD(S), front and  back<em v-if="documents.eadCard">*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'documents',key:'eadCard'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'eadCard'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'eadCard'})">
                             <vs-checkbox
                            
                             v-model="documents.eadCard"
                                 @change="
                                   selectCheck({
                                     section: 'documents',
                                     key: 'eadCard',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'i140PriorityDate'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Priority Date of I-140<em v-if="beneficiaryInfo.i140PriorityDate">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'i140PriorityDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'i140PriorityDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'i140PriorityDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.dateOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'i140PriorityDate',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false &&showOrHideField({section: 'beneficiaryInfo',key: 'classification'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Classificaton/Category<em v-if="beneficiaryInfo.classification">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'classification'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'classification'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'classification'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.classification"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'classification',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'hasPermResidencyInOtherCountry'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Do you hold Permanent residence in any other country? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasPermResidencyInOtherCountry'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasPermResidencyInOtherCountry'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasPermResidencyInOtherCountry'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.hasPermResidencyInOtherCountry"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'hasPermResidencyInOtherCountry',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false && showOrHideField({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Permanent Residency Country<em>*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'permResidencyCountryDetails'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.permResidencyCountryDetails"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'permResidencyCountryDetails',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'haveYouArrestedBefore'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever been arrested,cited, charged or detained for any reason by an law enforcement official? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouArrestedBefore'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBefore'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBefore'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYouArrestedBefore"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYouArrestedBefore',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'haveYouArrestedBeforeDocs'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >documents, if any<em>*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouArrestedBeforeDocs'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBeforeDocs'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouArrestedBeforeDocs'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.haveYouArrestedBeforeDocs"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'haveYouArrestedBeforeDocs',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>                  
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'everAppliedAOSInUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever applied AOS in the united states or an immigrant visa at the US Embassy/Consulate to obatain permanent resident status before? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'everAppliedAOSInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedAOSInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'everAppliedAOSInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.everAppliedAOSInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'everAppliedAOSInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'appliedAOSInUSDocs'})">
                       <div class="vx-row">
                         <div class="vx-col w-full md:w-1/2">
                           <div class="form_group">
                             <div class="d-flex align-end mb-1">
                               <label class="form_label"
                                 >documents, if any<em>*</em></label
                               >
                               <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'appliedAOSInUSDocs'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'appliedAOSInUSDocs'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'appliedAOSInUSDocs'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.appliedAOSInUSDocs"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'appliedAOSInUSDocs',
                                   })
                                 "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                               
                             </div>
                             <span
                               class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                             >
                               <img
                                 src="@/assets/images/main/file-upload.svg"
                                 class="file-icon"
                               />Upload
                               <label for="docs_i140_approval_notice"></label>
                               <input
                                 type="file"
                                 name="docs_i140_approval_notice"
                                 id="docs_i140_approval_notice"
                                 accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                 :disabled="true"
                                 />
                             </span>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverReceivedPublicAssistendeInUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever received public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverReceivedPublicAssistendeInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYouEverReceivedPublicAssistendeInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYouEverReceivedPublicAssistendeInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverlikelyReceivePublicAssistendeInUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3">Have you ever likely to receive public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)?
</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYouEverlikelyReceivePublicAssistendeInUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYouEverlikelyReceivePublicAssistendeInUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'isVisaDenieedTOUS'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever been denied a visa to the United States?</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isVisaDenieedTOUS'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.isVisaDenieedTOUS"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'isVisaDenieedTOUS',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'visaDeniedReason'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Reason<em v-if="beneficiaryInfo.visaDeniedReason">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'visaDeniedReason'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'visaDeniedReason'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'visaDeniedReason'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.visaDeniedReason"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'visaDeniedReason',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'haveYoueverPresntUnlawfully'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Have you ever been present in the united states unlawfully for more than 180 days?</a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYoueverPresntUnlawfully'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYoueverPresntUnlawfully'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYoueverPresntUnlawfully'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.haveYoueverPresntUnlawfully"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'haveYoueverPresntUnlawfully',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'presntUnlawfullyReason'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Reason<em v-if="beneficiaryInfo.presntUnlawfullyReason">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'presntUnlawfullyReason'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'presntUnlawfullyReason'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'presntUnlawfullyReason'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.presntUnlawfullyReason"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo',
                                 key: 'presntUnlawfullyReason',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     
                     <div class="vx-col w-full md:w-1/2 relative" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'I94ExpiryDate'})">
                      <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'isI94DSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box ">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container mart10" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'isI94DSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isI94DSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isI94DSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="beneficiaryInfo.isI94DSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'beneficiaryInfo',
                                     key: 'isI94DSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div> 
                      <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">I-94 Expiry Date<em v-if="beneficiaryInfo.I94ExpiryDate">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.I94ExpiryDate"
                             @change="
                               selectCheck({ section: 'beneficiaryInfo', key: 'I94ExpiryDate' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <!-- <div class="divider full-divider mb-0"></div> -->
                    </div>
                  </div>
                </vs-col>
                <vs-col
                        class="m-auto float-none"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                        vs-lg="12"
                        vs-sm="12"
                      >
                      <div class="form-container pt-10 questionnaire_hb form-container_QT">
                          <div class="vx-row">
                            <div class="vx-col w-full" >
                              <div class="form_group w-full">
                                <label class="form_label"
                                  ><h3 class="small-header">Passport</h3>
                                  <div class="IB_tooltip H1-140 QT">
                                    <span
                                      ><info-icon size="1.5x" class="custom-class"></info-icon
                                    ></span>
                                    <div class="tooltip_cnt">
                                      <p>
                                        Make sure you input the most recent passport
                                        information. Also, note that the passport must have more
                                        than 6 months validity.
                                      </p>
                                    </div>
                                  </div>
                                </label>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportNumber'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Passport Number<em v-if="beneficiaryInfo.passportNumber">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportNumber'})}">
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.passportNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'passportNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportIssuedDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Passport Issued Date<em v-if="beneficiaryInfo.passportIssuedDate">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportIssuedDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.passportIssuedDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'passportIssuedDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                      :disabled="true"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportExpiryDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Passport Expiry Date<em v-if="beneficiaryInfo.passportExpiryDate">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.passportExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'passportExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                      :disabled="true"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if=" showOrHideField({section: 'beneficiaryInfo',key: 'passportIssuedCountry'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Country of Passport Issued<em v-if="beneficiaryInfo.passportIssuedCountry">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportIssuedCountry'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedCountry'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedCountry'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.passportIssuedCountry"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'passportIssuedCountry',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="con-select w-full">
                                  <multiselect :options="[]" placeholder="Select">
                                  </multiselect>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curNonImmigrantVisaStatus'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Current Non-Immigrant Status<em v-if="beneficiaryInfo.curNonImmigrantVisaStatus">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})}">
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.curNonImmigrantVisaStatus"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'curNonImmigrantVisaStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="con-select w-full">
                                  <multiselect :options="[]" placeholder="Select" :disabled="true">
                                  </multiselect>
                                </div>
                              </div>
                            </div>
                            
                            <div class="vx-col w-full md:w-1/2 mart20" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'isDSExpiryDate'})">
                            <div class="">
                              <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                              <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                              </div>
                              <div class="check_box_container" v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'isDSExpiryDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'isDSExpiryDate'})}"  >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'isDSExpiryDate'})">
                                  <vs-checkbox
                                    
                                      v-model="beneficiaryInfo.isDSExpiryDate"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo',
                                          key: 'isDSExpiryDate',
                                        })
                                      "
                                    ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curVisaExpiryDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Current Status Expiry Date<em v-if="beneficiaryInfo.curVisaExpiryDate">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.curVisaExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'curVisaExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'maritalStatus'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Marital Status<em v-if="beneficiaryInfo.maritalStatus">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'maritalStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'maritalStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'maritalStatus'})">
                                    <vs-checkbox
                                    
                                    v-model="beneficiaryInfo.maritalStatus"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'maritalStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="con-select w-full">
                                  <multiselect :options="[]" placeholder="Select" :disabled="true">
                                  </multiselect>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'sevisNumber'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">SEVIS Number<em v-if="beneficiaryInfo.sevisNumber">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'sevisNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'sevisNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'sevisNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.sevisNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'sevisNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'eadNumber'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">EAD Number<em v-if="beneficiaryInfo.eadNumber">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'eadNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'eadNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'eadNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.eadNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'eadNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" />
                                </div>
                              </div>
                            </div>
                            
                            
                            <div class="vx-col w-full" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'addressOutsideUS'})">
                              <h3 class="small-header">
                                Address Outside the U.S <em v-if="beneficiaryInfo.addressOutsideUS">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'addressOutsideUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUS'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.addressOutsideUS"
                                  @change="
                                    selectCheck({ section: 'beneficiaryInfo', key: 'addressOutsideUS' })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="divider full-divider mb-5" v-if="false"></div>
                            <!--new address-->
                            <div class="vx-col w-full" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'addressOutsideUSMoreThanYear'})">
                              <h3 class="small-header">
                                Last Address outside Of the United States for more than one year<em>*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'addressOutsideUSMoreThanYear'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUSMoreThanYear'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'addressOutsideUSMoreThanYear'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.addressOutsideUSMoreThanYear"
                                  @change="
                                    selectCheck({ section: 'beneficiaryInfo', key: 'addressOutsideUSMoreThanYear' })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',key: 'startDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Start Date<em v-if="beneficiaryInfo.addressOutsideUSMoreThanYear.startDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'startDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'startDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'startDate'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.addressOutsideUSMoreThanYear.startDate"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',
                                              key: 'startDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',key: 'endDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">End Date<em v-if="beneficiaryInfo.addressOutsideUSMoreThanYear.endDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.addressOutsideUSMoreThanYear.endDate"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo.addressOutsideUSMoreThanYear',
                                              key: 'endDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                          </div>
                            </div>
                            <div class="divider full-divider mb-5" v-if="false"></div>
                            <div class="vx-col w-full" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'addressOfLastNYears'})">
                              <h3 class="small-header">
                                Your Residence starting with most current for the Past Five Years in the U.S and Aboard<em>*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo',key:'addressOfLastNYears'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'addressOfLastNYears'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'addressOfLastNYears'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.addressOfLastNYears"
                                  @change="
                                    selectCheck({ section: 'beneficiaryInfo', key: 'addressOfLastNYears' })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOfLastNYears',key: 'startDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Start Date<em v-if="beneficiaryInfo.addressOfLastNYears.startDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOfLastNYears',key:'startDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'startDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'startDate'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.addressOfLastNYears.startDate"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo.addressOfLastNYears',
                                              key: 'startDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.addressOfLastNYears',key: 'endDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">End Date<em v-if="beneficiaryInfo.addressOfLastNYears.endDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.addressOfLastNYears',key:'endDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'endDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.addressOfLastNYears',key:'endDate'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.addressOfLastNYears.endDate"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo.addressOfLastNYears',
                                              key: 'endDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                          </div>
                            </div>
                            <div class="divider full-divider mb-5" v-if="false" ></div>
                            <div class="vx-col w-full" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'consulateInfo'})">
                              <h3 class="small-header">
                                Consulate you want to attend the visa interview<em v-if="beneficiaryInfo.consulateInfo">*</em>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'consulateInfo'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'consulateInfo'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'consulateInfo'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.consulateInfo"
                                @change="
                                  selectCheck({
                                    section: 'beneficiaryInfo',
                                    key: 'consulateInfo',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </h3>
                            
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <!-- <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div> -->
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'hasI140ImmPetitionFiled'})">
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Has I-140 immigrant petition been filed on your behalf?<em v-if="beneficiaryInfo.hasI140ImmPetitionFiled">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasI140ImmPetitionFiled'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasI140ImmPetitionFiled'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasI140ImmPetitionFiled'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.hasI140ImmPetitionFiled"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'hasI140ImmPetitionFiled',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      
                                    </div>
                                    <div class="form_radio_btns">
                                      <vs-button class="yes mr-5" color="success" type="border">
                                        Yes</vs-button
                                      >
                                      <vs-button class="no" color="danger" type="border"
                                        >No</vs-button
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'documents',key: 'I140ApprovalNotice'})">
                              <div class="vx-row">
                                <div class="vx-col w-full md:w-1/2">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >I-140 Approval Notice, if any<em v-if="documents.I140ApprovalNotice">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'I140ApprovalNotice'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'I140ApprovalNotice'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'I140ApprovalNotice'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.I140ApprovalNotice"
                                        @change="
                                          selectCheck({
                                            section: 'documents',
                                            key: 'I140ApprovalNotice',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      
                                    </div>
                                    <span
                                      class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                    >
                                      <img
                                        src="@/assets/images/main/file-upload.svg"
                                        class="file-icon"
                                      />Upload
                                      <label for="docs_i140_approval_notice"></label>
                                      <input
                                        type="file"
                                        name="docs_i140_approval_notice"
                                        id="docs_i140_approval_notice"
                                        accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                      />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div class="vx-col w-full" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'didThisPtnrFliedImmPetitionEarlier'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Has this employer ever filed a Non-Immigrant H1B petition for you earlier?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'didThisPtnrFliedImmPetitionEarlier'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'didThisPtnrFliedImmPetitionEarlier'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'didThisPtnrFliedImmPetitionEarlier'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.didThisPtnrFliedImmPetitionEarlier"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'didThisPtnrFliedImmPetitionEarlier',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>                         
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'nonImmPetitionsInfo'})">
                              <div class="form-container form-container-v2">
                                <div class="vx-row">
                                  <div class="vx-col w-full mt-0 mb-5">
                                    <div class="d-flex">
                                        <h3 class="small-header">
                                          Non-Immigrant Petitions Information<em v-if="beneficiaryInfo.nonImmPetitionsInfo">*</em>
                                          <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'nonImmPetitionsInfo'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'nonImmPetitionsInfo'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'nonImmPetitionsInfo'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.nonImmPetitionsInfo"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo',
                                                  key: 'nonImmPetitionsInfo',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                      </div>
                                        </h3>
                                    </div>
                                    <p>List all the petitions filed till date on your behalf</p>
                                  </div>
                                  <div class="vx-col w-full">
                                    <div class="vx-row">
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Visa Status</label>
                                          </div>
                                          <selectField wrapclass="" placeholder="Visa Status" />
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Receipt Number</label>
                                          </div>
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"
                                              >Petitioner/Employer Name</label
                                            >
                                          </div>
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                          <div class="form_group mt-datepicker-wrap">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Valid From</label>
                                            </div>
                                            <div
                                              class="mx-datepicker pad5"
                                              typeable="true"
                                              name="dfdateOfBirth"
                                              data-vv-as="Date of Birth"
                                            >
                                              <div class="mx-input-wrapper">
                                                <Datepicker
                                                  format="MM/DD/YYYY"
                                                  placeholder="MM/DD/YYYY"
                                                ></Datepicker>
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group mt-datepicker-wrap">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Valid To</label>
                                          </div>
                                          <div
                                            class="mx-datepicker pad5"
                                            typeable="true"
                                            name="dfdateOfBirth"
                                            data-vv-as="Date of Birth"
                                          >
                                            <div class="mx-input-wrapper">
                                              <Datepicker
                                                format="MM/DD/YYYY"
                                                placeholder="MM/DD/YYYY"
                                              ></Datepicker>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                            </div>
                            
                            <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'haveYouEverTravelledToUS'})">
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Have you ever travelled to the United States?<em v-if="beneficiaryInfo.haveYouEverTravelledToUS">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'haveYouEverTravelledToUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverTravelledToUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'haveYouEverTravelledToUS'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.haveYouEverTravelledToUS"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'haveYouEverTravelledToUS',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      
                                    </div>
                                    <div class="form_radio_btns">
                                      <vs-button class="yes mr-5" color="success" type="border">
                                        Yes</vs-button
                                      >
                                      <vs-button class="no" color="danger" type="border"
                                        >No</vs-button
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'priorPeriodOfStayInUS'})">
                              <div class="form-container form-container-v2">
                                <div class="vx-row">
                                  <div class="vx-col w-full mt-5 mb-5">
                                    <div class="d-flex">
                                    <h3 class="small-header">Dates of Stay in USA<em v-if="beneficiaryInfo.priorPeriodOfStayInUS">*</em>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.priorPeriodOfStayInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'priorPeriodOfStayInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                    </div>
                                    </h3>
                                </div>
                                    <p>
                                      All prior periods of stay in the U.S. over the last seven
                                      years
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full prior-stay-list periods-nowrap">
                                <div class="vx-row delete-row">
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Visa Status</label>
                                      </div>
                                      <selectField wrapclass="" placeholder="Visa Status" />
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Date Entered</label>
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="mx-input-wrapper">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Date Departed</label>
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  
                                </div>
                              </div>
                            
                            </div>
                            <template v-if="false">
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'anyImmPetitionFiled'})">
                            <div class="d-flex align-center">
                              <a class="switch-label mr-3">
                                Has any immigrant Visa petition (PERM, I-140, I-485) ever been filed on your behalf?
                              </a>
                              <vs-switch>
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                              </vs-switch>
                              <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiled'})">
                                  <vs-checkbox
                                  
                                  v-model="beneficiaryInfo.anyImmPetitionFiled"
                                  @change="
                                  selectCheck({
                                    section: 'beneficiaryInfo',
                                    key: 'anyImmPetitionFiled',
                                  })
                                "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'anyImmPetitionFiledDesc'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Immigrant Visa Petition Details<em v-if="beneficiaryInfo.anyImmPetitionFiledDesc">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'anyImmPetitionFiledDesc'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiledDesc'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'anyImmPetitionFiledDesc'})">
                                    <vs-checkbox
                                    
                                    v-model="beneficiaryInfo.anyImmPetitionFiledDesc"
                                      @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'anyImmPetitionFiledDesc',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <div class="vs-con-textarea w-full vs-textarea-primary">
                                  <textarea class="vs-textarea"></textarea>
                                </div>
                              </div>
                            </div>
                              <div class="vx-col w-full">
                                <h3 class="small-header" v-if=" showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyOtherAlienFiled'}) ||
                                showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedDate'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'employerName'}) ||
                                showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'rirOrRegularProcessing'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedStateId'}) ||
                                showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'applCurStatus'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'seekingFiledDateforETA750'}) || 
                                showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyI140Filed'}) ||  showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'fieldDate'}) || 
                                showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'employerName'}) ||  showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'priorityDate'}) || 
                                showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'currentStatus'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'eb2orEb3'}) 

                                ">
                                  Immigrant Petition Information<em v-if="beneficiaryInfo.h1bImmPetitionsInfo">*</em>
                                  <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'h1bImmPetitionsInfo'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'h1bImmPetitionsInfo'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'h1bImmPetitionsInfo'})">
                                            <vs-checkbox
                                          
                                            v-model="beneficiaryInfo.h1bImmPetitionsInfo"
                                              @change="
                                                selectCheck({
                                                  section: 'beneficiaryInfo',
                                                  key: 'h1bImmPetitionsInfo',
                                                })
                                              "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                      </div>
                                </h3>
                              </div>
                              <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'h1bImmPetitionsInfo'})">
                                  <p>List all the petitions filed till date on your behalf</p>
                                  <div class="vx-col w-full">
                                    <div class="vx-row">
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Petition Type</label>
                                          </div>
                                          <selectField wrapclass="" placeholder="Petition Type" />
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Receipt Number</label>
                                          </div>
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"
                                              >Petitioner/Employer Name</label
                                            >
                                          </div>
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                          <div class="form_group mt-datepicker-wrap">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label">Valid From</label>
                                            </div>
                                            <div
                                              class="mx-datepicker pad5"
                                              typeable="true"
                                              name="dfdateOfBirth"
                                              data-vv-as="Date of Birth"
                                            >
                                              <div class="mx-input-wrapper">
                                                <Datepicker
                                                  format="MM/DD/YYYY"
                                                  placeholder="MM/DD/YYYY"
                                                ></Datepicker>
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                      <div class="vx-col md:w-1/3 w-full">
                                        <div class="form_group mt-datepicker-wrap">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Valid To</label>
                                          </div>
                                          <div
                                            class="mx-datepicker pad5"
                                            typeable="true"
                                            name="dfdateOfBirth"
                                            data-vv-as="Date of Birth"
                                          >
                                            <div class="mx-input-wrapper">
                                              <Datepicker
                                                format="MM/DD/YYYY"
                                                placeholder="MM/DD/YYYY"
                                              ></Datepicker>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      
                                    </div>
                                  </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyOtherAlienFiled'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Has any other Alien Employment Certification, a.k.a Labor Certification been filed on your behalf?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.anyOtherAlienFiled"
                                    @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.immPetitionInfo',
                                      key: 'anyImmPetitionFiled',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Date Filed<em v-if="beneficiaryInfo.immPetitionInfo.filedDate">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.filedDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.immPetitionInfo',
                                        key: 'filedDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'employerName'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Name of the Employer<em v-if="beneficiaryInfo.immPetitionInfo.employerName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.employerName"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo.immPetitionInfo', key: 'employerName' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" />
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'rirOrRegularProcessing'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  RIR or Regular Processing
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.rirOrRegularProcessing"
                                    @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.immPetitionInfo',
                                      key: 'rirOrRegularProcessing',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedStateId'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">State where it was filed<em v-if="beneficiaryInfo.immPetitionInfo.filedStateId">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.filedStateId"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.immPetitionInfo',
                                        key: 'filedStateId',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="con-select w-full">
                                  <multiselect :options="[]" placeholder="Select">
                                  </multiselect>
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'applCurStatus'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Current Status of the Application<em v-if="beneficiaryInfo.immPetitionInfo.applCurStatus">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.applCurStatus"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo.immPetitionInfo', key: 'applCurStatus' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" />
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'seekingFiledDateforETA750'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Are you seeking to utilize the filing date from a previously submitted Application for Alien Employment Certification (ETA 750)?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.seekingFiledDateforETA750"
                                    @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.immPetitionInfo',
                                      key: 'seekingFiledDateforETA750',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyI140Filed'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Has any I-140 Petition been filed on your behalf? any I-140 filed on your behalf?
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'anyI140Filed'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyI140Filed'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyI140Filed'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.anyI140Filed"
                                    @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.immPetitionInfo',
                                      key: 'anyI140Filed',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'fieldDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Date Filed<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.fieldDate">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'fieldDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'fieldDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'fieldDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.i140Info.fieldDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.immPetitionInfo.i140Info',
                                        key: 'fieldDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'employerName'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Name of the Employer<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.employerName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'employerName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'employerName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'employerName'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.i140Info.employerName"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo.immPetitionInfo.i140Info', key: 'employerName' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" />
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'priorityDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Priority Date<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.priorityDate">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'priorityDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'priorityDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'priorityDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.i140Info.priorityDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.immPetitionInfo.i140Info',
                                        key: 'priorityDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'currentStatus'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Current Status of the I-140<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.currentStatus">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'currentStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'currentStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'currentStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.i140Info.currentStatus"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo.immPetitionInfo.i140Info', key: 'currentStatus' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" />
                                </div>
                              </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo.i140Info',key: 'eb2orEb3'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">EB2/EB3<em v-if="beneficiaryInfo.immPetitionInfo.i140Info.eb2orEb3">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'eb2orEb3'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'eb2orEb3'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo.i140Info',key:'eb2orEb3'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.immPetitionInfo.i140Info.eb2orEb3"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo.immPetitionInfo.i140Info', key: 'eb2orEb3' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <div class="vs-con-input">
                                  <input type="text" class="vs-inputx vs-input--input normal" />
                                </div>
                              </div>
                              </div>
                            </template>
                            
                              <div class="vx-col w-full mb-10" v-if="false &&  showOrHideField({section: 'beneficiaryInfo',key: 'hasApprovedI140'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  Approved I-140 (from any employer that has not been revoked within 180 days of its approval)
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasApprovedI140'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasApprovedI140'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasApprovedI140'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.hasApprovedI140"
                                    @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'hasApprovedI140',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="false && showOrHideField({section: 'beneficiaryInfo',key: 'hasPermPendingForMorethan365Days'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3">
                                  PERM application pending for more than 365 days
                                </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasPermPendingForMorethan365Days'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasPermPendingForMorethan365Days'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasPermPendingForMorethan365Days'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.hasPermPendingForMorethan365Days"
                                    @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'hasPermPendingForMorethan365Days',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </div>
                              </div>
                          </div>
                        </div>
                </vs-col>
                <template v-if="false">
                     <vs-col class="w-full p-0 mt-5">
                        <vs-alert
                        color="warning"
                        class="warning-alert top-warning-alert"
                        icon-pack="IntakePortal"
                        icon="IP-information-button"
                        active="true"
                        >
                          All associations and groups of which you are or have been a member, including political organizations, if you do not belong to any organizations, please write "None".
                        </vs-alert>
                     </vs-col>
                      <vs-col
                        class="m-auto float-none"
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                        vs-lg="12"
                        vs-sm="12"
                      >
                      <div class="form-container pt-10 form-container_QT">
                        <h3 class="small-header">ASSOCIATIONS/GROUPS
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'associations'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'associations'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'associations'})">
                              <vs-checkbox
                                  v-model="
                                beneficiaryInfo.associations.associations
                              "
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo.associations',
                                  key: 'associations',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </h3>
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <div class="form-container alt-rows-bg questionnaire_hb">
                                      <div class="vx-row">
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'name'})">
                                            <div class="form_group mt-datepicker-wrap">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">Name of the associations and groups<em v-if="beneficiaryInfo.associations.name">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'name'})">
                                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'name'})}">
                                                              <span class="checkmark" >
                                                                <i class="material-icons">check</i>
                                                              </span>
                                                            </span>
                                                            <div class="tooltip_cnt">
                                                              <p>Field is required</p>
                                                            </div>
                                                        </div>
                                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'name'})">
                                                          <vs-checkbox
                                    
                                                                v-model="beneficiaryInfo.associations.name"
                                                                @change="
                                                                  selectCheck({
                                                                    section: 'beneficiaryInfo.associations',
                                                                    key: 'name',
                                                                  })
                                                                "
                                                            ></vs-checkbox>
                                                            <div class="tooltip_cnt">
                                                              <p>Validation is required</p>
                                                            </div>
                                                        </div>
                                                  </div>
                                                </div>
                                                <div class="vs-con-input">
                                                    <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                                                </div>
                                            </div>
                                        </div>    
                                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'startDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Start Date<em v-if="beneficiaryInfo.associations.startDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'startDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'startDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'startDate'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.associations.startDate"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo.associations',
                                              key: 'startDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                            :disabled="true"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                        </div>                                 
                                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'endDate'})">
                                    <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">End Date<em v-if="beneficiaryInfo.associations.endDate">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'endDate'})">
                                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'endDate'})}" >
                                                <span class="checkmark" >
                                                  <i class="material-icons">check</i>
                                                </span>
                                              </span>
                                              <div class="tooltip_cnt">
                                                <p>Field is required</p>
                                              </div>
                                            </div>
                                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'endDate'})">
                                              <vs-checkbox
                                            
                                              v-model="beneficiaryInfo.associations.endDate"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo.associations',
                                              key: 'endDate',
                                            })
                                          "
                                              ></vs-checkbox>
                                              <div class="tooltip_cnt">
                                                <p>Validation is required</p>
                                              </div>
                                            </div>
                                            </div>
                                        
                                      </div>
                                      <div
                                        class="mx-datepicker pad5"
                                        typeable="true"
                                        name="dfdateOfBirth"
                                        data-vv-as="Date of Birth"
                                      >
                                        <div class="vs-con-input">
                                          <Datepicker
                                            format="MM/DD/YYYY"
                                            placeholder="MM/DD/YYYY"
                                            :disabled="true"
                                          ></Datepicker>
                                        </div>
                                      </div>
                                    </div>
                                        </div>                                 
                                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'natureofAssociations'})">
                                            <div class="form_group mt-datepicker-wrap">
                                                <div class="d-flex align-end mb-1">
                                                  <label class="form_label">Nature of associations and groups<em v-if="beneficiaryInfo.associations.natureofAssociations">*</em></label>
                                                  <div class="check_box_container"  v-if="isEdit">
                                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'natureofAssociations'})">
                                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'natureofAssociations'})}">
                                                              <span class="checkmark" >
                                                                <i class="material-icons">check</i>
                                                              </span>
                                                            </span>
                                                            <div class="tooltip_cnt">
                                                              <p>Field is required</p>
                                                            </div>
                                                        </div>
                                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'natureofAssociations'})">
                                                          <vs-checkbox
                                    
                                                                v-model="beneficiaryInfo.associations.natureofAssociations"
                                                                @change="
                                                                  selectCheck({
                                                                    section: 'beneficiaryInfo.associations',
                                                                    key: 'natureofAssociations',
                                                                  })
                                                                "
                                                            ></vs-checkbox>
                                                            <div class="tooltip_cnt">
                                                              <p>Validation is required</p>
                                                            </div>
                                                        </div>
                                                  </div>
                                                </div>
                                                <div class="vs-con-input">
                                                    <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                                                </div>
                                            </div>
                                        </div>             
                                        <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.associations',key: 'address'})">
                              <h3 class="small-header">
                              Address<em v-if="beneficiaryInfo.associations.address">*</em>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.associations',key:'address'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.associations',key:'address'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.associations',key:'address'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.associations.address"
                                @change="
                                  selectCheck({
                                    section: 'beneficiaryInfo.associations',
                                    key: 'address',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              </h3>
                            
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                        :disabled="true"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                        :disabled="true"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                        :disabled="true"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                                        </div>                 
                                        
                                </div>

                                </div>
                              </div>

                          </div>
                      </div>
                      </vs-col>
                     
                </template>
              </form>
            </div>
            <!--Educations-->
            <div v-if="currentTab=='Educational Info' && false">
              <form>
               
                <div class="vx-col w-full mb-5 mt-5" style="padding-left:50px;" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasMasterDegreeInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you have Masters degree in United States?<em v-if="beneficiaryInfo.hasMasterDegreeInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasMasterDegreeInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasMasterDegreeInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasMasterDegreeInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.hasMasterDegreeInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'hasMasterDegreeInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    After your 12th grade – Starting from the most recent degree first
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                    <h3 class="small-header">Education Information 
                      
                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'educations'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'educations'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'educations'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.educations"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'educations',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                    </h3>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="form-container questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col w-full">
                              <div class="vx-row delete-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'name'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >University/College/School Name<em v-if="beneficiaryInfo.educations.name">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'name'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'name'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'name'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.name"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'name',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                                      </div>
                                      
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full mb-5" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'highestDegree'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Highest Degree<em v-if="beneficiaryInfo.educations.highestDegree">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'highestDegree'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'highestDegree'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'highestDegree'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.highestDegree"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'highestDegree',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                      
                                    </div>
                                    <selectField
                                      wrapclass=""
                                      placeholder="Highest Degree"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'majorFieldOfStudy'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Major Field of Study<em v-if="beneficiaryInfo.educations.majorFieldOfStudy">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})">
                              <vs-checkbox
                             
                              v-model="
                                          beneficiaryInfo.educations.majorFieldOfStudy
                                        "
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'majorFieldOfStudy',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                      
                                    </div>
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'graduatedYear'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Year of Graduation<em v-if="beneficiaryInfo.educations.graduatedYear">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'graduatedYear'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedYear'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedYear'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.educations.graduatedYear"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'graduatedYear',
                                          })
                                        "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                      
                                    </div>
                                    <selectField
                                      wrapclass=""
                                      placeholder="Highest Degree"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'attendedFrom'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Course Started On<em v-if="beneficiaryInfo.educations.attendedFrom">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'attendedFrom'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedFrom'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedFrom'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.attendedFrom"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'attendedFrom',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'attendedTo'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Course Completed On<em v-if="beneficiaryInfo.educations.attendedTo">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'attendedTo'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedTo'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedTo'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.attendedTo"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'attendedTo',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'graduatedDate'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Date of Graduation<em v-if="beneficiaryInfo.educations.graduatedDate">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'graduatedDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.graduatedDate"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'graduatedDate',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'address'})">
                                  <h3 class="small-header">
                                    University/College/School Address<em v-if="beneficiaryInfo.educations.address">*</em>
                                    <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'address'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'address'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.address"
                                      @change="
                                        selectCheck({
                                          section: 'beneficiaryInfo.educations',
                                          key: 'address',
                                        })
                                      "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                    
                                  </h3>

                                  <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Street Address</label>
                                        </div>
                                        <vs-input
                                          class="w-full"
                                          v-validate="'required'"
                                          data-vv-as="Street Address"
                                        />
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Apt, Suite</label>
                                        </div>
                                        <div class="address-suite">
                                          <ul
                                            class="demo-alignment custom-radio"
                                            vs-type="flex"
                                            vs-align="center"
                                          >
                                            <li>
                                              <vs-checkbox name="aptType1"
                                                >Apt</vs-checkbox
                                              >
                                            </li>
                                            <li>
                                              <vs-checkbox name="aptType2"
                                                >Ste</vs-checkbox
                                              >
                                            </li>
                                            <li>
                                              <vs-checkbox name="aptType3"
                                                >Flr</vs-checkbox
                                              >
                                            </li>
                                          </ul>
                                          <vs-input class="" data-vv-as="Apt, Suite" />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="con-select w-full select-large">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Country</label>
                                          </div>
                                          <multiselect
                                            name="Status"
                                            :multiple="false"
                                            :options="[]"
                                            :hideSelected="true"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Select Country"
                                            :preselect-first="false"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="con-select w-full select-large">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"> State</label>
                                          </div>
                                          <multiselect
                                            name="Status"
                                            :multiple="false"
                                            :options="[]"
                                            :hideSelected="true"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Select State"
                                            :preselect-first="false"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="con-select w-full select-large">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"> City</label>
                                          </div>

                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select City"
                                              :preselect-first="false"
                                            />
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col md:w-1/2 w-full">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label for class="form_label">Zip Code</label>
                                        </div>
                                        <vs-input class="w-full" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'isAccredited'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Accredited at the time of your
                                        graduation?<em v-if="beneficiaryInfo.educations.isAccredited">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'isAccredited'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'isAccredited'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'isAccredited'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.isAccredited"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'isAccredited',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'isForProfit'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Profit University?<em v-if="beneficiaryInfo.educations.isForProfit">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'isForProfit'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'isForProfit'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'isForProfit'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.educations.isForProfit"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'isForProfit',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                      
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                               <!-- <div class="delete">
                                  <a>
                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                  </a>
                                </div> -->
                              </div>
                            </div>
                          </div>
                          <div
                            class="m-auto"
                            vs-type="flex"
                            vs-align="center"
                            vs-lg="2"
                            vs-sm="2"
                          >
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!--employment-->
            <div v-if="currentTab=='Employement Info' && false">
              
              <form
                data-vv-scope="employmentform"
                @submit.prevent=""
                @keydown.enter.prevent=""
              >
             
              <div class="vx-col w-full mb-5 mt-5" style="padding-left:50px" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'anyOtherPersonEmployedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed?<em v-if="beneficiaryInfo.anyOtherPersonEmployedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'anyOtherPersonEmployedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'anyOtherPersonEmployedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'anyOtherPersonEmployedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.anyOtherPersonEmployedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'anyOtherPersonEmployedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Please write the following information about your current and past employment for the past five years in the U.S and aboard starting with your most current Job.
                  </vs-alert>
                </vs-col>
                
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Employment 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          beneficiaryInfo.prevEmploymentInfo.prevEmploymentInfo
                        "
                        @change="
                          selectCheck({
                            section: 'beneficiaryInfo.prevEmploymentInfo',
                            key: 'prevEmploymentInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'employerName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Employer Name<em v-if="beneficiaryInfo.prevEmploymentInfo.employerName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      beneficiaryInfo.prevEmploymentInfo.employerName
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'employerName',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'currentEmployer'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3"> Current Employer? </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                        <vs-checkbox
                                      
                                        v-model=" 
                                    beneficiaryInfo.prevEmploymentInfo.currentEmployer
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.prevEmploymentInfo',
                                      key: 'currentEmployer',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                            </div>
                            
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobTitle'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Job Title<em v-if="beneficiaryInfo.prevEmploymentInfo.jobTitle">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.jobTitle"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'jobTitle',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'businessType'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Employer Business E.g., IT<em v-if="beneficiaryInfo.prevEmploymentInfo.businessType">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      beneficiaryInfo.prevEmploymentInfo.businessType
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'businessType',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Salary<em v-if="beneficiaryInfo.prevEmploymentInfo.salary">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.salary"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Pay Frequency<em v-if="beneficiaryInfo.prevEmploymentInfo.payFrequency">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.payFrequency"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobDuties'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Description of Duties Performed<em v-if="beneficiaryInfo.prevEmploymentInfo.jobDuties">*</em>
                                    <div class="IB_tooltip H1-140">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Please fill in your Job Duties only.Avoid
                                          inserting all project details.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.jobDuties"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'jobDuties',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-textarea w-full vs-textarea-primary">
                                  <textarea class="vs-textarea"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="beneficiaryInfo.prevEmploymentInfo.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="beneficiaryInfo.prevEmploymentInfo.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'address'})">
                              <h3 class="small-header">
                                Work Address<em v-if="beneficiaryInfo.prevEmploymentInfo.address">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.address"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo.prevEmploymentInfo',

                                      key: 'address',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                
                <vs-col class="w-full p-0 mt-6">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Last Employer outside of the United States for more than one year.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Employment Outside US
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <vs-checkbox
                          
                            v-model="
                          beneficiaryInfo.prevEmploymentOutsideUS.prevEmploymentOutsideUS
                        "
                        @change="
                          selectCheck({
                            section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                            key: 'prevEmploymentOutsideUS',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">

<div class="vx-col w-full">
  <div class="form-container alt-rows-bg questionnaire_hb">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'employerName'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Employer Name<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.employerName">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'employerName'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'employerName'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'employerName'})">
                  <vs-checkbox
                
                  v-model="
                beneficiaryInfo.prevEmploymentOutsideUS.employerName
              "
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'employerName',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'currentEmployer'})">
        <div class="d-flex align-center">
          <a class="switch-label mr-3"> Current Employer? </a>
          <vs-switch>
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'currentEmployer'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <vs-checkbox
                
                  v-model=" 
              beneficiaryInfo.prevEmploymentOutsideUS.currentEmployer
            "
            @change="
              selectCheck({
                section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                key: 'currentEmployer',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </div>
      </div>
      
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'jobTitle'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Job Title<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.jobTitle">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobTitle'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.jobTitle"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'jobTitle',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'businessType'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label"
              >Employer Business E.g., IT<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.businessType">*</em></label
            >
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'businessType'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'businessType'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'businessType'})">
                  <vs-checkbox
                
                  v-model="
                beneficiaryInfo.prevEmploymentOutsideUS.businessType
              "
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'businessType',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Salary<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.salary">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentOutsideUS.salary"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Pay Frequency<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.payFrequency">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentOutsideUS.payFrequency"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'jobDuties'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label class="form_label"
              >Description of Duties Performed<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.jobDuties">*</em>
              <div class="IB_tooltip H1-140">
                <span
                  ><info-icon
                    size="1.5x"
                    class="custom-class"
                  ></info-icon
                ></span>
                <div class="tooltip_cnt">
                  <p>
                    Please fill in your Job Duties only.Avoid
                    inserting all project details.
                  </p>
                </div>
              </div>
            </label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobDuties'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.jobDuties"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'jobDuties',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-textarea w-full vs-textarea-primary">
            <textarea class="vs-textarea"></textarea>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'startDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">Start Date<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.startDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'startDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'startDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'startDate'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.startDate"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'startDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'endDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">End Date<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.endDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'endDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'endDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'endDate'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.endDate"
              @change="
                selectCheck({
                  section: 'beneficiaryInfo.prevEmploymentOutsideUS',
                  key: 'endDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <!--   

       -->
      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentOutsideUS',key: 'address'})">
        <h3 class="small-header">
          Work Address<em v-if="beneficiaryInfo.prevEmploymentOutsideUS.address">*</em>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'address'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'address'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentOutsideUS',key:'address'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.address"
            @change="
              selectCheck({
                section: 'beneficiaryInfo.prevEmploymentOutsideUS',

                key: 'address',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </h3>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Street Address</label>
              </div>
              <vs-input
                class="w-full"
                v-validate="'required'"
                data-vv-as="Street Address"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Apt, Suite</label>
              </div>
              <div class="address-suite">
                <ul
                  class="demo-alignment custom-radio"
                  vs-type="flex"
                  vs-align="center"
                >
                  <li>
                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                  </li>
                </ul>
                <vs-input class="" data-vv-as="Apt, Suite" />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label">Country</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Country"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> State</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select State"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> City</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select City"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label for class="form_label">Zip Code</label>
              </div>
              <vs-input class="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
                  </div>
                </vs-col>
              </form>
            </div>
            
            <!--Parents Info-->
            <div v-if="currentTab=='Parents Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    Provide your father details, starting from
                    the most recent first.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Father Information 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'fatherInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'fatherInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'fatherInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          fatherInfo.fatherInfo
                        "
                        @change="
                          selectCheck({
                            section: 'fatherInfo',
                            key: 'fatherInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="fatherInfo.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="fatherInfo.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="fatherInfo.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'fatherInfo',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo',key: 'otherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'otherNames'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'otherNames'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'otherNames'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.otherNames"
                            @change="
                              selectCheck({
                                section: 'fatherInfo',
                                key: 'otherNames',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                            </div>
                            <div class="vx-col w-full">
                                <div class="form_group w-full">
                                  <label class="form_label"
                                    ><h3 class="small-header">Name at Birth</h3>
                                  </label>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo.nameAtBirth',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="fatherInfo.nameAtBirth.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo.nameAtBirth',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.nameAtBirth.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo.nameAtBirth',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo.nameAtBirth',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="fatherInfo.nameAtBirth.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo.nameAtBirth',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.nameAtBirth.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo.nameAtBirth',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo.nameAtBirth',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="fatherInfo.nameAtBirth.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'fatherInfo.nameAtBirth',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo.nameAtBirth',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="fatherInfo.nameAtBirth.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'fatherInfo.nameAtBirth',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'dateOfBirth'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date of Birth<em v-if="fatherInfo.dateOfBirth">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'dateOfBirth'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'dateOfBirth'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'dateOfBirth'})">
                                        <vs-checkbox
                                      
                                        v-model="fatherInfo.dateOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'dateOfBirth',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'countryOfBirth'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'fatherInfo',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'provinceOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'provinceOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'provinceOfBirth'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'fatherInfo',
                                  key: 'provinceOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'locationOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'locationOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'locationOfBirth'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.locationOfBirth"
                              @change="
                                selectCheck({ section: 'fatherInfo', key: 'locationOfBirth' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'fatherInfo',key: 'deceasedCity'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Deceased City<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'deceasedCity'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'deceasedCity'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'deceasedCity'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.deceasedCity"
                              @change="
                                selectCheck({
                                  section: 'fatherInfo',
                                  key: 'deceasedCity',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'deceasedDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Deceased Date<em v-if="fatherInfo.deceasedDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'deceasedDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'deceasedDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'deceasedDate'})">
                                        <vs-checkbox
                                      
                                        v-model="fatherInfo.deceasedDate"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'deceasedDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'fatherInfo',key: 'isUSCitizen'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Is your father now or was he ever a U.S. citizen?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'isUSCitizen'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'isUSCitizen'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'isUSCitizen'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.isUSCitizen"
                              @change="
                              selectCheck({
                                section: 'fatherInfo',
                                key: 'isUSCitizen',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'dateFromUSCitizen'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> Dates from US citizen<em v-if="fatherInfo.dateFromUSCitizen">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'fatherInfo',key:'dateFromUSCitizen'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'dateFromUSCitizen'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'dateFromUSCitizen'})">
                                        <vs-checkbox
                                      
                                        v-model="fatherInfo.dateFromUSCitizen"
                                    @change="
                                      selectCheck({
                                        section: 'fatherInfo',
                                        key: 'dateFromUSCitizen',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                          <div class="vx-col w-full" v-if="showOrHideField({section: 'fatherInfo',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Residence  <em v-if="currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'fatherInfo',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'fatherInfo',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'fatherInfo',key:'currentAddress'})">
                              <vs-checkbox
                             
                              v-model="fatherInfo.currentAddress"
                            @change="
                              selectCheck({ section: 'fatherInfo', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                 <vs-col class="w-full p-0 mt-5">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    Provide your mother details, starting from
                    the most recent first.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Mother Information 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'motherInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'motherInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'motherInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          motherInfo.motherInfo
                        "
                        @change="
                          selectCheck({
                            section: 'motherInfo',
                            key: 'motherInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="motherInfo.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="motherInfo.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="motherInfo.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'motherInfo',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo',key: 'otherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'otherNames'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'otherNames'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'otherNames'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.otherNames"
                            @change="
                              selectCheck({
                                section: 'motherInfo',
                                key: 'otherNames',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                            </div>
                            <div class="vx-col w-full">
                                <div class="form_group w-full">
                                  <label class="form_label"
                                    ><h3 class="small-header">Name at Birth</h3>
                                  </label>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo.nameAtBirth',key: 'firstName'})">
                              <div class="vx-input-group flex form-input-group FML">
                                <div class="vx-input-group-default flex-grow">
                                  <div class="vx-col w-full md:w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">First Name<em v-if="motherInfo.nameAtBirth.firstName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo.nameAtBirth',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo.nameAtBirth',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo.nameAtBirth',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.nameAtBirth.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo.nameAtBirth',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>

                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo.nameAtBirth',key: 'middleName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Middle Name<em v-if="motherInfo.nameAtBirth.middleName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo.nameAtBirth',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo.nameAtBirth',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo.nameAtBirth',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.nameAtBirth.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo.nameAtBirth',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo.nameAtBirth',key: 'lastName'})">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Last Name<em v-if="motherInfo.nameAtBirth.lastName">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'motherInfo.nameAtBirth',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo.nameAtBirth',key:'lastName'})}"  >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo.nameAtBirth',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="motherInfo.nameAtBirth.lastName"
                                          @change="
                                            selectCheck({
                                              section: 'motherInfo.nameAtBirth',
                                              key: 'lastName',
                                            })
                                          "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                      </div>
                                      <div class="vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                          <input
                                            type="text"
                                            maxlength="200"
                                            class="vs-inputx vs-input--input normal"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'motherInfo',key: 'dateOfBirth'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date of Birth<em v-if="motherInfo.dateOfBirth">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'dateOfBirth'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'dateOfBirth'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'dateOfBirth'})">
                                        <vs-checkbox
                                      
                                        v-model="motherInfo.dateOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'dateOfBirth',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'countryOfBirth'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'motherInfo',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'provinceOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'provinceOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'provinceOfBirth'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'motherInfo',
                                  key: 'provinceOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'locationOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'locationOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'locationOfBirth'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.locationOfBirth"
                              @change="
                                selectCheck({ section: 'motherInfo', key: 'locationOfBirth' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'motherInfo',key: 'deceasedCity'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Deceased City<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'deceasedCity'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'deceasedCity'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'deceasedCity'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.deceasedCity"
                              @change="
                                selectCheck({
                                  section: 'motherInfo',
                                  key: 'deceasedCity',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'motherInfo',key: 'deceasedDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Deceased Date<em v-if="motherInfo.deceasedDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'deceasedDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'deceasedDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'deceasedDate'})">
                                        <vs-checkbox
                                      
                                        v-model="motherInfo.deceasedDate"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'deceasedDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'motherInfo',key: 'isUSCitizen'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Is your mother now or was she ever a U.S. citizen?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'isUSCitizen'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'isUSCitizen'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'isUSCitizen'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.isUSCitizen"
                              @change="
                              selectCheck({
                                section: 'motherInfo',
                                key: 'isUSCitizen',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'motherInfo',key: 'dateFromUSCitizen'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> Dates from US citizen<em v-if="motherInfo.dateFromUSCitizen">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'motherInfo',key:'dateFromUSCitizen'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'dateFromUSCitizen'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'dateFromUSCitizen'})">
                                        <vs-checkbox
                                      
                                        v-model="motherInfo.dateFromUSCitizen"
                                    @change="
                                      selectCheck({
                                        section: 'motherInfo',
                                        key: 'dateFromUSCitizen',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                        </div>
                          <div class="vx-col w-full" v-if="showOrHideField({section: 'motherInfo',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address <em v-if="address">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'motherInfo',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'motherInfo',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'motherInfo',key:'currentAddress'})">
                              <vs-checkbox
                             
                              v-model="motherInfo.currentAddress"
                            @change="
                              selectCheck({ section: 'motherInfo', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                          </div>
                          

                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col> 
              </form>
              
            </div>
            <!-- documents-->
            <div v-if="currentTab=='Documents Info'">
              <form>
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <h3 class="small-header">
                          List of documents needs to be updated
                          <span class="file-type">
                            (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                          </span>
                        </h3>
                        <label>Beneficiary Documents </label>
                        <div class="documents_group case_documents">
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'proofOfCurrentStatus'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Proof of Current Status<em v-if="documents.proofOfCurrentStatus">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'proofOfCurrentStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'proofOfCurrentStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'proofOfCurrentStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.proofOfCurrentStatus"
                                    @change="
                                      selectCheck({
                                        section: 'documents',

                                        key: 'proofOfCurrentStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'copyOfExistingVisa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Copy of Existing H4<em v-if="documents.copyOfExistingVisa">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'copyOfExistingVisa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'copyOfExistingVisa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'copyOfExistingVisa'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.copyOfExistingVisa"
                                    @change="
                                      selectCheck({
                                        section: 'documents',

                                        key: 'copyOfExistingVisa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'copyOfExistingL2Visa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Copy of Existing L2<em v-if="documents.copyOfExistingL2Visa">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'copyOfExistingL2Visa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'copyOfExistingL2Visa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'copyOfExistingL2Visa'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.copyOfExistingL2Visa"
                                    @change="
                                      selectCheck({
                                        section: 'documents',

                                        key: 'copyOfExistingL2Visa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'approvalCopyOfI140'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">{{'approvalCopyOfI140' | formatdoctype }}<em v-if="documents.approvalCopyOfI140">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'approvalCopyOfI140'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'approvalCopyOfI140'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'approvalCopyOfI140'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.approvalCopyOfI140"
                                    @change="
                                      selectCheck({
                                        section: 'documents',

                                        key: 'approvalCopyOfI140',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                          </div> 
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'priorH4Approvals'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">All prior H4 approvals, if any <em v-if="documents.priorH4Approvals">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'priorH4Approvals'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'priorH4Approvals'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'priorH4Approvals'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.priorH4Approvals"
                                    @change="
                                      selectCheck({
                                        section: 'documents',

                                        key: 'priorH4Approvals',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'priorL2Approvals'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">All prior L2 approvals, if any <em v-if="documents.priorL2Approvals">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'priorL2Approvals'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'priorL2Approvals'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'priorL2Approvals'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.priorL2Approvals"
                                    @change="
                                      selectCheck({
                                        section: 'documents',

                                        key: 'priorL2Approvals',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'usVisa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">US Visa<em v-if="documents.usVisa">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'usVisa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'usVisa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'usVisa'})">
                                    <vs-checkbox
                                  
                                    v-model="documents.usVisa"
                                    @change="
                                      selectCheck({
                                        section: 'documents',

                                        key: 'usVisa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'passport'})">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"
                                      >Passport<em v-if="documents.passport">*</em></label
                                    >
                                    <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'documents',key:'passport'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'passport'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'passport'})">
                                            <vs-checkbox
                                          
                                            v-model="documents.passport"
                                      @change="
                                        selectCheck({
                                          section: 'documents',
                                          key: 'passport',
                                        })
                                      "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                    
                                  </div>
                                  <span
                                    class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                  >
                                    <img
                                      src="@/assets/images/main/file-upload.svg"
                                      class="file-icon"
                                    />Upload
                                    <input
                                      type="file"
                                      name="false"
                                      id="null"
                                      accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    />
                                  </span>
                                </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'mostRecentI94'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Most recent I-94<em v-if="documents.mostRecentI94">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'mostRecentI94'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'mostRecentI94'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'mostRecentI94'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.mostRecentI94"
                                  @change="
                                    selectCheck({
                                      section: 'documents',
                                      key: 'mostRecentI94',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'eadCard'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Prior EAD Cards, if any <em v-if="documents.eadCard">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'eadCard'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'eadCard'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'eadCard'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.eadCard"
                                  @change="
                                    selectCheck({ section: 'documents', key: 'eadCard' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'ssnCard'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >SSN Card, if any <em v-if="documents.ssnCard">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'ssnCard'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'ssnCard'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'ssnCard'})">
                                        <vs-checkbox
                                      
                                        v-model="documents.ssnCard"
                                  @change="
                                    selectCheck({ section: 'documents', key: 'ssnCard' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'marriageCertificate'})">
                            <div class="form_group">
                            <div class="d-flex align-end mb-1">
                            <label class="form_label"
                            > Marriage Certificate <em v-if="documents.marriageCertificate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'documents',key:'marriageCertificate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'marriageCertificate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'marriageCertificate'})">
                              <vs-checkbox

                              v-model="documents.marriageCertificate"
                            @change="
                            selectCheck({
                            section: 'documents',
                            key: 'marriageCertificate',
                            })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>

                            </div>
                            <span
                            class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                            >
                            <img
                            src="@/assets/images/main/file-upload.svg"
                            class="file-icon"
                            />Upload
                            <input
                            type="file"
                            name="false"
                            id="null"
                            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            />
                            </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'documents',key: 'other'})">
                            <div class="form_group">
                            <div class="d-flex align-end mb-1">
                            <label class="form_label"
                            > Others <em v-if="documents.other">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'documents',key:'other'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'other'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'other'})">
                              <vs-checkbox

                              v-model="documents.other"
                            @change="
                            selectCheck({
                            section: 'documents',
                            key: 'other',
                            })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>

                            </div>
                            <span
                            class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                            >
                            <img
                            src="@/assets/images/main/file-upload.svg"
                            class="file-icon"
                            />Upload
                            <input
                            type="file"
                            name="false"
                            id="null"
                            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            />
                            </span>
                            </div>
                          </div>
                        </div>
                        
                      
                        <div class="documents_group case_documents mb-2">
                          <label class="mb-5">Spouse Documents</label>
                          
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'approvedI140'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Approved I-140 or Pending Perm for more than 365 days <em v-if="dependentsInfo.spouse.documents.approvedI140">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'approvedI140'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'approvedI140'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'approvedI140'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.approvedI140"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'approvedI140',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                          </div> 
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'h1Bapprovals'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >All H-1B approvals<em v-if="dependentsInfo.spouse.documents.h1Bapprovals">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'h1Bapprovals'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'h1Bapprovals'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'h1Bapprovals'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.documents.h1Bapprovals"
                                  @change="
                                    selectCheck({ section: 'dependentsInfo.spouse.documents', key: 'h1Bapprovals' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'l1approvals'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >All L1 approvals<em v-if="dependentsInfo.spouse.documents.l1approvals">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'l1approvals'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'l1approvals'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'l1approvals'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.documents.l1approvals"
                                  @change="
                                    selectCheck({ section: 'dependentsInfo.spouse.documents', key: 'l1approvals' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'passport'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Passport<em v-if="dependentsInfo.spouse.documents.passport">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'passport'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'passport'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'passport'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.documents.passport"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.documents',
                                      key: 'passport',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'usVisa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">US Visa<em v-if="dependentsInfo.spouse.documents.usVisa">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'usVisa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'usVisa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'usVisa'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.usVisa"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'usVisa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                          </div>
                          
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'mostRecentI94'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Most recent I-94<em v-if="dependentsInfo.spouse.documents.mostRecentI94">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'mostRecentI94'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'mostRecentI94'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'mostRecentI94'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.documents.mostRecentI94"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.documents',
                                      key: 'mostRecentI94',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'travelHistory'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Travel History<em v-if="dependentsInfo.spouse.documents.travelHistory">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'travelHistory'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'travelHistory'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'travelHistory'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.documents.travelHistory"
                                  @change="
                                    selectCheck({ section: 'dependentsInfo.spouse.documents', key: 'travelHistory' })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="null"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'mostRecentPayStubs'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >3 most recent pay stubs<em v-if="dependentsInfo.spouse.documents.mostRecentPayStubs">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'mostRecentPayStubs'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'mostRecentPayStubs'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'mostRecentPayStubs'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.documents.mostRecentPayStubs"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.documents',
                                      key: 'mostRecentPayStubs',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'other'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Others<em v-if="dependentsInfo.spouse.documents.other">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'other'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'other'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'other'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.documents.other"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.documents',
                                      key: 'other',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <input
                                  type="file"
                                  name="false"
                                  id="null"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!--dependends(spouse)-->
            <div v-if="currentTab=='Dependents Info' && false">
              <form>
                <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'hasAnyDependetsinUStoFileH4'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you have any dependents currently in USA for whom you wish to file H4 Visa?<em v-if="beneficiaryInfo.hasAnyDependetsinUStoFileH4">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'hasAnyDependetsinUStoFileH4'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'hasAnyDependetsinUStoFileH4'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'hasAnyDependetsinUStoFileH4'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.hasAnyDependetsinUStoFileH4"
                                          @change="
                                            selectCheck({
                                              section: 'beneficiaryInfo',
                                              key: 'hasAnyDependetsinUStoFileH4',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4Required'})">
                    <div class="vx-row">
                      
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4Required'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">H4 required for spouse?<em v-if="dependentsInfo.spouse.h4Required">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'h4Required'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'h4Required'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'h4Required'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.h4Required"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'h4Required',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <template v-if="dependentsInfo.spouse.h4Required">
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'adjustmentOfI485Status'})">
                        <h3  class="small-header">Spouse Information</h3>
                        <label class="switch-label">Would you like to apply for adjustment of status (I-485) or consular processing? </label>
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Adjustment of Status (I-485)
                            <p>When your Priority Date is current, and you have a valid status in the U.S. by then, you may file I-485 to get your Green Card</p>  
                          </vs-checkbox>
                        </div>
                          <div class="check_box_container mart30" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'adjustmentOfI485Status'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentOfI485Status'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentOfI485Status'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.adjustmentOfI485Status"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'adjustmentOfI485Status',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'consularProcessing'})">
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Consular Processing 
                            <p>When your Priority Date is current, and you would like to go to a U.S. consulate 
                            abroad to apply for an immigrant visa to get your Green Card</p>
                          </vs-checkbox>
                        </div>
                          <div class="check_box_container mart30" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'consularProcessing'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'consularProcessing'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'consularProcessing'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.consularProcessing"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'consularProcessing',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!---h4EadPhotoEmailStmt-->
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4EadPhotoEmailStmt'})">
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <b>Note:</b> <p style="padding-left:5px;">TWO US style photographs are required for H4 EAD filing, please mail the copies to our office address: Somireddy Law Group PLLC, 20745 Williamsport Place, Suite 390, Ashburn, Virginia 20147</p>
                          
                        </div>
                          <div class="check_box_container" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'h4EadPhotoEmailStmt'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EadPhotoEmailStmt'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="false && checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EadPhotoEmailStmt'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.h4EadPhotoEmailStmt"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'h4EadPhotoEmailStmt',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentlyInUS'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Are you currently in USA? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'currentlyInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentlyInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentlyInUS'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.currentlyInUS"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',

                                key: 'currentlyInUS',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'adjustmentStatusToPermResidenceI485'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Adjustment of status to Permanent Residency (Form I-485) required for spouse?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'adjustmentStatusToPermResidenceI485'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentStatusToPermResidenceI485'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'adjustmentStatusToPermResidenceI485'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.adjustmentStatusToPermResidenceI485"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'adjustmentStatusToPermResidenceI485',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'h4EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >H4 EAD required for spouse?</label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'h4EADRequired'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EADRequired'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'h4EADRequired'})">
                              <vs-checkbox
                            
                              v-model="dependentsInfo.spouse.h4EADRequired"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'h4EADRequired',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full mb-10">
                        <div class="vx-input-group flex form-input-group FML">
                          <div class="vx-input-group-default flex-grow">
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'firstName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">First Name<em v-if="dependentsInfo.spouse.firstName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'middleName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.middleName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'lastName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.lastName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'lastName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.lastName"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'lastName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <div class="vs-input w-full vs-input-primary">
                                  <div class="vs-con-input">
                                    <input
                                      type="text"
                                      maxlength="200"
                                      class="vs-inputx vs-input--input normal"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'otherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'otherNames'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'otherNames'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'otherNames'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.otherNames"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'otherNames',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>                         
                        </div>
                      </div>
                     
                     
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'nameDiffFromBirthCert'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> if your name is different from that stated on your birth certificate, have you had it legally changes? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'nameDiffFromBirthCert'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'nameDiffFromBirthCert'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'nameDiffFromBirthCert'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.nameDiffFromBirthCert"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'nameDiffFromBirthCert',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'birthCertHaveNamePobDob'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Does the birth certificate have your name, place of birth, date of birth, parents’ names mentioned, and the birth was registered around the time you were born? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'birthCertHaveNamePobDob'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'birthCertHaveNamePobDob'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'birthCertHaveNamePobDob'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.birthCertHaveNamePobDob"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'birthCertHaveNamePobDob',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> 
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'have2AffidavitsOfBirthFamily'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Do you have two (2) affidavits of birth from family members?</a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'have2AffidavitsOfBirthFamily'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'have2AffidavitsOfBirthFamily'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'have2AffidavitsOfBirthFamily'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.have2AffidavitsOfBirthFamily"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'have2AffidavitsOfBirthFamily',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.height',key: 'feet'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Feet<em v-if="dependentsInfo.spouse.height.feet">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.height',key:'feet'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.height',key:'feet'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.height',key:'feet'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.height.feet"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.height',
                                  key: 'feet',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.height',key: 'inches'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Inches<em v-if="dependentsInfo.spouse.height.inches">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.height',key:'inches'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.height',key:'inches'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.height',key:'inches'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.height.inches"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.height',
                                  key: 'inches',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'weight'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Weight<em v-if="dependentsInfo.spouse.weight">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'weight'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'weight'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'weight'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.weight"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'weight',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'race'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Race<em v-if="dependentsInfo.spouse.race">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'race'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'race'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'race'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.race"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'race',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'eyeColor'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EYE COLOR<em v-if="dependentsInfo.spouse.eyeColor">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'eyeColor'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'eyeColor'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'eyeColor'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.eyeColor"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'eyeColor',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'hairColor'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">HAIR COLOR<em v-if="dependentsInfo.spouse.hairColor">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'hairColor'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'hairColor'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'hairColor'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.hairColor"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'hairColor',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                        
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage<em v-if="dependentsInfo.spouse.dateOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriage'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.dateOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'dateOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfMarriageEnd'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage End<em v-if="dependentsInfo.spouse.dateOfMarriageEnd">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfMarriageEnd'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriageEnd'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfMarriageEnd'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.dateOfMarriageEnd"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'dateOfMarriageEnd',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Marriage<em v-if="dependentsInfo.spouse.countryOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.countryOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'countryOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'provinceOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provience of Marriage<em v-if="dependentsInfo.spouse.provinceOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'provinceOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.provinceOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'provinceOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'locationOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Marriage<em v-if="dependentsInfo.spouse.locationOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'locationOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.locationOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'locationOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'applyingWithYou'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Applying with you?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'applyingWithYou'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'applyingWithYou'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'applyingWithYou'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.applyingWithYou"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'applyingWithYou',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'enterInUSUnderCaseWaiverProgram'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Did you enter the U.S. under the Visa waiver program?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'enterInUSUnderCaseWaiverProgram'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'enterInUSUnderCaseWaiverProgram'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'enterInUSUnderCaseWaiverProgram'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.enterInUSUnderCaseWaiverProgram"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'enterInUSUnderCaseWaiverProgram',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'curNonImmigrantVisaNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current nonimmigrant visa number<em v-if="dependentsInfo.spouse.curNonImmigrantVisaNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.curNonImmigrantVisaNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'curNonImmigrantVisaNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'stateOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              > State of recent entry into the USA<em v-if="dependentsInfo.spouse.stateOfLastEntryInUS">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'stateOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'stateOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'stateOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.stateOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'stateOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'placeOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Place of recent entry into the USA<em v-if="dependentsInfo.spouse.placeOfLastEntryInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'placeOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'placeOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'placeOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.placeOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'placeOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentSpouseName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Spouse Name<em v-if="dependentsInfo.spouse.currentSpouseName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'currentSpouseName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentSpouseName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentSpouseName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.currentSpouseName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'currentSpouseName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'lastArrivalDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Date of most recent entry into the USA<em v-if="dependentsInfo.spouse.lastArrivalDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'lastArrivalDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'lastArrivalDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'lastArrivalDate'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.lastArrivalDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'lastArrivalDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'inspectedByAnyImmOfficer'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Were you inspected by an immigration officer?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'inspectedByAnyImmOfficer'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'inspectedByAnyImmOfficer'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'inspectedByAnyImmOfficer'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.inspectedByAnyImmOfficer"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'inspectedByAnyImmOfficer',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'issuedAnyEADFromUSCIS'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever been issued an Employement Authorization Document(EAD) from the USCIS?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'issuedAnyEADFromUSCIS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'issuedAnyEADFromUSCIS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'issuedAnyEADFromUSCIS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.issuedAnyEADFromUSCIS"
                              @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'issuedAnyEADFromUSCIS',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'eadCard'})">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Please provide a copy of the EAD CARD(S), front and  back<em v-if="dependentsInfo.spouse.documents.eadCard">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'eadCard'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'eadCard'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'eadCard'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.documents.eadCard"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.documents',
                                      key: 'eadCard',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <label for="docs_i140_approval_notice"></label>
                                <input
                                  type="file"
                                  name="docs_i140_approval_notice"
                                  id="docs_i140_approval_notice"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'hasPermResidencyInOtherCountry'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Do you hold Permanent residence in any other country? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'hasPermResidencyInOtherCountry'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'hasPermResidencyInOtherCountry'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'hasPermResidencyInOtherCountry'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.hasPermResidencyInOtherCountry"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'hasPermResidencyInOtherCountry',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'permResidencyCountryDetails'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Permanent Residency Country<em>*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'permResidencyCountryDetails'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'permResidencyCountryDetails'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'permResidencyCountryDetails'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.permResidencyCountryDetails"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'permResidencyCountryDetails',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouArrestedBefore'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever been arrested,cited, charged or detained for any reason by an law enforcement official? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouArrestedBefore'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBefore'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBefore'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYouArrestedBefore"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYouArrestedBefore',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouArrestedBeforeDocs'})">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >documents, if any<em>*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouArrestedBeforeDocs'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBeforeDocs'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouArrestedBeforeDocs'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.haveYouArrestedBeforeDocs"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'haveYouArrestedBeforeDocs',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <label for="docs_i140_approval_notice"></label>
                                <input
                                  type="file"
                                  name="docs_i140_approval_notice"
                                  id="docs_i140_approval_notice"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>                  
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'everAppliedAOSInUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever applied AOS in the united states or an immigrant visa at the US Embassy/Consulate to obatain permanent resident status before? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'everAppliedAOSInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'everAppliedAOSInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'everAppliedAOSInUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.everAppliedAOSInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'everAppliedAOSInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'appliedAOSInUSDocs'})">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/2">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >documents, if any<em>*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'appliedAOSInUSDocs'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'appliedAOSInUSDocs'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'appliedAOSInUSDocs'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.appliedAOSInUSDocs"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'appliedAOSInUSDocs',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <span
                                class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                              >
                                <img
                                  src="@/assets/images/main/file-upload.svg"
                                  class="file-icon"
                                />Upload
                                <label for="docs_i140_approval_notice"></label>
                                <input
                                  type="file"
                                  name="docs_i140_approval_notice"
                                  id="docs_i140_approval_notice"
                                  accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverReceivedPublicAssistendeInUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever received public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverReceivedPublicAssistendeInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverReceivedPublicAssistendeInUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYouEverReceivedPublicAssistendeInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYouEverReceivedPublicAssistendeInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverlikelyReceivePublicAssistendeInUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">Have you ever likely to receive public assistence in the united states from any source, including the US government or any state,country,city or muncipality(other than emergency medical treatment)?
 </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverlikelyReceivePublicAssistendeInUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYouEverlikelyReceivePublicAssistendeInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYouEverlikelyReceivePublicAssistendeInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isVisaDenieedTOUS'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever been denied a visa to the United States?</a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'isVisaDenieedTOUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isVisaDenieedTOUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isVisaDenieedTOUS'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.isVisaDenieedTOUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'isVisaDenieedTOUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'visaDeniedReason'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Reason<em v-if="dependentsInfo.spouse.visaDeniedReason">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'visaDeniedReason'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'visaDeniedReason'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'visaDeniedReason'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.visaDeniedReason"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'visaDeniedReason',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYoueverPresntUnlawfully'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Have you ever been present in the united states unlawfully for more than 180 days?</a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYoueverPresntUnlawfully'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYoueverPresntUnlawfully'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYoueverPresntUnlawfully'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.haveYoueverPresntUnlawfully"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'haveYoueverPresntUnlawfully',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'presntUnlawfullyReason'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Reason<em v-if="dependentsInfo.spouse.presntUnlawfullyReason">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'presntUnlawfullyReason'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'presntUnlawfullyReason'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'presntUnlawfullyReason'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.presntUnlawfullyReason"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'presntUnlawfullyReason',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                     
                      <div class="vx-col w-full mb-10 md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'email'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Email<em v-if="dependentsInfo.spouse.email">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'email'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'email'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'email'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.email"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'email',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              maxlength="200"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.dateOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'dateOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="dependentsInfo.spouse.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'countryOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em v-if="dependentsInfo.spouse.provinceOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'provinceOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'provinceOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfCitizenship'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Citizenship<em v-if="dependentsInfo.spouse.countryOfCitizenship">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.countryOfCitizenship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'countryOfCitizenship',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="dependentsInfo.spouse.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'locationOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.locationOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'locationOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'I94'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Number<em v-if="dependentsInfo.spouse.I94">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'I94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'I94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'I94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.I94"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'I94',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'I94ExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isI94DSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'isI94DSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isI94DSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isI94DSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.spouse.isI94DSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.spouse',
                                     key: 'isI94DSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Expiry Date<em v-if="dependentsInfo.spouse.I94ExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'I94ExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'I94ExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'I94ExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.I94ExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'I94ExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'sevisNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">SEVIS Number<em v-if="dependentsInfo.spouse.sevisNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'sevisNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'sevisNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'sevisNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.sevisNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'sevisNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'eadNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EAD Number<em v-if="dependentsInfo.spouse.eadNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'eadNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'eadNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'eadNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.eadNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'eadNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>






                      <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'phoneNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="dependentsInfo.spouse.phoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'phoneNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'phoneNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'phoneNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.phoneNumber"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'phoneNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Previous Spouse
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'previousSpouse'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'previousSpouse'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'previousSpouse'})">
                                <vs-checkbox
                              
                                v-model="
                              dependentsInfo.spouse.previousSpouse.previousSpouse
                            "
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse.previousSpouse',
                                key: 'previousSpouse',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                            </div>
                            </h3>
                          </label>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'firstName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">First Name<em v-if="dependentsInfo.spouse.previousSpouse.firstName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'firstName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'firstName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'firstName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.firstName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'firstName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'middleName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.previousSpouse.middleName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'middleName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'middleName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'middleName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.middleName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'middleName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'lastName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.previousSpouse.lastName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'lastName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'lastName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'lastName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.lastName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'lastName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name<em v-if="dependentsInfo.spouse.previousSpouse.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'maidenName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.maidenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.previousSpouse.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfBirth'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfBirth'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.dateOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'dateOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'dateOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.dateOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriage'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>  
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.dateOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'dateOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'dateOfMarriageEnd'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.dateOfMarriageEnd">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriageEnd'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriageEnd'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'dateOfMarriageEnd'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.dateOfMarriageEnd"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'dateOfMarriageEnd',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'countryOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.countryOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.countryOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'countryOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'provinceOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provience of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.provinceOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.provinceOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'provinceOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'locationOfMarriage'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Marriage<em v-if="dependentsInfo.spouse.previousSpouse.locationOfMarriage">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriage'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriage'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriage'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.locationOfMarriage"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'locationOfMarriage',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'countryOfMarriageTermination'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Termination<em v-if="dependentsInfo.spouse.previousSpouse.countryOfMarriageTermination">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriageTermination'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriageTermination'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'countryOfMarriageTermination'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.countryOfMarriageTermination"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'countryOfMarriageTermination',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'provinceOfMarriageTermination'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Provience of Termination<em v-if="dependentsInfo.spouse.previousSpouse.provinceOfMarriageTermination">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriageTermination'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriageTermination'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'provinceOfMarriageTermination'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.provinceOfMarriageTermination"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'provinceOfMarriageTermination',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'locationOfMarriageTermination'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Termination<em v-if="dependentsInfo.spouse.previousSpouse.locationOfMarriageTermination">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriageTermination'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriageTermination'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'locationOfMarriageTermination'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.locationOfMarriageTermination"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'locationOfMarriageTermination',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'marriageEndedDueTo'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Marriage Ended Due To<em v-if="dependentsInfo.spouse.previousSpouse.marriageEndedDueTo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedDueTo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedDueTo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedDueTo'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.marriageEndedDueTo"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'marriageEndedDueTo',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'marriageEndedOtherInfo'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">If, Marriage Ended<em v-if="dependentsInfo.spouse.previousSpouse.marriageEndedOtherInfo">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedOtherInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedOtherInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'marriageEndedOtherInfo'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.previousSpouse.marriageEndedOtherInfo"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.previousSpouse',
                                  key: 'marriageEndedOtherInfo',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              maxlength="200"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                       <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.previousSpouse',key: 'obtainPermResidenceThroughSpouse'})" >
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Did you obtain U.S Permanent Residence Through Spouse? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'obtainPermResidenceThroughSpouse'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                              <vs-checkbox
                             
                                v-model="dependentsInfo.spouse.previousSpouse.obtainPermResidenceThroughSpouse"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.previousSpouse',
                                    key: 'obtainPermResidenceThroughSpouse',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Passport</h3></label
                          >
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Number<em v-if="dependentsInfo.spouse.passportNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.passportNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'passportNumber',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportIssuedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Issued Date<em v-if="dependentsInfo.spouse.passportIssuedDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportIssuedDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.passportIssuedDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'passportIssuedDate',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Expiry Date<em v-if="dependentsInfo.spouse.passportExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.passportExpiryDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',

                                  key: 'passportExpiryDate',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportIssuedCountry'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Country of Passport Issued<em v-if="dependentsInfo.spouse.passportIssuedCountry">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.passportIssuedCountry"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'passportIssuedCountry',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'lastArrivalDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of most recent entry into the USA<em v-if="dependentsInfo.spouse.lastArrivalDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'lastArrivalDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'lastArrivalDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'lastArrivalDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.lastArrivalDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'lastArrivalDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Last Entry in US<em v-if="dependentsInfo.spouse.dateOfLastEntryInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfLastEntryInUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfLastEntryInUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfLastEntryInUS'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.dateOfLastEntryInUS"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'dateOfLastEntryInUS',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status<em v-if="dependentsInfo.spouse.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'currentStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.currentStatus"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'currentStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'curNonImmigrantVisaStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Nonimmigrant visa category <em v-if="dependentsInfo.spouse.curNonImmigrantVisaStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'curNonImmigrantVisaStatus'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.curNonImmigrantVisaStatus"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'curNonImmigrantVisaStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div> -->
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'presentMaritalStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Marital Status<em v-if="dependentsInfo.spouse.presentMaritalStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'presentMaritalStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'presentMaritalStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'presentMaritalStatus'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.presentMaritalStatus"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'presentMaritalStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 mart20" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox>If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.spouse.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.spouse',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'statusExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status Expiry Date<em v-if="dependentsInfo.spouse.statusExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.statusExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',
                                        key: 'statusExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'SSN'})">
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full mb-5">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Social Security number (if applicable)<em v-if="dependentsInfo.spouse.SSN">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'SSN'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'SSN'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'SSN'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.SSN"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'SSN',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'alienNumber'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Your Alien Number (if applicable)<em v-if="dependentsInfo.spouse.alienNumber">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'alienNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'alienNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'alienNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.alienNumber"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'alienNumber',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverTravelledToUS'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Have you ever travelled to the United States?<em v-if="dependentsInfo.spouse.haveYouEverTravelledToUS">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverTravelledToUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverTravelledToUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverTravelledToUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.haveYouEverTravelledToUS"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',
                                      key: 'haveYouEverTravelledToUS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'priorPeriodOfStayInUS'})">
                        <div class="form-container form-container-v2">
                          <div class="vx-row">
                            <div class="vx-col w-full mt-0 mb-5">
                              <div class="d-flex">
                              <h3 class="small-header mt-0">Dates of Stay in USA<em v-if="dependentsInfo.spouse.priorPeriodOfStayInUS">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'priorPeriodOfStayInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'priorPeriodOfStayInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'priorPeriodOfStayInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.priorPeriodOfStayInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'priorPeriodOfStayInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                              </h3>
                          </div>
                              <p>
                                All prior periods of stay in the U.S. over the last seven
                                years
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full prior-stay-list periods-nowrap">
                          <div class="vx-row delete-row">
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa Status</label>
                                </div>
                                <selectField wrapclass="" placeholder="Visa Status" />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Entered</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="mx-input-wrapper">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Departed</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="delete">
                              <a>
                                <img src="@/assets/images/main/delete-row-img.svg">
                              </a>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                     
                        <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'physicalAddress'})">
                        <h3 class="small-header">
                          Current Address <em v-if="dependentsInfo.spouse.physicalAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'physicalAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'physicalAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'physicalAddress'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.physicalAddress"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'physicalAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Mailing Address <em v-if="dependentsInfo.spouse.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'currentAddress'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentAddress'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentAddress'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.currentAddress"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'currentAddress' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOutsideUS'})">
                        <h3 class="small-header">
                          Address Outside the U.S<em v-if="dependentsInfo.spouse.addressOutsideUS">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'addressOutsideUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUS'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.addressOutsideUS"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',
                                        key: 'addressOutsideUS',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                      
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOutsideUSMoreThanYear'})">
                        <h3 class="small-header">
                          Last Address outside Of the United States for more than one year<em>*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'addressOutsideUSMoreThanYear'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUSMoreThanYear'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUSMoreThanYear'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.addressOutsideUSMoreThanYear"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'addressOutsideUSMoreThanYear' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.addressOutsideUSMoreThanYear.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOutsideUSMoreThanYear.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="dependentsInfo.spouse.addressOutsideUSMoreThanYear.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.addressOutsideUSMoreThanYear',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOutsideUSMoreThanYear',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOutsideUSMoreThanYear.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOutsideUSMoreThanYear',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                      </div>
                      <div class="divider full-divider mb-5"></div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOfLastNYears'})">
                        <h3 class="small-header">
                          Your Residence starting with most current for the Past Five Years in the U.S and Aboard<em>*</em>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'addressOfLastNYears'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOfLastNYears'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOfLastNYears'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.addressOfLastNYears"
                            @change="
                              selectCheck({ section: 'dependentsInfo.spouse', key: 'addressOfLastNYears' })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOfLastNYears',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.addressOfLastNYears.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOfLastNYears',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOfLastNYears.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOfLastNYears',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.addressOfLastNYears',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="dependentsInfo.spouse.addressOfLastNYears.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.addressOfLastNYears',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.addressOfLastNYears',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.addressOfLastNYears.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.addressOfLastNYears',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                    </div>
                      </div>
                    </template>
                    </div>
                  </div>
                </vs-col>
                
                <template v-if="dependentsInfo.spouse.h4Required">
                  <vs-col class="w-full p-0 mt-5" >
                    <vs-alert
                      color="warning"
                      class="warning-alert top-warning-alert"
                      icon-pack="IntakePortal"
                      icon="IP-information-button"
                      active="true"
                    >
                      Provide your father details, starting from
                      the most recent first.
                    </vs-alert>
                  </vs-col>
                      <vs-col
                    class="m-auto float-none"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="12"
                    vs-sm="12"
                  >
                    <div class="form-container pt-10 form-container_QT">
                              <h3 class="small-header">Father Information 
                                
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'fatherInfo'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'fatherInfo'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'fatherInfo'})">
                              <vs-checkbox
                            
                              v-model="
                            dependentsInfo.spouse.fatherInfo.fatherInfo
                          "
                          @change="
                            selectCheck({
                              section: 'dependentsInfo.spouse.fatherInfo',
                              key: 'fatherInfo',
                            })
                          "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                              </h3>
                      <div class="vx-row">

                        <div class="vx-col w-full">
                          <div class="form-container alt-rows-bg questionnaire_hb">
                            <div class="vx-row">
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'firstName'})">
                                <div class="vx-input-group flex form-input-group FML">
                                  <div class="vx-input-group-default flex-grow">
                                    <div class="vx-col w-full md:w-1/2">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">First Name<em v-if="dependentsInfo.spouse.fatherInfo.firstName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'firstName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'firstName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'firstName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.firstName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'firstName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>

                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'middleName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.fatherInfo.middleName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'middleName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'middleName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'middleName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.middleName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'middleName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'lastName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.fatherInfo.lastName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'lastName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'lastName'})}"  >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'lastName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.lastName"
                                            @change="
                                              selectCheck({
                                                section: 'dependentsInfo.spouse.fatherInfo',
                                                key: 'lastName',
                                              })
                                            "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full">
                                  <div class="form_group w-full">
                                    <label class="form_label"
                                      ><h3 class="small-header">Name at Birth</h3>
                                    </label>
                                  </div>
                              </div>
                              <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',key: 'firstName'})">
                                <div class="vx-input-group flex form-input-group FML">
                                  <div class="vx-input-group-default flex-grow">
                                    <div class="vx-col w-full md:w-1/2">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">First Name<em v-if="dependentsInfo.spouse.fatherInfo.nameAtBirth.firstName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'firstName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'firstName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'firstName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.nameAtBirth.firstName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',
                                          key: 'firstName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>

                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',key: 'middleName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.fatherInfo.nameAtBirth.middleName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'middleName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'middleName'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'middleName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.nameAtBirth.middleName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',
                                          key: 'middleName',
                                        })
                                      "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',key: 'lastName'})">
                                      <div class="form_group">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.fatherInfo.nameAtBirth.lastName">*</em></label>
                                          <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'lastName'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'lastName'})}"  >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo.nameAtBirth',key:'lastName'})">
                                      <vs-checkbox
                                    
                                      v-model="dependentsInfo.spouse.fatherInfo.nameAtBirth.lastName"
                                            @change="
                                              selectCheck({
                                                section: 'dependentsInfo.spouse.fatherInfo.nameAtBirth',
                                                key: 'lastName',
                                              })
                                            "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                    </div>
                                        </div>
                                        <div class="vs-input w-full vs-input-primary">
                                          <div class="vs-con-input">
                                            <input
                                              type="text"
                                              maxlength="200"
                                              class="vs-inputx vs-input--input normal"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'dateOfBirth'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.fatherInfo.dateOfBirth">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'dateOfBirth'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateOfBirth'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateOfBirth'})">
                                          <vs-checkbox
                                        
                                          v-model="dependentsInfo.spouse.fatherInfo.dateOfBirth"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'dateOfBirth',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div
                                    class="mx-datepicker pad5"
                                    typeable="true"
                                    name="dfdateOfBirth"
                                    data-vv-as="Date of Birth"
                                  >
                                    <div class="vs-con-input">
                                      <Datepicker
                                        format="MM/DD/YYYY"
                                        placeholder="MM/DD/YYYY"
                                      ></Datepicker>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'countryOfBirth'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Country of Birth<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'countryOfBirth'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'countryOfBirth'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'countryOfBirth'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.countryOfBirth"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'countryOfBirth',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div class="con-select w-full">
                              <multiselect :options="[]" placeholder="Select">
                              </multiselect>
                            </div>
                          </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'provinceOfBirth'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Province of Birth<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'provinceOfBirth'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'provinceOfBirth'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'provinceOfBirth'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.provinceOfBirth"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'provinceOfBirth',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div class="con-select w-full">
                              <multiselect :options="[]" placeholder="Select">
                              </multiselect>
                            </div>
                          </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'locationOfBirth'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Location of Birth<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'locationOfBirth'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'locationOfBirth'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'locationOfBirth'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.locationOfBirth"
                                @change="
                                  selectCheck({ section: 'dependentsInfo.spouse.fatherInfo', key: 'locationOfBirth' })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                            </div>
                            <div class="vs-con-input">
                              <input type="text" class="vs-inputx vs-input--input normal" />
                            </div>
                          </div>
                          </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'currentAddress'})">
                          <h3 class="small-header">
                            Current Address <em v-if="currentAddress">*</em>
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'currentAddress'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'currentAddress'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'currentAddress'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.currentAddress"
                              @change="
                                selectCheck({ section: 'dependentsInfo.spouse.fatherInfo', key: 'currentAddress' })
                              "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                            
                          </h3>
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Street Address</label>
                                </div>
                                <vs-input
                                  class="w-full"
                                  v-validate="'required'"
                                  data-vv-as="Street Address"
                                />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Apt, Suite</label>
                                </div>
                                <div class="address-suite">
                                  <ul
                                    class="demo-alignment custom-radio"
                                    vs-type="flex"
                                    vs-align="center"
                                  >
                                    <li>
                                      <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                    </li>
                                    <li>
                                      <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                    </li>
                                    <li>
                                      <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                    </li>
                                  </ul>
                                  <vs-input class="" data-vv-as="Apt, Suite" />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="con-select w-full select-large">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Country</label>
                                  </div>
                                  <multiselect
                                    name="Status"
                                    :multiple="false"
                                    :options="[]"
                                    :hideSelected="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select Country"
                                    :preselect-first="false"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="con-select w-full select-large">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"> State</label>
                                  </div>
                                  <multiselect
                                    name="Status"
                                    :multiple="false"
                                    :options="[]"
                                    :hideSelected="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select State"
                                    :preselect-first="false"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="con-select w-full select-large">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label"> City</label>
                                  </div>
                                  <multiselect
                                    name="Status"
                                    :multiple="false"
                                    :options="[]"
                                    :hideSelected="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select City"
                                    :preselect-first="false"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Zip Code</label>
                                </div>
                                <vs-input class="w-full" />
                              </div>
                            </div>
                          </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'deceasedCity'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Deceased City<em>*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedCity'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedCity'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedCity'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.deceasedCity"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'deceasedCity',
                                  })
                                "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                              
                            </div>
                            <div class="con-select w-full">
                              <multiselect :options="[]" placeholder="Select">
                              </multiselect>
                            </div>
                          </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'deceasedDate'})">
                                <div class="form_group mt-datepicker-wrap">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Deceased Date<em v-if="dependentsInfo.spouse.fatherInfo.deceasedDate">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedDate'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedDate'})}" >
                                            <span class="checkmark" >
                                              <i class="material-icons">check</i>
                                            </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                            <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'deceasedDate'})">
                                          <vs-checkbox
                                        
                                          v-model="dependentsInfo.spouse.fatherInfo.deceasedDate"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.spouse.fatherInfo',
                                          key: 'deceasedDate',
                                        })
                                      "
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                            <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                    
                                  </div>
                                  <div
                                    class="mx-datepicker pad5"
                                    typeable="true"
                                    name="dfdateOfBirth"
                                    data-vv-as="Date of Birth"
                                  >
                                    <div class="vs-con-input">
                                      <Datepicker
                                        format="MM/DD/YYYY"
                                        placeholder="MM/DD/YYYY"
                                      ></Datepicker>
                                    </div>
                                  </div>
                                </div>
                          </div>
                          <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'isUSCitizen'})">
                          <div class="d-flex align-center">
                            <a class="switch-label mr-3">
                              Is your father now or was he ever a U.S. citizen?
                            </a>
                            <vs-switch>
                              <span slot="on">Yes</span>
                              <span slot="off">No</span>
                            </vs-switch>
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'isUSCitizen'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'isUSCitizen'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'isUSCitizen'})">
                                <vs-checkbox
                              
                                v-model="dependentsInfo.spouse.fatherInfo.isUSCitizen"
                                @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse.fatherInfo',
                                  key: 'isUSCitizen',
                                })
                              "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                          </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.fatherInfo',key: 'dateFromUSCitizen'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> Dates from US citizen<em v-if="dependentsInfo.spouse.fatherInfo.dateFromUSCitizen">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.fatherInfo',key:'dateFromUSCitizen'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateFromUSCitizen'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.fatherInfo',key:'dateFromUSCitizen'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.fatherInfo.dateFromUSCitizen"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.fatherInfo',
                                    key: 'dateFromUSCitizen',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                    </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-col>                     
                  <vs-col class="w-full p-0 mt-5">
                    <vs-alert
                      color="warning"
                      class="warning-alert top-warning-alert"
                      icon-pack="IntakePortal"
                      icon="IP-information-button"
                      active="true"
                    >
                      Provide your mother details, starting from
                      the most recent first.
                    </vs-alert>
                    </vs-col>
                    <vs-col
                      class="m-auto float-none"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-lg="12"
                      vs-sm="12"
                    >
                      <div class="form-container pt-10 form-container_QT">
                                <h3 class="small-header">Mother Information 
                                  
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'motherInfo'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'motherInfo'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'motherInfo'})">
                                <vs-checkbox
                              
                                v-model="
                              dependentsInfo.spouse.motherInfo.motherInfo
                            "
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse.motherInfo',
                                key: 'motherInfo',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                              </div>
                                </h3>
                        <div class="vx-row">

                          <div class="vx-col w-full">
                            <div class="form-container alt-rows-bg questionnaire_hb">
                              <div class="vx-row">
                                <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'firstName'})">
                                  <div class="vx-input-group flex form-input-group FML">
                                    <div class="vx-input-group-default flex-grow">
                                      <div class="vx-col w-full md:w-1/2">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">First Name<em v-if="dependentsInfo.spouse.motherInfo.firstName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'firstName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'firstName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'firstName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.firstName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'firstName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>

                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'middleName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.motherInfo.middleName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'middleName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'middleName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'middleName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.middleName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'middleName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'lastName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.motherInfo.lastName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'lastName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'lastName'})}"  >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'lastName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.lastName"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.spouse.motherInfo',
                                                  key: 'lastName',
                                                })
                                              "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full">
                                    <div class="form_group w-full">
                                      <label class="form_label"
                                        ><h3 class="small-header">Name at Birth</h3>
                                      </label>
                                    </div>
                                </div>
                                <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',key: 'firstName'})">
                                  <div class="vx-input-group flex form-input-group FML">
                                    <div class="vx-input-group-default flex-grow">
                                      <div class="vx-col w-full md:w-1/2">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">First Name<em v-if="dependentsInfo.spouse.motherInfo.nameAtBirth.firstName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'firstName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'firstName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'firstName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.nameAtBirth.firstName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',
                                            key: 'firstName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>

                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',key: 'middleName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.motherInfo.nameAtBirth.middleName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'middleName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'middleName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'middleName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.nameAtBirth.middleName"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',
                                            key: 'middleName',
                                          })
                                        "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',key: 'lastName'})">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.motherInfo.nameAtBirth.lastName">*</em></label>
                                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'lastName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'lastName'})}"  >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo.nameAtBirth',key:'lastName'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.motherInfo.nameAtBirth.lastName"
                                              @change="
                                                selectCheck({
                                                  section: 'dependentsInfo.spouse.motherInfo.nameAtBirth',
                                                  key: 'lastName',
                                                })
                                              "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                          </div>
                                          <div class="vs-input w-full vs-input-primary">
                                            <div class="vs-con-input">
                                              <input
                                                type="text"
                                                maxlength="200"
                                                class="vs-inputx vs-input--input normal"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'dateOfBirth'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.motherInfo.dateOfBirth">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'dateOfBirth'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateOfBirth'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateOfBirth'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.spouse.motherInfo.dateOfBirth"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'dateOfBirth',
                                          })
                                        "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'countryOfBirth'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Country of Birth<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'countryOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'countryOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'countryOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.countryOfBirth"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.motherInfo',
                                      key: 'countryOfBirth',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select">
                                </multiselect>
                              </div>
                            </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'provinceOfBirth'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Province of Birth<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'provinceOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'provinceOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'provinceOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.provinceOfBirth"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.motherInfo',
                                      key: 'provinceOfBirth',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select">
                                </multiselect>
                              </div>
                            </div>
                            </div>
                            <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'locationOfBirth'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Location of Birth<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'locationOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'locationOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'locationOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.locationOfBirth"
                                  @change="
                                    selectCheck({ section: 'dependentsInfo.spouse.motherInfo', key: 'locationOfBirth' })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="vs-con-input">
                                <input type="text" class="vs-inputx vs-input--input normal" />
                              </div>
                            </div>
                            </div>
                              <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'currentAddress'})">
                            <h3 class="small-header">
                              Current Address <em v-if="address">*</em>
                              <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'currentAddress'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'currentAddress'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'currentAddress'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.currentAddress"
                                @change="
                                  selectCheck({ section: 'dependentsInfo.spouse.motherInfo', key: 'currentAddress' })
                                "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                              
                            </h3>
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Street Address</label>
                                  </div>
                                  <vs-input
                                    class="w-full"
                                    v-validate="'required'"
                                    data-vv-as="Street Address"
                                  />
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Apt, Suite</label>
                                  </div>
                                  <div class="address-suite">
                                    <ul
                                      class="demo-alignment custom-radio"
                                      vs-type="flex"
                                      vs-align="center"
                                    >
                                      <li>
                                        <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                      </li>
                                      <li>
                                        <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                      </li>
                                      <li>
                                        <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                      </li>
                                    </ul>
                                    <vs-input class="" data-vv-as="Apt, Suite" />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Country</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select Country"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"> State</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select State"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="con-select w-full select-large">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"> City</label>
                                    </div>
                                    <multiselect
                                      name="Status"
                                      :multiple="false"
                                      :options="[]"
                                      :hideSelected="true"
                                      :close-on-select="true"
                                      :clear-on-select="false"
                                      :preserve-search="true"
                                      placeholder="Select City"
                                      :preselect-first="false"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col md:w-1/2 w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label for class="form_label">Zip Code</label>
                                  </div>
                                  <vs-input class="w-full" />
                                </div>
                              </div>
                            </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'deceasedCity'})">
                            <div class="form_group mt-datepicker-wrap">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Deceased City<em>*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'deceasedCity'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedCity'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedCity'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.deceasedCity"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.motherInfo',
                                      key: 'deceasedCity',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="con-select w-full">
                                <multiselect :options="[]" placeholder="Select">
                                </multiselect>
                              </div>
                            </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'deceasedDate'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Deceased Date<em v-if="dependentsInfo.spouse.motherInfo.deceasedDate">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'deceasedDate'})">
                                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedDate'})}" >
                                              <span class="checkmark" >
                                                <i class="material-icons">check</i>
                                              </span>
                                            </span>
                                            <div class="tooltip_cnt">
                                              <p>Field is required</p>
                                            </div>
                                          </div>
                                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'deceasedDate'})">
                                            <vs-checkbox
                                          
                                            v-model="dependentsInfo.spouse.motherInfo.deceasedDate"
                                        @change="
                                          selectCheck({
                                            section: 'dependentsInfo.spouse.motherInfo',
                                            key: 'deceasedDate',
                                          })
                                        "
                                            ></vs-checkbox>
                                            <div class="tooltip_cnt">
                                              <p>Validation is required</p>
                                            </div>
                                          </div>
                                          </div>
                                      
                                    </div>
                                    <div
                                      class="mx-datepicker pad5"
                                      typeable="true"
                                      name="dfdateOfBirth"
                                      data-vv-as="Date of Birth"
                                    >
                                      <div class="vs-con-input">
                                        <Datepicker
                                          format="MM/DD/YYYY"
                                          placeholder="MM/DD/YYYY"
                                        ></Datepicker>
                                      </div>
                                    </div>
                                  </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'isUSCitizen'})">
                            <div class="d-flex align-center">
                              <a class="switch-label mr-3">
                                Is your father now or was he ever a U.S. citizen?
                              </a>
                              <vs-switch>
                                <span slot="on">Yes</span>
                                <span slot="off">No</span>
                              </vs-switch>
                              <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'isUSCitizen'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'isUSCitizen'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'isUSCitizen'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.motherInfo.isUSCitizen"
                                  @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.motherInfo',
                                    key: 'isUSCitizen',
                                  })
                                "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.motherInfo',key: 'dateFromUSCitizen'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> Dates from US citizen<em v-if="dependentsInfo.spouse.motherInfo.dateFromUSCitizen">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.motherInfo',key:'dateFromUSCitizen'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateFromUSCitizen'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.motherInfo',key:'dateFromUSCitizen'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.motherInfo.dateFromUSCitizen"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.motherInfo',
                                    key: 'dateFromUSCitizen',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                    </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </vs-col>

                  <vs-col class="w-full p-0 mt-5">
                  <vs-alert
                  color="warning"
                  class="warning-alert top-warning-alert"
                  icon-pack="IntakePortal"
                  icon="IP-information-button"
                  active="true"
                  >
                  All associations and groups of which you are or have been a member, including political organizations, if you do not belong to any organizations, please write "None".
                  </vs-alert>
                  </vs-col>
                  <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  >
                  <div class="form-container pt-10 form-container_QT">
                  <h3 class="small-header">ASSOCIATIONS/GROUPS 
                  <div class="check_box_container"  v-if="isEdit">
                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'associations'})">
                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'associations'})}" >
                      <span class="checkmark" >
                        <i class="material-icons">check</i>
                      </span>
                    </span>
                    <div class="tooltip_cnt">
                      <p>Field is required</p>
                    </div>
                  </div>
                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'associations'})">
                    <vs-checkbox
                        v-model="
                      dependentsInfo.spouse.associations.associations
                    "
                    @change="
                      selectCheck({
                        section: 'dependentsInfo.spouse.associations',
                        key: 'associations',
                      })
                    "
                    ></vs-checkbox>
                    <div class="tooltip_cnt">
                        <p>Validation is required</p>
                    </div>
                  </div>
                  </div>
                  </h3>
                  <div class="vx-row">
                  <div class="vx-col w-full">
                      <div class="form-container alt-rows-bg questionnaire_hb">
                            <div class="vx-row">
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'name'})">
                                  <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Name of the associations and groups<em v-if="dependentsInfo.spouse.associations.name">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'name'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'name'})}">
                                                    <span class="checkmark" >
                                                      <i class="material-icons">check</i>
                                                    </span>
                                                  </span>
                                                  <div class="tooltip_cnt">
                                                    <p>Field is required</p>
                                                  </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'name'})">
                                                <vs-checkbox
                          
                                                      v-model="dependentsInfo.spouse.associations.name"
                                                      @change="
                                                        selectCheck({
                                                          section: 'dependentsInfo.spouse.associations',
                                                          key: 'name',
                                                        })
                                                      "
                                                  ></vs-checkbox>
                                                  <div class="tooltip_cnt">
                                                    <p>Validation is required</p>
                                                  </div>
                                              </div>
                                        </div>
                                      </div>
                                      <div class="vs-con-input">
                                          <input type="text" class="vs-inputx vs-input--input normal" />
                                      </div>
                                  </div>
                              </div>
                            
                              <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'address'})">
                    <h3 class="small-header">
                      Address<em v-if="dependentsInfo.spouse.associations.address">*</em>
                    <div class="check_box_container"  v-if="isEdit">
                        <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'address'})">
                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'address'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                          </span>
                          <div class="tooltip_cnt">
                            <p>Field is required</p>
                          </div>
                        </div>
                        <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'address'})">
                          <vs-checkbox
                        
                          v-model="dependentsInfo.spouse.associations.address"
                      @change="
                        selectCheck({
                          section: 'dependentsInfo.spouse.associations',
                          key: 'address',
                        })
                      "
                          ></vs-checkbox>
                          <div class="tooltip_cnt">
                            <p>Validation is required</p>
                          </div>
                        </div>
                        </div>
                    </h3>
                  
                    <div class="vx-row">
                      <div class="vx-col md:w-1/2 w-full">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Country</label>
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select Country"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> State</label>
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select State"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"> City</label>
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select City"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                            
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'startDate'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.associations.startDate">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'startDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'startDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'startDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.associations.startDate"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.associations',
                                    key: 'startDate',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                            
                              <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'endDate'})">
                          <div class="form_group mt-datepicker-wrap">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">End Date<em v-if="dependentsInfo.spouse.associations.endDate">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'endDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'endDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'endDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.associations.endDate"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse.associations',
                                    key: 'endDate',
                                  })
                                "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                              
                            </div>
                            <div
                              class="mx-datepicker pad5"
                              typeable="true"
                              name="dfdateOfBirth"
                              data-vv-as="Date of Birth"
                            >
                              <div class="vs-con-input">
                                <Datepicker
                                  format="MM/DD/YYYY"
                                  placeholder="MM/DD/YYYY"
                                ></Datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                            
                              <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse.associations',key: 'natureofAssociations'})">
                                  <div class="form_group mt-datepicker-wrap">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Nature of associations and groups<em v-if="dependentsInfo.spouse.associations.natureofAssociations">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                              <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.associations',key:'natureofAssociations'})">
                                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'natureofAssociations'})}">
                                                    <span class="checkmark" >
                                                      <i class="material-icons">check</i>
                                                    </span>
                                                  </span>
                                                  <div class="tooltip_cnt">
                                                    <p>Field is required</p>
                                                  </div>
                                              </div>
                                              <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.associations',key:'natureofAssociations'})">
                                                <vs-checkbox
                          
                                                      v-model="dependentsInfo.spouse.associations.natureofAssociations"
                                                      @change="
                                                        selectCheck({
                                                          section: 'dependentsInfo.spouse.associations',
                                                          key: 'natureofAssociations',
                                                        })
                                                      "
                                                  ></vs-checkbox>
                                                  <div class="tooltip_cnt">
                                                    <p>Validation is required</p>
                                                  </div>
                                              </div>
                                        </div>
                                      </div>
                                      <div class="vs-con-input">
                                          <input type="text" class="vs-inputx vs-input--input normal" />
                                      </div>
                                  </div>
                              </div>

                            </div>

                      </div>
                    </div>

                  </div>
                  </div>
                  </vs-col>
                </template>
                <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px;"  v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'anyOtherPersonEmployedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed?<em v-if="dependentsInfo.spouse.anyOtherPersonEmployedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'anyOtherPersonEmployedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'anyOtherPersonEmployedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'anyOtherPersonEmployedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.anyOtherPersonEmployedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'anyOtherPersonEmployedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0 mt-5">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Please write the following information about your current and past employment for the past five years in the U.S and aboard starting with your most current Job.
                  </vs-alert>
                </vs-col>
                
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Employment 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          dependentsInfo.spouse.prevEmploymentInfo.prevEmploymentInfo
                        "
                        @change="
                          selectCheck({
                            section: 'dependentsInfo.spouse.prevEmploymentInfo',
                            key: 'prevEmploymentInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'employerName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Employer Name<em v-if="dependentsInfo.spouse.prevEmploymentInfo.employerName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'employerName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'employerName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'employerName'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.employerName
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'employerName',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'currentEmployer'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3"> Current Employer? </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'currentEmployer'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'currentEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'currentEmployer'})">
                                        <vs-checkbox
                                      
                                        v-model=" 
                                    dependentsInfo.spouse.prevEmploymentInfo.currentEmployer
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                      key: 'currentEmployer',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                            </div>
                            
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'jobTitle'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Job Title<em v-if="dependentsInfo.spouse.prevEmploymentInfo.jobTitle">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobTitle'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobTitle'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobTitle'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.jobTitle"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'jobTitle',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'businessType'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Employer Business E.g., IT<em v-if="dependentsInfo.spouse.prevEmploymentInfo.businessType">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'businessType'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'businessType'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'businessType'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.businessType
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'businessType',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div> 
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Salary<em v-if="dependentsInfo.spouse.prevEmploymentInfo.salary">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.salary
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Pay Frequency<em v-if="dependentsInfo.spouse.prevEmploymentInfo.payFrequency">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentInfo.payFrequency
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'jobDuties'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Description of Duties Performed<em v-if="dependentsInfo.spouse.prevEmploymentInfo.jobDuties">*</em>
                                    <div class="IB_tooltip H1-140">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Please fill in your Job Duties only.Avoid
                                          inserting all project details.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobDuties'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobDuties'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'jobDuties'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.jobDuties"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'jobDuties',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-textarea w-full vs-textarea-primary">
                                  <textarea class="vs-textarea"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.prevEmploymentInfo.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="dependentsInfo.spouse.prevEmploymentInfo.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentInfo',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentInfo',key: 'address'})">
                              <h3 class="small-header">
                                Work Address<em v-if="dependentsInfo.spouse.prevEmploymentInfo.address">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'address'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentInfo',key:'address'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.prevEmploymentInfo.address"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse.prevEmploymentInfo',

                                      key: 'address',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
                <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px;" v-if="false && showOrHideField({section: 'dependentsInfo.spouse',key: 'haveYouEverEmployed'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed Outside US?<em v-if="dependentsInfo.spouse.haveYouEverEmployed">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'haveYouEverEmployed'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverEmployed'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'haveYouEverEmployed'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.haveYouEverEmployed"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'haveYouEverEmployed',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                <vs-col class="w-full p-0 mt-6">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                  Last Employer outside of the United States for more than one year.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                            <h3 class="small-header">Employment Outside US
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'prevEmploymentOutsideUS'})">
                            <vs-checkbox
                          
                            v-model="
                          dependentsInfo.spouse.prevEmploymentOutsideUS.prevEmploymentOutsideUS
                        "
                        @change="
                          selectCheck({
                            section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                            key: 'prevEmploymentOutsideUS',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                            <div class="vx-row">

<div class="vx-col w-full">
  <div class="form-container alt-rows-bg questionnaire_hb">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'employerName'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Employer Name<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.employerName">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'employerName'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'employerName'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'employerName'})">
                  <vs-checkbox
                
                  v-model="
                dependentsInfo.spouse.prevEmploymentOutsideUS.employerName
              "
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'employerName',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'currentEmployer'})">
        <div class="d-flex align-center">
          <a class="switch-label mr-3"> Current Employer? </a>
          <vs-switch>
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'currentEmployer'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'currentEmployer'})">
                  <vs-checkbox
                
                  v-model=" 
              dependentsInfo.spouse.prevEmploymentOutsideUS.currentEmployer
            "
            @change="
              selectCheck({
                section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                key: 'currentEmployer',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </div>
      </div>
      
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'jobTitle'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label">Job Title<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.jobTitle">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobTitle'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobTitle'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.jobTitle"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'jobTitle',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'businessType'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label for class="form_label"
              >Employer Business E.g., IT<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.businessType">*</em></label
            >
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'businessType'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'businessType'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'businessType'})">
                  <vs-checkbox
                
                  v-model="
                dependentsInfo.spouse.prevEmploymentOutsideUS.businessType
              "
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'businessType',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-input">
            <input
              type="text"
              class="vs-inputx vs-input--input normal"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Salary<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.salary">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentOutsideUS.salary
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Pay Frequency<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.payFrequency">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.spouse.prevEmploymentOutsideUS.payFrequency
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'jobDuties'})">
        <div class="form_group">
          <div class="d-flex align-end mb-1">
            <label class="form_label"
              >Description of Duties Performed<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.jobDuties">*</em>
              <div class="IB_tooltip H1-140">
                <span
                  ><info-icon
                    size="1.5x"
                    class="custom-class"
                  ></info-icon
                ></span>
                <div class="tooltip_cnt">
                  <p>
                    Please fill in your Job Duties only.Avoid
                    inserting all project details.
                  </p>
                </div>
              </div>
            </label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobDuties'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'jobDuties'})">
                  <vs-checkbox
                
                  v-model="beneficiaryInfo.prevEmploymentOutsideUS.jobDuties"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'jobDuties',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div class="vs-con-textarea w-full vs-textarea-primary">
            <textarea class="vs-textarea"></textarea>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'startDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">Start Date<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.startDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'startDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'startDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'startDate'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.startDate"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'startDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'endDate'})">
        <div class="form_group mt-datepicker-wrap">
          <div class="d-flex align-end mb-1">
            <label class="form_label">End Date<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.endDate">*</em></label>
            <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'endDate'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'endDate'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'endDate'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.endDate"
              @change="
                selectCheck({
                  section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',
                  key: 'endDate',
                })
              "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
            
          </div>
          <div
            class="mx-datepicker pad5"
            typeable="true"
            name="dfdateOfBirth"
            data-vv-as="Date of Birth"
          >
            <div class="vs-con-input">
              <Datepicker
                format="MM/DD/YYYY"
                placeholder="MM/DD/YYYY"
              ></Datepicker>
            </div>
          </div>
        </div>
      </div>
      <!--   

       -->
      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',key: 'address'})">
        <h3 class="small-header">
          Work Address<em v-if="dependentsInfo.spouse.prevEmploymentOutsideUS.address">*</em>
          <div class="check_box_container"  v-if="isEdit">
                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'address'})">
                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'address'})}" >
                    <span class="checkmark" >
                      <i class="material-icons">check</i>
                    </span>
                  </span>
                  <div class="tooltip_cnt">
                    <p>Field is required</p>
                  </div>
                </div>
                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.prevEmploymentOutsideUS',key:'address'})">
                  <vs-checkbox
                
                  v-model="dependentsInfo.spouse.prevEmploymentOutsideUS.address"
            @change="
              selectCheck({
                section: 'dependentsInfo.spouse.prevEmploymentOutsideUS',

                key: 'address',
              })
            "
                  ></vs-checkbox>
                  <div class="tooltip_cnt">
                    <p>Validation is required</p>
                  </div>
                </div>
                </div>
          
        </h3>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Street Address</label>
              </div>
              <vs-input
                class="w-full"
                v-validate="'required'"
                data-vv-as="Street Address"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label class="form_label">Apt, Suite</label>
              </div>
              <div class="address-suite">
                <ul
                  class="demo-alignment custom-radio"
                  vs-type="flex"
                  vs-align="center"
                >
                  <li>
                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                  </li>
                </ul>
                <vs-input class="" data-vv-as="Apt, Suite" />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label">Country</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Country"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> State</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select State"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="con-select w-full select-large">
                <div class="d-flex align-end mb-1">
                  <label class="form_label"> City</label>
                </div>
                <multiselect
                  name="Status"
                  :multiple="false"
                  :options="[]"
                  :hideSelected="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select City"
                  :preselect-first="false"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="form_group">
              <div class="d-flex align-end mb-1">
                <label for class="form_label">Zip Code</label>
              </div>
              <vs-input class="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
                  </div>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-0 form-container_QT" v-if="dependentsInfo.spouse.h4Required">
                    <div class="vx-row">
                      <div class="vx-col w-full" v-if="dependentsInfo.spouse.h4Required">
                        <h3 class="small-header">
                            List of documents needs to be updated
                            <span class="file-type">
                              (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                            </span>
                          </h3>
                          <div class="documents_group case_documents">
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'passport'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Passport- First page with photo, Visa page and last
                                    page with address</label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'passport'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'passport'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'passport'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.passport"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'passport',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'usVisa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa</label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'usVisa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'usVisa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'usVisa'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.usVisa"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'usVisa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'formI94'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Copy of I-94<em v-if="dependentsInfo.spouse.documents.formI94">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'formI94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.formI94"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'formI94',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'formI797'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Latest I-797, Notice of Approval of the spouse (if
                                    spouse is on H-1B or L-1 status)<em v-if="dependentsInfo.spouse.documents.formI797">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'formI797'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI797'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI797'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.formI797"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'formI797',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'formI20'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Spouse’s all Form I-20s (if spouse is on F-1
                                    status)<em v-if="dependentsInfo.spouse.documents.formI20">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'formI20'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI20'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'formI20'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.formI20"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'formI20',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                 
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'payStubs'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Three Recent Pay Stubs<em v-if="dependentsInfo.spouse.documents.payStubs">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'payStubs'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'payStubs'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'payStubs'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.payStubs"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'payStubs',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                 
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'marriageCertificate'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >{{'marriageCertificate' | formatdoctype}} <em v-if="dependentsInfo.spouse.documents.marriageCertificate">*</em>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'marriageCertificate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'marriageCertificate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'marriageCertificate'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.spouse.documents.marriageCertificate
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'marriageCertificate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>


                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'slgApprovalNoticeOfPrevH4'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Current and Previous H4 Approval Copies<em v-if="dependentsInfo.spouse.documents.slgApprovalNoticeOfPrevH4">*</em>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'slgApprovalNoticeOfPrevH4'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.spouse.documents.slgApprovalNoticeOfPrevH4
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'slgApprovalNoticeOfPrevH4',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse.documents',key: 'other'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Others<em v-if="dependentsInfo.spouse.documents.other">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse.documents',key:'other'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'other'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse.documents',key:'other'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.documents.other"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse.documents',

                                        key: 'other',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </vs-col>  
               
              </form>
            </div>
            <!--child -->
            <div v-if="currentTab=='Dependents Info'">
              <form>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'hasChildren'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you want to fill children information?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'hasChildren'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'hasChildren'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'hasChildren'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.hasChildren"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'hasChildren',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <template v-if="dependentsInfo.childrens.hasChildren">
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'adjustmentOfI485Status'})">
                        <h3 class="small-header">Child Information</h3>
                        <label class="switch-label">Would you like to apply for adjustment of status (I-485) or consular processing? </label>
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Adjustment of Status (I-485)
                            <p>When your Priority Date is current, and you have a valid status in the U.S. by then, you may file I-485 to get your Green Card</p> </vs-checkbox>
                            </div>
                          <div class="check_box_container" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'adjustmentOfI485Status'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'adjustmentOfI485Status'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'adjustmentOfI485Status'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.adjustmentOfI485Status"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'adjustmentOfI485Status',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'consularProcessing'})">
                        <div class="d-flex align-center">
                          <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                          <vs-checkbox> Consular Processing
                            <p>When your Priority Date is current, and you would like to go to a U.S. consulate 
                            abroad to apply for an immigrant visa to get your Green Card</p> </vs-checkbox>
                            </div>
                          <div class="check_box_container" v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'consularProcessing'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'consularProcessing'})}"  >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'consularProcessing'})">
                              <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.consularProcessing"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'consularProcessing',
                                    })
                                  "
                                ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'currentlyInUS'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Are you currently in USA? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'currentlyInUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'currentlyInUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'currentlyInUS'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.currentlyInUS"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'currentlyInUS',
                              })
                            "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </div>
                      </div>
                      
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'h4EADRequired'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">H4 EAD required for Child?</label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'h4EADRequired'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'h4EADRequired'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'h4EADRequired'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.h4EADRequired"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'h4EADRequired',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                      </div>
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'firstName'})">
                        <div class="vx-col w-full mb-10">
                          <div class="vx-input-group flex form-input-group FML">
                            <div class="vx-input-group-default flex-grow">
                              <div class="vx-col w-full md:w-1/2">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">First Name<em v-if="dependentsInfo.childrens.firstName">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'firstName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.firstName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.childrens',

                                          key: 'firstName',
                                        })
                                      "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                    
                                  </div>
                                  <div class="vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        maxlength="200"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Middle Name<em v-if="dependentsInfo.childrens.middleName">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'middleName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.middleName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.childrens',

                                          key: 'middleName',
                                        })
                                      "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                    
                                  </div>
                                  <div class="vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        maxlength="200"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="vx-col w-full md:w-1/2">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Last Name<em v-if="dependentsInfo.childrens.lastName">*</em></label>
                                    <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'lastName'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.lastName"
                                      @change="
                                        selectCheck({
                                          section: 'dependentsInfo.childrens',

                                          key: 'lastName',
                                        })
                                      "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                   
                                  </div>
                                  <div class="vs-input w-full vs-input-primary">
                                    <div class="vs-con-input">
                                      <input
                                        type="text"
                                        maxlength="200"
                                        class="vs-inputx vs-input--input normal"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col w-full md:w-1/2 mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'email'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Email<em v-if="dependentsInfo.childrens.email">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'email'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'email'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'email'})">
                              
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.email"
                              @change="
                                selectCheck({ section: 'dependentsInfo.childrens', key: 'email' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input
                              type="text"
                              maxlength="200"
                              class="vs-inputx vs-input--input normal"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'phoneNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="dependentsInfo.childrens.phoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'phoneNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'phoneNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'phoneNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.phoneNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'phoneNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'hasOtherNames'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Have you ever used any other names previously?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'hasOtherNames'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'hasOtherNames'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'hasOtherNames'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.hasOtherNames"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'hasOtherNames',
                              })
                            "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </div>
                      </div>

                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'relationship'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Your Relationship with the dependent<em v-if="dependentsInfo.childrens.relationship">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'relationship'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'relationship'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'relationship'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.relationship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'relationship',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <selectField
                            wrapclass=""
                            placeholder="Your Relationship with the dependent"
                          />
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="dependentsInfo.childrens.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'dateOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'dateOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'dateOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.dateOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'dateOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="dependentsInfo.childrens.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'countryOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.countryOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'countryOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'applyingWithYou'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3"> Applying with you? </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'applyingWithYou'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'applyingWithYou'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'applyingWithYou'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.applyingWithYou"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'applyingWithYou',
                              })
                            "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'provinceOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Province of Birth<em v-if="dependentsInfo.childrens.provinceOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'provinceOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'provinceOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'provinceOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.provinceOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'provinceOfBirth',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'locationOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="dependentsInfo.childrens.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'locationOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'locationOfBirth'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'locationOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.locationOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'locationOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                           
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'countryOfCitizenship'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Country of Citizenship<em v-if="dependentsInfo.childrens.countryOfCitizenship">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.countryOfCitizenship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'countryOfCitizenship',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'I94'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Number<em v-if="dependentsInfo.childrens.I94">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'I94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'I94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'I94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.I94"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'I94',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'I94ExpiryDate'})">
                        <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'isI94DSExpiryDate'})">
                       <div class="d-flex align-center">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox>If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'isI94DSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.childrens.isI94DSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.childrens',
                                     key: 'isI94DSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Expiry Date<em v-if="dependentsInfo.childrens.I94ExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'I94ExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.I94ExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'I94ExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'sevisNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">SEVIS Number<em v-if="dependentsInfo.childrens.sevisNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'sevisNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'sevisNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'sevisNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.sevisNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'sevisNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'eadNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">EAD Number<em v-if="dependentsInfo.childrens.eadNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'eadNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'eadNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'eadNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.eadNumber"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'eadNumber',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'stateOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              > State of recent entry into the USA<em v-if="dependentsInfo.childrens.stateOfLastEntryInUS">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'stateOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'stateOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'stateOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.stateOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'stateOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'placeOfLastEntryInUS'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Place of recent entry into the USA<em v-if="dependentsInfo.childrens.placeOfLastEntryInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'placeOfLastEntryInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'placeOfLastEntryInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'placeOfLastEntryInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.placeOfLastEntryInUS"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'placeOfLastEntryInUS',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full">
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Passport</h3></label
                          >
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportNumber'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Number<em v-if="dependentsInfo.childrens.passportNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.passportNumber"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'passportNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportIssuedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Issued Date<em v-if="dependentsInfo.childrens.passportIssuedDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportIssuedDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.passportIssuedDate"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',

                                  key: 'passportIssuedDate',
                                })
                              "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportExpiryDate'})" >
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Expiry Date<em v-if="dependentsInfo.childrens.passportExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.passportExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'passportExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportIssuedCountry'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Country of Passport Issued<em v-if="dependentsInfo.childrens.passportIssuedCountry">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.passportIssuedCountry"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'passportIssuedCountry',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'lastArrivalDate'})" >
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of most recent entry into the USA<em v-if="dependentsInfo.childrens.lastArrivalDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'lastArrivalDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'lastArrivalDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'lastArrivalDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.lastArrivalDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'lastArrivalDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                     
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status<em v-if="dependentsInfo.childrens.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'currentStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'currentStatus'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'currentStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.currentStatus"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'currentStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full md:w-1/2 mart20" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox>If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.childrens.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.childrens',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'statusExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status Expiry Date<em v-if="dependentsInfo.childrens.statusExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.statusExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'statusExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'SSN'})">
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full mb-5">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Social Security number (if applicable)<em v-if="dependentsInfo.childrens.SSN">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'SSN'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'SSN'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'SSN'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.SSN"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'SSN',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'alienNumber'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Your Alien Number (if applicable)<em v-if="dependentsInfo.childrens.alienNumber">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'alienNumber'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'alienNumber'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'alienNumber'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.alienNumber"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'alienNumber',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="vs-con-input">
                                <input
                                  type="text"
                                  name="0"
                                  placeholder="123 - 45 - 6789"
                                  data-vv-as="123 - 45 - 6789"
                                  class="vs-inputx vs-input--input normal"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col w-full mb-0" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'anyOtherPersonEmployedInUS'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Have you ever been employed?<em v-if="dependentsInfo.childrens.anyOtherPersonEmployedInUS">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'anyOtherPersonEmployedInUS'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'anyOtherPersonEmployedInUS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'anyOtherPersonEmployedInUS'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.anyOtherPersonEmployedInUS"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens',
                                              key: 'anyOtherPersonEmployedInUS',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
              </div>
                      <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-5">
                            <h3 class="small-header">Employment 
                              
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <vs-checkbox
                          
                            v-model="
                          dependentsInfo.childrens.prevEmploymentInfo.prevEmploymentInfo
                        "
                        @change="
                          selectCheck({
                            section: 'dependentsInfo.childrens.prevEmploymentInfo',
                            key: 'prevEmploymentInfo',
                          })
                        "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                            </h3>
                    <div class="vx-row">

                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'employerName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Employer Name<em v-if="dependentsInfo.childrens.prevEmploymentInfo.employerName">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'employerName'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'employerName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'employerName'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.childrens.prevEmploymentInfo.employerName
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'employerName',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'currentEmployer'})">
                              <div class="d-flex align-center">
                                <a class="switch-label mr-3"> Current Employer? </a>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'currentEmployer'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'currentEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'currentEmployer'})">
                                        <vs-checkbox
                                      
                                        v-model=" 
                                    dependentsInfo.childrens.prevEmploymentInfo.currentEmployer
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                      key: 'currentEmployer',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </div>
                            </div>
                      
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'jobTitle'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Job Title<em v-if="dependentsInfo.childrens.prevEmploymentInfo.jobTitle">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobTitle'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobTitle'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobTitle'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.prevEmploymentInfo.jobTitle"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'jobTitle',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'businessType'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Employer Business E.g., IT<em v-if="dependentsInfo.childrens.prevEmploymentInfo.businessType">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'businessType'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'businessType'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'businessType'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.childrens.prevEmploymentInfo.businessType
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'businessType',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Salary<em v-if="dependentsInfo.childrens.prevEmploymentInfo.salary">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.childrens.prevEmploymentInfo.salary
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label"
                                    >Pay Frequency<em v-if="dependentsInfo.childrens.prevEmploymentInfo.payFrequency">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="
                                      dependentsInfo.childrens.prevEmploymentInfo.payFrequency
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'jobDuties'})"> 
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Description of Duties Performed<em v-if="dependentsInfo.childrens.prevEmploymentInfo.jobDuties">*</em>
                                    <div class="IB_tooltip H1-140">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Please fill in your Job Duties only.Avoid
                                          inserting all project details.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobDuties'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobDuties'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'jobDuties'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.prevEmploymentInfo.jobDuties"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'jobDuties',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-textarea w-full vs-textarea-primary">
                                  <textarea class="vs-textarea"></textarea>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="dependentsInfo.childrens.prevEmploymentInfo.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'startDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'startDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.prevEmploymentInfo.startDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'startDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="dependentsInfo.childrens.prevEmploymentInfo.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'endDate'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'endDate'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.prevEmploymentInfo.endDate"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.prevEmploymentInfo',
                                        key: 'endDate',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.prevEmploymentInfo',key: 'address'})">
                              <h3 class="small-header">
                                Work Address<em v-if="dependentsInfo.spouse.prevEmploymentInfo.address">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'address'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.prevEmploymentInfo',key:'address'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.prevEmploymentInfo.address"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens.prevEmploymentInfo',

                                      key: 'address',
                                    })
                                  "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                
                              </h3>
                              <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Street Address</label>
                                    </div>
                                    <vs-input
                                      class="w-full"
                                      v-validate="'required'"
                                      data-vv-as="Street Address"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Apt, Suite</label>
                                    </div>
                                    <div class="address-suite">
                                      <ul
                                        class="demo-alignment custom-radio"
                                        vs-type="flex"
                                        vs-align="center"
                                      >
                                        <li>
                                          <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                        </li>
                                        <li>
                                          <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                        </li>
                                      </ul>
                                      <vs-input class="" data-vv-as="Apt, Suite" />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Country</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Country"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> State</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select State"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label"> City</label>
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select City"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label for class="form_label">Zip Code</label>
                                    </div>
                                    <vs-input class="w-full" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>



                <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'haveYouEverTravelledToUS'})">
                        <div class="vx-row">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"
                                  >Have you ever travelled to the United States?<em v-if="dependentsInfo.childrens.haveYouEverTravelledToUS">*</em></label
                                >
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'haveYouEverTravelledToUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'haveYouEverTravelledToUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'haveYouEverTravelledToUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.haveYouEverTravelledToUS"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',
                                      key: 'haveYouEverTravelledToUS',
                                    })
                                  "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                                
                              </div>
                              <div class="form_radio_btns">
                                <vs-button class="yes mr-5" color="success" type="border">
                                  Yes</vs-button
                                >
                                <vs-button class="no" color="danger" type="border"
                                  >No</vs-button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'priorPeriodOfStayInUS'})">
                        <div class="form-container form-container-v2">
                          <div class="vx-row">
                            <div class="vx-col w-full mt-5 mb-5">
                              <div class="d-flex">
                              <h3 class="small-header">Dates of Stay in USA<em v-if="dependentsInfo.childrens.priorPeriodOfStayInUS">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'priorPeriodOfStayInUS'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'priorPeriodOfStayInUS'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'priorPeriodOfStayInUS'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.priorPeriodOfStayInUS"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.childrens',
                                    key: 'priorPeriodOfStayInUS',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                              </h3>
                          </div>
                              <p>
                                All prior periods of stay in the U.S. over the last seven
                                years
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full prior-stay-list periods-nowrap">
                          <div class="vx-row delete-row">
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa Status</label>
                                </div>
                                <selectField wrapclass="" placeholder="Visa Status" />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Entered</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="mx-input-wrapper">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Departed</label>
                                </div>
                                <div
                                  class="mx-datepicker pad5"
                                  typeable="true"
                                  name="dfdateOfBirth"
                                  data-vv-as="Date of Birth"
                                >
                                  <div class="vs-con-input">
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    ></Datepicker>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="delete">
                              <a>
                                <img src="@/assets/images/main/delete-row-img.svg">
                              </a>
                            </div>
                          </div>
                        </div>
                       
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address<em v-if="dependentsInfo.childrens.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'currentAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'currentAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'currentAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.currentAddress"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'currentAddress',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'physicalAddress'})">
                        <h3 class="small-header">
                          Mailing Address<em v-if="dependentsInfo.childrens.physicalAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'physicalAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'physicalAddress'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'physicalAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.physicalAddress"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'physicalAddress',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                          
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'addressOutsideUS'})">
                        <h3 class="small-header">
                          Address Outside the U.S<em v-if="dependentsInfo.childrens.addressOutsideUS">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'addressOutsideUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'addressOutsideUS'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'addressOutsideUS'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.addressOutsideUS"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',
                                        key: 'addressOutsideUS',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                      
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    </div>
                    <div class="vs-col w-full"  v-if="dependentsInfo.childrens.hasChildren">
                      <div class="form-container">
                        <div class="vx-row w-full">
                          <div class="form-container">
                            <h3 class="small-header">
                              List of documents needs to be updated
                              <span class="file-type">
                                (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                              </span>
                            </h3>
                          </div>
                          <div class="documents_group case_documents">
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'passport'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Passport- First page with photo, Visa page and last
                                    page with address<em v-if="dependentsInfo.childrens.documents.passport">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'passport'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'passport'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'passport'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.passport"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'passport',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'visa'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Visa<em v-if="dependentsInfo.childrens.documents.visa">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'visa'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'visa'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'visa'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.visa"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'visa',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'formI94'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">I94<em v-if="dependentsInfo.childrens.documents.formI94">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'formI94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'formI94'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'formI94'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.formI94"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'formI94',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'approvalNotice'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Approval Notice<em v-if="dependentsInfo.childrens.documents.approvalNotice">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'approvalNotice'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'approvalNotice'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'approvalNotice'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.childrens.documents.approvalNotice
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'approvalNotice',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'birthCertificate'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Birth Certificate<em v-if="dependentsInfo.childrens.documents.birthCertificate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'birthCertificate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'birthCertificate'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'birthCertificate'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.childrens.documents.birthCertificate
                                    "
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'birthCertificate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'slgApprovalNoticeOfPrevL2'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Current and Previous L2 Approval Copies<em v-if="dependentsInfo.childrens.documents.slgApprovalNoticeOfPrevL2">*</em>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevL2'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevL2'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevL2'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.childrens.documents.slgApprovalNoticeOfPrevL2"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'slgApprovalNoticeOfPrevL2',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'slgApprovalNoticeOfPrevH4'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Current and Previous H4 Approval Copies<em v-if="dependentsInfo.childrens.documents.slgApprovalNoticeOfPrevH4">*</em>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevH4'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'slgApprovalNoticeOfPrevH4'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                      dependentsInfo.childrens.documents.slgApprovalNoticeOfPrevH4"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'slgApprovalNoticeOfPrevH4',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                  
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                            <div class="vx-col w-full md:w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens.documents',key: 'other'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Others<em v-if="dependentsInfo.childrens.documents.other">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens.documents',key:'other'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'other'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens.documents',key:'other'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.documents.other"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens.documents',

                                        key: 'other',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                                <span
                                  class="file-upload-input file-upload-input-cs file-uploads file-uploads-html5"
                                >
                                  <img
                                    src="@/assets/images/main/file-upload.svg"
                                    class="file-icon"
                                  />Upload
                                  <input
                                    type="file"
                                    name="null"
                                    id="null"
                                    accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <vs-popup
      class="holamundo success-popups"
      title="Your registration is complete."
      :active.sync="SuccessQuestionnaire"
    >
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire submitted successfully!</h2>
      <p>
        It will be reviewed by the petitioner and appropriate actions will be taken soon.
      </p>
    </vs-popup>

    <vs-popup
      class="holamundo success-popups"
      title="Template configuration complete."
      :active.sync="showFinalsubmitPopup"
    >
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire template submission!</h2>
      <p>Are you sure to continue?</p>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="showFinalsubmitPopup = false"
          >Cancel</vs-button
        >
        <vs-button color="success" class="save ml-3" type="filled" @click="saveMe(true)"
          >Yes</vs-button
        >
      </div>
    </vs-popup>
    
  </div>
</template>


<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import Datepicker from "vuejs-datepicker-inv";
import immiMask from "@/views/forms/fields/maskinput.vue";
import "vue2-datepicker/index.css";
import immiuploader from "@/views/forms/fields/fileupload.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import immiInput from "@/views/forms/fields/simpleinput.vue";
import immitextarea from "@/views/forms/fields/simpletextarea.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
import immiPhone from "@/views/forms/fields/phonenumber.vue";
import immiyesorno from "@/views/forms/fields/yesorno.vue";
import addressField from "@/views/forms/fields/address.vue";
import { InfoIcon } from "vue-feather-icons";
import { EyeIcon } from "vue-feather-icons";
import Multiselect from "vue-multiselect-inv";
import { Trash2Icon } from "vue-feather-icons";
import _ from "lodash";

export default {
  props: {
    templateId: {
      default: "",
    },
    isEdit:true,
    entityType:''
  },
  beforeDestroy() {
    this.SuccessQuestionnaire = false;
    document.removeEventListener("click", this.reloadthePage);
  },
  data() {
    return {
      currentTab: 'Personal Info',
      tabslist: [{
                        key: "casedetails",
                        name: "Personal Info"
                    }
    
                ],
      SuccessQuestionnaire: false,
      showFinalsubmitPopup: false,
      beneficiaryInfo: {
        h4EADRequired:true,
        doYouAlreadyH4EAD:true,
        l2EADRequired:true,
        doYouAlreadyL2EAD:true,


        applyingPetitionFor:false,
  anyOtherPersonEmployedInUS:false,
  hasAnyDependetsinUStoFileH4:false,
  haveYouEverEmployed:false,
  empInUsIfANumber:false,
  l1SpouseApprNumber:false,
  h1bSpouseApprNumber:false,
    appliedAOSInUSDocs:false,
    associations: [{
    name:false, 
        address:{
            locationId: false,
            locationDetails: false,
            stateId: false,
            stateDetails: false,
            countryId: false,
            countryDetails: false,
        },
    startDate: false,
    endDate:false,
    natureofAssociations:false,
    }],
    previousSpouse: {
      previousSpouse:false,
      firstName: false,
      middleName: false,
      lastName: false,
      dateOfBirth: false,
      dateOfMarriage: false,
      dateOfMarriageEnd: false,
      maidenName: false,
      //Place of Marriage
      countryOfMarriage: false,
      countryOfMarriageDetails: false,
      provinceOfMarriage: false,
      provinceOfMarriageDetails: false,
      locationOfMarriage: false,

      //Place of Termination
      countryOfMarriageTermination: false,
      countryOfMarriageTerminationDetails: false,
      provinceOfMarriageTermination: false,
      provinceOfMarriageTerminationDetails: false,
      locationOfMarriageTermination: false,
      obtainPermResidenceThroughSpouse: false,
      marriageEndedDueTo: false,
      marriageEndedOtherInfo: false,
    },
    curNonImmigrantVisaNumber:false, 
    curNonImmigrantVisaCategory : false,  
    doesBirthRegistered:false, 
    isVisaDenieedTOUS:false,
    visaDeniedReason:false,
    haveYoueverPresntUnlawfully:false,
    presntUnlawfullyReason:false,
    haveYouEverReceivedPublicAssistendeInUS:false,
    haveYouEverlikelyReceivePublicAssistendeInUS:false,
    eadCard:false,
    everAppliedAOSInUS: false,
    appliedAOSInUSDocs:false,
    haveYouArrestedBefore:false, 
    haveYouArrestedBeforeDocs:false, 
    maritalStatusDetails:false,
    haveYouEverTravelledToUS:false,
    currentlyInUS: false,
    haveOwnershipInterest: false,
    ownershipInterestDesc: false,
    haveYouEverAppliedH1bCase: false,
    prevH1bCaseDesc: false,
    anyImmPetitionFiledDesc:false,
    consulateInfo: {
        locationId: false,
        locationDetails: false,
        stateId: false,
        stateDetails: false,
        countryId: false,
        countryDetails: false
    },
    alienNumber: false,
    lastArrivalNumber: false,
    placeOfLastEntryInUS: false,
    hasMasterDegreeInUS:false,
    educations: [{
        _id: 0,
        name: false,
        address: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: false,
            stateId: false,
            stateDetails: false,
            countryId: false,
            countryDetails: false,
            zipcode: false,
           
        },
        highestDegree: false,
        highestDegreeDetails: false,
        majorFieldOfStudy: false,
        attendedFrom: false,
        attendedTo: false,
        graduatedYear: false,
        degreereceived: false,
        isAccredited: false,
        isForProfit: false,
        graduatedDate:false
    }],
    nonImmPetitionsInfo: [{
        _id: 0,
        visaStatus: false,
        visaStatusDetails: false,
        receiptNo: false,
        petitionerName: false,
        validFrom:false,
        validTo:false,
    }],
    h1bImmPetitionsInfo: [{
        typeId:false,
        _id: 0,
        typeId: false,
        typeDetails: false,
        receiptNo: false,
        petitionerName: false,
        validFrom:false,
        validTo:false,
    }],     
    didThisPtnrFliedImmPetitionEarlier:false,
    anyImmPetitionFiled: false,
    immPetitionInfo: {
        anyOtherAlienFiled: false,
        filedNumber: false,
        employerName: false,
        rirOrRegularProcessing: false,
        filedStateId: false,
        filedStateDetails: false,
        applCurStatus: false,
        seekingFiledtrueforETA750: false,
        anyI140Filed: false,
        i140Info: {
            fieldNumber: false,
            employerName: false,
            priorityNumber: false,
            eb2orEb3: false,
            currentStatus: false
        }
    },
    prevEmploymentInfo: [{
        _id: 0,
        employerName: false,
        address: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: false,
            stateId: false,
            stateDetails: false,
            countryId: false,
            countryDetails: false,
            zipcode: false
        },
        businessType: false,
        jobTitle: false,
        jobDuties: false,
        startDate: false,
        endDate: false,
        salary:false,
        payFrequency:false,
        currentEmployer: false,
    }],
    prevEmploymentOutsideUS:[{
        _id: 0,
        employerName:false,
        address: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: false,
            stateId: false,
            stateDetails: false,
            countryId: false,
            countryDetails: false,
            zipcode: false
        },
        businessType: false,
        jobTitle: false,
        jobDuties: false,
        startDate: false,
        endDate: false,
        salary:false,
        payFrequency:false,
        currentEmployer: false ,
    }],
    
    addressOutsideUS: {
        line1: false,
        line2: false,
        aptType: false,
        locationId: false,
        locationDetails: false,
        stateId: false,
        stateDetails: false,
        countryId: false,
        countryDetails: false,
        zipcode: false
    },

    name: false,
    firstName: false,
    middleName: false,
    lastName: false,
    hasOtherNames: false,
    otherNames: [{
        _id: 0,
        name: false,
        firstName: false,
        middleName: false,
        lastName: false,
    }],
    gender: false,
    email: false,
    education: {
        highestDegree: false,
        highestDegreeDetails: false,
        majorFieldOfStudy: false
    },
    maritalStatus: false,
    // GC 485 fields start
    noOfChildrens: false,
    dateOfMarriage: false,
    countryOfMarriage: false,
    countryOfMarriageDetails: false,
    provinceOfMarriage: false,
    provinceOfMarriageDetails: false,
    locationOfMarriage: false,
    doYouHaveMarriageCert: false ,
    appliedAOSInUSDocs:false,
    marriageCertDocs: false,
    have2AffidavitsAttestingToMarriage: false,
    nameDiffFromBirthCert:false,
    have2AffidavitsOfBirthFamily:false,
    birthCertHaveNamePobDob:false,
    birthCertHaveNamePobDob:false,
    have2AffidavitsOfBirthFamily:false,
    previouslyMarried:false,
    
  
    dateOfBirth: false,
    countryOfBirth: false,
    countryOfBirthDetails: false,
    provinceOfBirth: false,
    provinceOfBirthDetails: false,
    locationOfBirth: false,
    countryOfCitizenship: false,
    countryOfCitizenshipDetails: false,
    I94: false,
    I94ExpiryDate: false,
    I94StatusName:false,
    
    height: {
    feet: false,
    inches: false
    },
        weight: false,
        race: {
            id: false,
            name: false
        },
        eyeColor: {
            id: false,
            name: false
        },
        hairColor: {
            id: false,
            name: false
        },
        firstArrivalDate: false,
        lastArrivalDate: false,
        reasonOfLastArrival: false,
        stateOfLastEntryInUS: false,
        stateDetailsOfLastEntryInUS: false,
        placeOfLastEntryInUS: false,
        caseIssuedDate: false,
        caseExpiryDate: false,
        placeOfCaseIssued: false,
        i140PriorityDate:false,
        classification:false,
        // GC 485 fields end
        homePhoneNumber: false,
        homePhoneCountryCode: {
            countryCode: false,
            countryCallingCode: false
        },
        cellPhoneNumber: false,
        cellPhoneCountryCode: {
            countryCode: false,
            countryCallingCode: false
        },
        // GC 485 fields start
        noOfChildrens: false,
        dateOfMarriage: false,
        countryOfMarriage: false,
        countryOfMarriageDetails: false,
        provinceOfMarriage: false,
        provinceOfMarriageDetails: false,
        locationOfMarriage: false,
        doYouHaveMarriageCert: false ,
        appliedAOSInUSDocs:false,
        marriageCertDocs: false,
                  have2AffidavitsAttestingToMarriage: false,
                  nameDiffFromBirthCert:false,
                  have2AffidavitsOfBirthFamily:false,
                  birthCertHaveNamePobDob:false,
                  birthCertHaveNamePobDob:false,
                  have2AffidavitsOfBirthFamily:false,
                  previouslyMarried:false,
                  
                
                  dateOfBirth: false,
                  countryOfBirth: false,
                  countryOfBirthDetails: false,
                  provinceOfBirth: false,
                  provinceOfBirthDetails: false,
                  locationOfBirth: false,
                  countryOfCitizenship: false,
                  countryOfCitizenshipDetails: false,
                  I94: false,
                  I94ExpiryDate: false,
                  sevisNumber: false,
                  eadNumber: false,
                  isI94DSExpiryDate:false,
                  I94StatusName:false,
                  
                  height: {
                  feet: false,
                  inches: false
                  },
                  weight: false,
                  race: {
                      id: false,
                      name: false
                  },
                  eyeColor: {
                      id: false,
                      name: false
                  },
                  hairColor: {
                      id: false,
                      name: false
                  },
                  firstArrivalDate: false,
                  lastArrivalDate: false,
                  reasonOfLastArrival: false,
                  stateOfLastEntryInUS: false,
                  stateDetailsOfLastEntryInUS: false,
                  placeOfLastEntryInUS: false,
                  caseIssuedDate: false,
                  caseExpiryDate: false,
                  placeOfCaseIssued: false,
                  i140PriorityDate:false,
                  classification:false,
                  // GC 485 fields end
                  homePhoneNumber: false,
                  homePhoneCountryCode: {
                      countryCode: false,
                      countryCallingCode: false
                  },
                  cellPhoneNumber: false,
                  cellPhoneCountryCode: {
                      countryCode: false,
                      countryCallingCode: false
                  },
                  // GC 485 fields start
                  allIssuedpassportData: [{
                      countryId: false,
                      countryDetails: false,
                      number: false,
                      issuedDate: false,
                      expiryDate: false 
                  }],
                  curVisaExpiryDate:false,
                  isDSExpiryDate:false,
                  dateFromWhichResideInUs:false,
                  inspectedByAnyImmOfficer:false,
                  issuedAnyEADFromUSCIS:false,
                  enterInUSUnderCaseWaiverProgram:false,
                  hasPermResidencyInOtherCountry:false,
                  permResidencyCountryId:false,
                  permResidencyCountryDetails:false,
                 
                  iAmFromUS: false,
                  mailingAddressIsSameAsAddress:false,
                    mailingAddress: {
                        line1: false,
                        line2: false,
                        aptType: false,
                        locationId: false,
                        locationDetails: false,
                        stateId: false,
                        stateDetails: false,
                        countryId: false,
                        countryDetails: false,
                        zipcode: false
                    },
                    currentAddress:{
                      line1: false,
                      line2: false,
                      aptType: false,
                      locationId: false,
                      locationDetails: false,
                      stateId: false,
                      stateDetails: false,
                      countryId: false,
                      countryDetails: false,
                      zipcode: false
                  },
                  physicalAddress:{
                      line1: false,
                      line2: false,
                      aptType: false,
                      locationId: false,
                      locationDetails: false,
                      stateId: false,
                      stateDetails: false,
                      countryId: false,
                      countryDetails: false,
                      zipcode: false
                  },
                  address: {
                      line1: false,
                      line2: false,
                      aptType: false,
                      locationId: false,
                      locationDetails: false,
                      stateId: false,
                      stateDetails: false,
                      countryId: false,
                      countryDetails: false,
                      zipcode: false
                  },
                  addressOfLastNYears: [{
                      line1: false,
                      line2: false,
                      aptType: false,
                      locationId: false,
                      locationDetails: false,
                      stateId: false,
                      stateDetails: false,
                      countryId: false,
                      countryDetails: false,
                      zipcode: false,
                      startDate: false,
                      endDate: false,
                  }], 
                  addressOutsideUSMoreThanYear:[{
                      line1: false,
                      line2: false,
                      aptType: false,
                      locationId: false,
                      locationDetails: false,
                      stateId: false,
                      stateDetails: false,
                      countryId: false,
                      countryDetails: false,
                      zipcode: false,
                      startDate: false,
                      endDate: false,
                  }],
                  consulateNotifyAddress: false,
                  SSN: false,
                  hasI140ImmPetitionFiled: false,
                  I140ImmPetitionFiledDetails: false,
                  passportNumber: false,
                  passportIssuedNumber: false,
                  passportExpiryNumber: false,
                  curNonImmigrantVisaStatus: false,
                  curNonImmigrantVisaStatusDetails: false,
                  curVisaExpiryNumber: false,
                  sevisNumber: false,
                  eadNumber: false,
                  priorPeriodOfStayInUS: [{
                      _id: 0,
                      enteredNumber: false,
                      departedNumber: false,
                      visaStatus: false,
                      visaStatusDetails: false,
                      noOfDays: false,
                      dateerror: false
                  }],
                  noOfDaysStayInUS: false,
                  confirmDaysStayInUS: false,
                  hasApprovedI140: false,
                  hasPermPendingForMorethan365Days: false,

                   //i140
                   passportIssuedCountry:false,
                   passportIssuedCountryDetails:false,
                  immPetitionPriorityDate: false, // list your Priority Date obtained from your previous immigrant petition
                  applyI485AdjOrConsuProcess: false, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },
                  adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                  consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                  areYouUnderRemoveOfIndOrUscis: false, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },

              },
    fatherInfo:{
        name: false,
    firstName: false,
    middleName: false,
    lastName: false,
    hasOtherNames: false,
    otherNames: [{
        _id: 0,
        name: false,
        firstName: false,
        middleName: false,
        lastName: false,
    }],
    dateOfBirth: false,
    countryOfBirth: false,
    countryOfBirthDetails: false,
    provinceOfBirth: false,
    provinceOfBirthDetails: false,
    locationOfBirth: false,
    currentAddress: false,
    isUSCitizen: false,
    dateFromUSCitizen: false,
    nameAtBirth:{
        firstName: false, 
        middleName: false, 
        lastName: false,
    },
    deceasedCity: false,
    deceasedCityDetails:false,
    deceasedDate: false,
      },
      motherInfo:{
        name: false,
    firstName: false,
    middleName: false,
    lastName: false,
    hasOtherNames: false,
    otherNames: [{
        _id: 0,
        name: false,
        firstName: false,
        middleName: false,
        lastName: false,
    }],
    dateOfBirth: false,
    countryOfBirth: false,
    countryOfBirthDetails: false,
    provinceOfBirth: false,
    provinceOfBirthDetails: false,
    locationOfBirth: false,
    currentAddress: false,
    isUSCitizen: false,
    dateFromUSCitizen: false,
    nameAtBirth:{
        firstName: false, 
        middleName: false, 
        lastName: false,
    },
    deceasedCity: false,
    deceasedCityDetails:false,
    deceasedDate: false,
      },
      documents: {
       
       eadCard:false,
       bnfSpouseLatestI797: false,
       bnfSpousePassport: false,
       bnfSpouseRecentPayStubs: false,
       bnfSpouseFormAllI20: false,
       slgOfferLetter:false,
       slgSignedOfferLetter:false,
       marriageCertificate: false,
       underlyingLaborApplications: false,
       mostRecentTaxTranscrips: false,
       resume: false,
       education: false,
       expLetters: false,
       INSNotices: false,
       I140ApprovalNotice: false,
       passport: false,
       passportVisaI94: false,
       formI20: false,
       socialSecurityCardAndProfLicense: false,
       other: false,
       payStubs: false,
       offerLetter: false,
       clientLetter: false,
       vendorLetter: false,
       msa: false,
       po: false,
       beneficiaryDocs: false,
       h1bRegSelectionNotice: false,
       employmentAgreement: false,
       primeVendor: false,
       mostRecentI94: false,
       priorFormI797: false,
       I797NoticeofApprovalforI140: false,
       eadCard: false,
       w2: false,
       birthCertificate: false,
       photographs: false,
       medicalExamins: false,
       dependentForI134: false,
       dependentTaxReturns: false,
       bankStatements: false,
       evidenceOfContinuVisaStatus: false,
       evidenceOfFilePetitionBefore30Apr2001: false,
       proofOfIncomeOrAsset: false,
       proofOfMedicalInsurence: false,
       recentCreditReport: false,
       permResidence: false,
       empAuth: false,  
       capSelectNotice:false,
       slgResume: false,
       slgCollegeDegreesCert: false,
       slgTransScripts: false,
       slgExpLetters: false,
       slgPassportAndVisa: false,
       slgI94: false,
       slgPrevNonimmApprovalNotices: false,
       slgPrevImmApprovalNotices: false,
       slgI140OrPermNoties: false,
       slgPrevLaborApplications: false,

       slgAckOfPrevLaborApplications: false,
       slgPaystubs: false,
       slgI20: false,
       slgEad: false,
       slgEvalOfEduCredentials: false,
       slgEvalOfEduExpCredentials:false,

       formI797H4ApprovalNotice: false,
       formI797H1BApprovalNoticePrinNonCtzn: false,
       passportOfPrinNonCtzn: false,
       last3MonthsPayslipsOfPrinNonCtzn: false,
       marriageCertificate: false,
       h4Ead: false,
       ssnCard:false,
       travelHistory:false,
       usVisa:false,
       priorH4Approvals:false,
       priorL2Approvals:false,
       copyOfExistingL2Visa:false,
       copyOfExistingVisa:false,


     },

      dependentsInfo: {
        spouse: {
          sevisNumber: false,
          eadNumber: false,
          haveYouEverTravelledToUS:false,
          isI94DSExpiryDate:false,
          anyOtherPersonEmployedInUS:false,
          haveYouEverEmployed:false,
          h4EadPhotoEmailStmt:false,
            isDSExpiryDate:false, 
            prevEmploymentInfo: [{
              _id: 0,
              employerName: false,
              address: {
                  line1: false,
                  line2: false,
                  aptType: false,
                  locationId: false,
                  locationDetails: false,
                  stateId: false,
                  stateDetails: false,
                  countryId: false,
                  countryDetails: false,
                  zipcode: false
              },
              businessType: false,
              jobTitle: false,
              jobDuties: false,
              startDate: false,
              endDate: false,
              salary:false,
              payFrequency:false,
              currentEmployer: false,
          }],
          prevEmploymentOutsideUS:[{
              _id: 0,
              employerName:false,
              address: {
                  line1: false,
                  line2: false,
                  aptType: false,
                  locationId: false,
                  locationDetails: false,
                  stateId: false,
                  stateDetails: false,
                  countryId: false,
                  countryDetails: false,
                  zipcode: false
              },
              businessType: false,
              jobTitle: false,
              jobDuties: false,
              startDate: false,
              endDate: false,
              salary:false,
              payFrequency:false,
              currentEmployer: false ,
          }],
          race: {
          id: false,
          name: false,
        },
        addressOfLastNYears: [{
                line1: false,
                line2: false,
                aptType: false,
                locationId: false,
                locationDetails: false,
                stateId: false,
                stateDetails: false,
                countryId: false,
                countryDetails: false,
                zipcode: false,
                startDate: false,
                endDate: false,
            }], 
            addressOutsideUSMoreThanYear:[{
                line1: false,
                line2: false,
                aptType: false,
                locationId: false,
                locationDetails: false,
                stateId: false,
                stateDetails: false,
                countryId: false,
                countryDetails: false,
                zipcode: false,
                startDate: false,
                endDate: false,
            }],
            previousSpouse:{
                // hasOtherNames:false,
                // otherNames: [{
                //     _id: 0,
                //     name: false,
                //     firstName: false,
                //     middleName: false,
                //     lastName: false,
                // }],
                previousSpouse:false,
                maidenName:false,
                marriageEndedDueTo:false,
                firstName: false,
                middleName: false,
                lastName: false,
                dateOfBirth: false,
                dateOfMarriage:false,
                dateOfMarriageEnd:false,

                  //Place of Marriage
                countryOfMarriage: false,
                countryOfMarriageDetails: false,
                provinceOfMarriage: false,
                provinceOfMarriageDetails: false,
                locationOfMarriage: false,

                //Place of Termination
                countryOfMarriageTermination: false,
                countryOfMarriageTerminationDetails: false,
                provinceOfMarriageTermination: false,
                provinceOfMarriageTerminationDetails: false,
                locationOfMarriageTermination: false,
                obtainPermResidenceThroughSpouse:false,  
                marriageEndedDueTo:false,
                marriageEndedOtherInfo:false,
            },
            dateOfLastEntryInUS:false,
            haveYoueverPresntUnlawfully:false,
            presntUnlawfullyReason:false,
            haveYouEverReceivedPublicAssistendeInUS:false,
            haveYouEverlikelyReceivePublicAssistendeInUS:false,
            everAppliedAOSInUS: false,
            appliedAOSInUSDocs:false,
            haveYouArrestedBefore:false,
            haveYouArrestedBeforeDocs:false,
            doesBirthRegistered:false,
            curNonImmigrantVisaNumber:false,
           
            enterInUSUnderCaseWaiverProgram: false,
            inspectedByAnyImmOfficer: false,
            issuedAnyEADFromUSCIS: false,
            hasPermResidencyInOtherCountry:false,
            permResidencyCountryId: false,
            permResidencyCountryDetails: false,
          visaDeniedReason:false,
          isVisaDenieedTOUS:false,
          hasPermResidencyInOtherCountry: false,
          permResidencyCountryId: false,
          permResidencyCountryDetails: false,
            everAppliedAOSInUS:false,
            associations:[ {
              name:false,
              address:{
                  locationId: false,
                  locationDetails:false,
                  stateId: false,
                  stateDetails: false,
                  countryId: false,
                  countryDetails: false,
              },
              startDate: false,
              endDate: false,
              natureofAssociations: false,
          }],
       
          dateOfMarriage: false,
          dateOfMarriageEnd:false,
          countryOfMarriage: false,
          countryOfMarriageDetails: false,
          provinceOfMarriage: false,
          provinceOfMarriageDetails:false,
          locationOfMarriage: false,
          currentSpouseName:false,
          presentMaritalStatus:false,
          presentMaritalStatusDetails:false,
          curNonImmigrantVisaStatus:false,
          fatherInfo:{
            name: false,
            firstName: false,
            middleName: false,
            lastName: false,
            hasOtherNames: false,
            otherNames: [{
                _id: 0,
                name: false,
                firstName: false,
                middleName: false,
                lastName: false,
            }],
            dateOfBirth: false,
            countryOfBirth: false,
            countryOfBirthDetails: false,
            provinceOfBirth: false,
            provinceOfBirthDetails: false,
            locationOfBirth: false,
            currentAddress: false,
            isUSCitizen: false,
            dateFromUSCitizen: false,
            nameAtBirth:{
                firstName: false, 
                middleName: false, 
                lastName: false,
            },
           deceasedCity: false,
           deceasedCityDetails:false,
           deceasedDate: false,
          },
          motherInfo:{
        name: false,
        firstName: false,
        middleName: false,
        lastName: false,
        hasOtherNames: false,
        otherNames: [{
            _id: 0,
            name: false,
            firstName: false,
            middleName: false,
            lastName: false,
        }],
          dateOfBirth: false,
          countryOfBirth: false,
          countryOfBirthDetails: false,
          provinceOfBirth: false,
          provinceOfBirthDetails: false,
          locationOfBirth: false,
          currentAddress: false,
          isUSCitizen: false,
          dateFromUSCitizen: false,
          nameAtBirth:{
              firstName: false, 
              middleName: false, 
              lastName: false,
          },
          deceasedCity: false,
          deceasedCityDetails:false,
          deceasedDate: false,
          },
      
          issuedAnyEADFromUSCIS: false,
          relationship: false,
          saved: false,
          currentlyInUS: false,
          hasOtherNames: false,
          otherNames: [
            {
              _id: 0,
              name: false,
              firstName: false,
              middleName: false,
              lastName: false,
            },
          ],
          passportIssuedNumber: false,
          passportIssuedCountry:false,
          alienNumber: false,
          currentAddress: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: false,
            stateId: false,
            stateDetails: false,
            countryId: false,
            countryDetails: false,
            zipcode: false,
          },
          addressOutsideUS: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: false,
            stateId: false,
            stateDetails: false,
            countryId: false,
            countryDetails: false,
            zipcode: false,
          },
          priorPeriodOfStayInUS:false,
          have2AffidavitsOfBirthFamily: false,
          h4Required: false,
          height: {
          feet: false,
          inches: false,
         },
          h4EADRequired: false,
          name: false,
          firstName: false,
          middleName: false,
          lastName: false,
          email: false,
          phoneNumber: false,
          phoneCountryCode: {
            countryCode: false,
            countryCallingCode: false,
          },
          dateOfBirth: false,
          countryOfBirth: false,
          countryOfBirthDetails: false,
          provinceOfBirth: false,
          provinceOfBirthDetails: false,
          locationOfBirth: false,
          locationOfBirthDetails: false,
          countryOfCitizenship: false,
          countryOfCitizenshipDetails: false,
          passportNumber: false,
          passportExpiryNumber: false,
          I94: false,
          I94ExpiryNumber: false,
          currentStatus: false,
          currentStatusDetails: false,
          statusExpiryNumber: false,
          SSN: false,
          lastArrivalNumber: false,
          placeOfLastEntryInUS: false,
          physicalAddress: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: false,
            stateId: false,
            stateDetails: false,
            countryId: false,
            countryDetails: false,
            zipcode: false,
          },
          documents: {
            approvedI140:false,
            h1Bapprovals:false,
            l1approvals:false,
            passport:false,
            usVisa:false,
            mostRecentI94:false,
            travelHistory:false,
            mostRecentPayStubs:false,
            other: false,




            // eadCard:false,
            // passport: false,
            // usVisa: false,
            // formI94: false,
            // formI797: false,
            // formI20: false,
            // payStubs: false,
            // marriageCertificate: false,
            
            // noticeOfApprovalOfH1Status: false,
            // approvalNoticeOfPrevH4: false,
            // slgApprovalNoticeOfPrevH4:false,
           
          },
          //i140
          adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
          consularProcessing: false, // Consular Processing { type: Boolean, default: false },
        },
        childrens: {
          sevisNumber: false,
          eadNumber: false,
          haveYouEverTravelledToUS:false,
          isI94DSExpiryDate:false,
          anyOtherPersonEmployedInUS:false,
          haveYouEverEmployed:false,
          isDSExpiryDate:false,
          applyingWithYou:false,
          dateOfLastEntryInUS:false,
          passportIssuedDate:false,
          h4EADRequired:false,
          have2AffidavitsOfBirthFamily:false,
          saved: false,
          relationship: false,
          currentlyInUS: false,
          hasOtherNames: false,
          otherNames: [
            {
              _id: false,
              name: false,
              firstName: false,
              middleName: false,
              lastName: false,
            },
          ],
          placeOfLastEntryInUS:false,
          stateOfLastEntryInUS:false,
          prevEmploymentInfo: {
           // prevEmploymentInfo:false,
            _id: 0,
            employerName: false,
            address: {
              line1: false,
              line2: false,
              aptType: false,
              locationId: false,
              locationDetails: false,
              stateId: false,
              stateDetails: false,
              countryId: false,
              countryDetails: false,
              zipcode: false,
          },
          salary:false,
          businessType: false,
          jobTitle: false,
          jobDuties: false,
          startDate: false,
          endDate: false,
          payFrequency:false,
          payFrequency:false,
          currentEmployer: false,
        },
          alienNumber: false,
          lastArrivalNumber: false,
          placeOfLastEntryInUS: false,
          currentAddress: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: {
              id: false,
              name: false,
              stateId: false,
              countryId: false,
            },
            stateId: false,
            stateDetails: {
              id: false,
              name: false,
              countryId: false,
            },
            countryId: false,
            countryDetails: {
              id: false,
              name: false,
              shortName: false,
              phoneCode: false,
              countryId: false,
              currencySymbol: false,
              currencyCode: false,
              zipcodeLength: false,
            },
            zipcode: false,
          },
          physicalAddress:{
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: {
              id: false,
              name: false,
              stateId: false,
              countryId: false,
            },
            stateId: false,
            stateDetails: {
              id: false,
              name: false,
              countryId: false,
            },
            countryId: false,
            countryDetails: {
              id: false,
              name: false,
              shortName: false,
              phoneCode: false,
              countryId: false,
              currencySymbol: false,
              currencyCode: false,
              zipcodeLength: false,
            },
            zipcode: false,
          },
          addressOutsideUS: {
            line1: false,
            line2: false,
            aptType: false,
            locationId: false,
            locationDetails: {
              id: false,
              name: false,
              stateId: false,
              countryId: false,
            },
            stateId: false,
            stateDetails: {
              id: false,
              name: false,
              countryId: false,
            },
            countryId: false,
            countryDetails: {
              id: false,
              name: false,
              shortName: false,
              phoneCode: false,
              countryId: false,
              currencySymbol: false,
              currencyCode: false,
              zipcodeLength: false,
            },
            zipcode: false,
          },
          passportIssuedNumber: false,
          priorPeriodOfStayInUS: false,
          hasChildren: false,
          name: false,
          firstName: false,
          middleName: false,
          lastName: false,
          email:false,
          phoneNumber:false,
          phoneCountryCode: {
          countryCode: false,
          countryCallingCode: false
          },
          dateOfBirth: false,
          countryOfBirth: false,
          countryOfBirthDetails: false,
          provinceOfBirth: false,
          provinceOfBirthDetails: false,
          locationOfBirth: false,
          locationOfBirthDetails: false,
          countryOfCitizenship: false,
          countryOfCitizenshipDetails: false,
          passportNumber: false,
          passportExpiryNumber: false,
          passportIssuedCountry:false,
          I94: false,
          I94ExpiryNumber: false,
          currentStatus: false,
          statusExpiryNumber: false,
          documents: {
            passport: false,
            visa: false,
            formI94: false,
            birthCertificate: false,
            approvalNotice: false,
            approvalNoticeOfPrevH4: false,
            slgApprovalNoticeOfPrevH4:false,
            other: false,
            slgApprovalNoticeOfPrevL2:false,

          },

          //i140
          adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
          consularProcessing: false, // Consular Processing { type: Boolean, default: false },
        },
      },
      isEveryThingLoaded:false,
      h4fields: [

      //spouse Documents
      {
            key: 'approvedI140',
            lebel: 'Approved I-140 or Pending Perm for more than 365 days',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
           
          },  
          {
            
            key: 'l1approvals',
            lebel: 'All L1 approvals',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'

            
          }, 
          {
            
            key: 'h1Bapprovals',
            lebel: 'All H-1B approvals',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'

            
          }, 
          {
            key: 'applyingPetitionFor',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'beneficiaryInfo'
          }, 
        {
            key: 'doYouAlreadyL2EAD',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'beneficiaryInfo'
          }, 
          {
            key: 'l2EADRequired',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'beneficiaryInfo'
          }, 
          {
            key: 'doYouAlreadyH4EAD',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'beneficiaryInfo'
          }, 
          {
            key: 'h4EADRequired',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'beneficiaryInfo'
          }, 
          {
            

            key: 'passport',
            lebel: 'Passport',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          }, 
          {
           
            key: 'usVisa',
            lebel: 'US Visa',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          },  
           
          {
            
            key: 'mostRecentI94',
            lebel: 'Most recent I-94',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'

          },  
          {
            
            key: 'travelHistory',
            lebel: 'Travel History',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          },  
          {
            
            key: 'mostRecentPayStubs',
            lebel: '3 most recent pay stubs',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'
          },
          {

            key: 'other',
            lebel: 'Others',
            description:'',      
            fieldRequired: true,
            "required": true,
           "section":'dependentsInfo.spouse.documents'

             
          },

{
  "key": "name",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "middleName",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "lastName",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "email",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "currentAddress",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "address",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "countryOfBirthDetails",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "SSN",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "lastArrivalDate",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "I94",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "passportNumber",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "passportIssuedDate",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "passportExpiryDate",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "curNonImmigrantVisaStatus",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "curVisaExpiryDate",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYouEverEmployed",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
}, 
{
  "key": "empInUsIfANumber",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
}, 
{
  "key": "l1SpouseApprNumber",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "h1bSpouseApprNumber",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "cellPhoneNumber",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "cellPhoneCountryCode",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "beneficiaryInfo"
},
{
  "key": "countryCode",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "cellPhoneCountryCode"
},
{
  "key": "countryCallingCode",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "cellPhoneCountryCode"
},
{
  "key": "passport",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},



{

  "key": "proofOfCurrentStatus",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"


},
{

"key": "copyOfExistingL2Visa",
"lebel": "",
"required": true,
"description": "",
"fieldRequired": true,
"section": "documents"

},
{

  "key": "copyOfExistingVisa",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"

},
{

  "key": "approvalCopyOfI140",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"

},



{
  "key": "priorH4Approvals",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "priorL2Approvals",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "usVisa",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "mostRecentI94",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "marriageCertificate",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "eadCard",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "ssnCard",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "travelHistory",
  "lebel": "",
  "required": true,
  "description": "",
  "fieldRequired": true,
  "section": "documents"
},
{
  "key": "formI797H4ApprovalNotice",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "last3MonthsPayslipsOfPrinNonCtzn",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "documents"
},
{
  "key": "passportOfPrinNonCtzn",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "documents"
},
{
  "key": "formI797H1BApprovalNoticePrinNonCtzn",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "documents"
},
{
  "key": "anyOtherPersonEmployedInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "anyOtherPersonEmployedInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "hasMasterDegreeInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "anyOtherPersonEmployedInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "associations",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "associations",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.associations"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.associations"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.associations"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.associations"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.associations"
},
{
  "key": "natureofAssociations",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.associations"
},
{
  "key": "curNonImmigrantVisaNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "doesBirthRegistered",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "isVisaDenieedTOUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "visaDeniedReason",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYoueverPresntUnlawfully",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "presntUnlawfullyReason",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYouEverReceivedPublicAssistendeInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYouEverlikelyReceivePublicAssistendeInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "eadCard",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "dateOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "dateOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "applyingWithYou",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "applyingWithYou",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "haveYouArrestedBefore",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYouArrestedBeforeDocs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "maidenName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "marriageEndedDueTo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "usPermanentResidenceThroughSpouse",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "dateOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "dateOfMarriageEnd",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "addressOfLastNYears",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.addressOfLastNYears"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.addressOfLastNYears"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.addressOfLastNYears"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.addressOfLastNYears"
},
{
  "key": "feet",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.height"
},
{
  "key": "inches",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.height"
},
{
  "key": "feet",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.height"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.addressOutsideUS"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.addressOutsideUS"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.addressOutsideUSMoreThanYear"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.addressOutsideUSMoreThanYear"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.addressOutsideUSMoreThanYear"
},
{
  "key": "inches",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.height"
},
{
  "key": "race",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "provinceOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "provinceOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "locationOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "currentSpouseName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "presentMaritalStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "presentMaritalStatusDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "curNonImmigrantVisaStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "associations",
  "lebel": "",
  "required": false,
  "fieldRequired": false,
  "description": "",
  "section": "dependentsInfo.spouse.associations"
},
{
  "key": "marriageEndedOtherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "marriageEndedOtherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "prevEmploymentInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.associations"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.associations"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.associations"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.associations"
},
{
  "key": "natureofAssociations",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.associations"
},
{
  "key": "isVisaDenieedTOUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "visaDeniedReason",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "haveYoueverPresntUnlawfully",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "presntUnlawfullyReason",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "haveYouEverReceivedPublicAssistendeInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "haveYouEverlikelyReceivePublicAssistendeInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "bnfSpouseLatestI797",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "bnfSpousePassport",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "bnfSpouseRecentPayStubs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "bnfSpouseFormAllI20",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "slgOfferLetter",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "slgSignedOfferLetter",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "underlyingLaborApplications",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "mostRecentTaxTranscrips",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "documents"
},
{
  "key": "everAppliedAOSInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "appliedAOSInUSDocs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "appliedAOSInUSDocs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYouArrestedBefore",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "haveYouArrestedBeforeDocs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "doesBirthRegistered",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "curNonImmigrantVisaNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "enterInUSUnderCaseWaiverProgram",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "inspectedByAnyImmOfficer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "issuedAnyEADFromUSCIS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "hasPermResidencyInOtherCountry",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "permResidencyCountryId",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "permResidencyCountryDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "eadCard",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "passportIssuedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "noOfChildrens",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "dateOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "countryOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "countryOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "provinceOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "provinceOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "locationOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "doYouHaveMarriageCert",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "marriageCertDocs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "have2AffidavitsAttestingToMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "height",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "weight",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "race",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "eyeColor",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "hairColor",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "nameDiffFromBirthCert",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "birthCertHaveNamePobDob",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "have2AffidavitsOfBirthFamily",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "previouslyMarried",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "previousSpouse",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "dateOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "dateOfMarriageEnd",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "countryOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "countryOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "provinceOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "provinceOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "locationOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "countryOfMarriageTermination",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "countryOfMarriageTerminationDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "provinceOfMarriageTermination",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "provinceOfMarriageTerminationDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "locationOfMarriageTermination",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "obtainPermResidenceThroughSpouse",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.previousSpouse"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "locationOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "provinceOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "provinceOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "countryOfMarriageDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "countryOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "dateOfMarriageEnd",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "dateOfMarriage",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "marriageEndedDueTo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "maidenName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "obtainPermResidenceThroughSpouse",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "locationOfMarriageTermination",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "provinceOfMarriageTerminationDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "provinceOfMarriageTermination",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "countryOfMarriageTerminationDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "countryOfMarriageTermination",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "previousSpouse",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.previousSpouse"
},
{
  "key": "addressOutsideUSMoreThanYear",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "addressOfLastNYears",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "addressOfLastNYears",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.addressOfLastNYears"
},
{
  "key": "caseIssuedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "caseExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "placeOfCaseIssued",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "dateFromWhichResideInUs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "curNonImmCaseNo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "classification",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "inspectedByAnyImmOfficer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "issuedAnyEADFromUSCIS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "enterInUSUnderCaseWaiverProgram",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "hasPermResidencyInOtherCountry",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "permResidencyCountryId",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "permResidencyCountryDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "everAppliedAOSInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "i140PriorityDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "currentJobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "currentAnnualSalary",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "prevEmploymentOutsideUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "prevEmploymentOutsideUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "businessType",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "jobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "jobDuties",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "currentEmployer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "salary",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "payFrequency",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentOutsideUS"
},
{
  "key": "assets",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "financials",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "liabilitiesDebts",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "publicBenefits",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "currentlyInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveOwnershipInterest",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "ownershipInterestDesc",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "prevH1bCaseStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYouEverAppliedH1bCase",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "prevH1bCaseDesc",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "anyImmPetitionFiledDesc",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "consulateInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "alienNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "firstArrivalDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "mannerOfLastArrival",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "stateOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "stateDetailsOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "placeOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "educations",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "highestDegree",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "majorFieldOfStudy",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "attendedFrom",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "attendedTo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "graduatedYear",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "isAccredited",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "isForProfit",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.educations"
},
{
  "key": "haveYouEverTravelledToUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "haveYouEverTravelledToUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "haveYouEverTravelledToUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "nonImmPetitionsInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "h1bImmPetitionsInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "didThisPtnrFliedImmPetitionEarlier",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "anyImmPetitionFiled",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "immPetitionPriorityDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "anyOtherAlienFiled",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "filedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "rirOrRegularProcessing",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "filedStateId",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "filedStateDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "applCurStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "seekingFiledDateforETA750",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "anyI140Filed",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo"
},
{
  "key": "fieldDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo.i140Info"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo.i140Info"
},
{
  "key": "priorityDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo.i140Info"
},
{
  "key": "eb2orEb3",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo.i140Info"
},
{
  "key": "currentStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.immPetitionInfo.i140Info"
},
{
  "key": "prevEmploymentInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "businessType",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "jobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "jobDuties",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "currentEmployer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.prevEmploymentInfo"
},
{
  "key": "addressOutsideUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "gender",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "education",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "highestDegree",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.education"
},
{
  "key": "majorFieldOfStudy",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo.education"
},
{
  "key": "maritalStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "provinceOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "provinceOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "locationOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "countryOfCitizenship",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "countryOfCitizenshipDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "I94ExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "isI94DSExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "I94StatusName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "homePhoneNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "homePhoneCountryCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "countryCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "homePhoneCountryCode"
},
{
  "key": "countryCallingCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "homePhoneCountryCode"
},
{
  "key": "mailingAddressIsSameAsAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "consulateNotifyAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "hasI140ImmPetitionFiled",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "I140ImmPetitionFiledDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "passportIssuedCountry",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "passportIssuedCountryDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "allIssuedPassportData",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "isDSExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "isDSExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "sevisNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "isDSExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "haveYouEverEmployed",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "haveYouEverEmployed",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "hasAnyDependetsinUStoFileH4",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "eadNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "priorPeriodOfStayInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "noOfDaysStayInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "confirmDaysStayInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "hasApprovedI140",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "hasPermPendingForMorethan365Days",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "applyI485AdjOrConsuProcess",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "adjustmentOfI485Status",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "consularProcessing",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "areYouUnderRemoveOfIndOrUscis",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "beneficiaryInfo"
},
{
  "key": "relationship",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "passportIssuedCountry",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "currentlyInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "alienNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "addressOutsideUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "currentAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "priorPeriodOfStayInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "gender",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "h4Required",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "h4EADRequired",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "email",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "phoneNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.phoneCountryCode"
},
{
  "key": "countryCallingCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.phoneCountryCode"
},
{
  "key": "cellPhoneNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.cellPhoneCountryCode"
},
{
  "key": "countryCallingCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.cellPhoneCountryCode"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "provinceOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "provinceOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "locationOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryOfCitizenship",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryOfCitizenshipDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "passportNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "passportExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "allIssuedPassportData",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "countryId",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.allIssuedPassportData"
},
{
  "key": "countryDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.allIssuedPassportData"
},
{
  "key": "number",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.allIssuedPassportData"
},
{
  "key": "issuedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.allIssuedPassportData"
},
{
  "key": "expiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.allIssuedPassportData"
},
{
  "key": "I94",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "I94ExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "sevisNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "eadNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "isI94DSExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "currentStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "statusExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "SSN",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "firstArrivalDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "lastArrivalDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "mannerOfLastArrival",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "stateOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "stateDetailsOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "placeOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "mailingAddressIsSameAsAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
// {
//   "key": "physicalAddress",
//   "lebel": "",
//   "required": false,
//   "description": "",
//   "fieldRequired": false,
//   "section": "dependentsInfo.spouse"
// },
{
  "key": "addressOutsideUSMoreThanYear",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "caseIssuedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "caseExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "placeOfCaseIssued",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "dateFromWhichResideInUs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "curNonImmCaseNo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "classification",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "applyI485AdjOrConsuProcess",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "adjustmentOfI485Status",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "consularProcessing",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "adjustmentStatusToPermResidenceI485",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "height",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "weight",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "eyeColor",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "hairColor",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "nameDiffFromBirthCert",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "birthCertHaveNamePobDob",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "have2AffidavitsOfBirthFamily",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "i140PriorityDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "highestDegree",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "majorFieldOfStudy",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "attendedFrom",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "attendedTo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "graduatedYear",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "isAccredited",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "isForProfit",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.educations"
},
{
  "key": "currentJobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "currentAnnualSalary",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "salary",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "payFrequency",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "businessType",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "jobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "jobDuties",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "currentEmployer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentInfo"
},
{
  "key": "prevEmploymentOutsideUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "prevEmploymentOutsideUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "businessType",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "jobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "jobDuties",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "currentEmployer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "salary",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "payFrequency",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.prevEmploymentOutsideUS"
},
{
  "key": "assets",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "financials",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "liabilitiesDebts",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "publicBenefits",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "fatherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "countryOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "provinceOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "provinceOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "locationOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "currentAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "isUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "dateFromUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "nameAtBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
},
{
  "key": "middleName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
},
{
  "key": "lastName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "dependentsInfo.spouse.fatherInfo.nameAtBirth"
},
{
  "key": "deceasedCityDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "deceasedCityDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "deceasedCity",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "deceasedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "motherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "countryOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "provinceOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "provinceOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "locationOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "currentAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "isUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "dateFromUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "nameAtBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
},
{
  "key": "middleName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
},
{
  "key": "lastName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "dependentsInfo.spouse.motherInfo.nameAtBirth"
},
{
  "key": "deceasedCity",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "deceasedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "motherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "countryOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "provinceOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "provinceOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "locationOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "currentAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "isUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "dateFromUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "motherInfo.nameAtBirth"
},
{
  "key": "middleName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "motherInfo.nameAtBirth"
},
{
  "key": "lastName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "motherInfo.nameAtBirth"
},
{
  "key": "deceasedCity",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "deceasedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "motherInfo"
},
{
  "key": "fatherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "countryOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "provinceOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "provinceOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "locationOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "currentAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "isUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "dateFromUSCitizen",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "firstName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "fatherInfo.nameAtBirth"
},
{
  "key": "middleName",
  "lebel": "",
  "description": "",
  "fieldRequired": false,
  "required": false,
  "section": "fatherInfo.nameAtBirth"
},
{
  "key": "lastName",
  "lebel": "",
  "fieldRequired": false,
  "required": false,
  "description": "",
  "section": "fatherInfo.nameAtBirth"
},
{
  "key": "deceasedCity",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "deceasedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "fatherInfo"
},
{
  "key": "passport",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "usVisa",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "formI94",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "formI797",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "formI20",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "payStubs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "marriageCertificate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "noticeOfApprovalOfH1Status",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "approvalNoticeOfPrevH4",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "other",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "birthCertificate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "photographs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "medicalExamins",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "dependentForI134",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "dependentTaxReturns",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "w2",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "bankStatements",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "evidenceOfContinuVisaStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "evidenceOfFilePetitionBefore30Apr2001",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "proofOfIncomeOrAsset",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "proofOfMedicalInsurence",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "recentCreditReport",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "permResidence",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "empAuth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "I140ApprovalNotice",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "h4EadPhotoEmailStmt",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse"
},
{
  "key": "slgPrevLaborApplications",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "slgApprovalNoticeOfPrevH4",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.documents"
},
{
  "key": "slgApprovalNoticeOfPrevH4",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "slgApprovalNoticeOfPrevL2",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "relationship",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "passportIssuedCountry",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "currentlyInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "hasOtherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "otherNames",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "passportIssuedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "alienNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "addressOutsideUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},

{
  "key": "priorPeriodOfStayInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "gender",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "hasChildren",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "h4EADRequired",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "firstName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "middleName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "lastName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "email",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "phoneNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "countryCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.phoneCountryCode"
},
{
  "key": "countryCallingCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.phoneCountryCode"
},
{
  "key": "cellPhoneNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "countryCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.cellPhoneCountryCode"
},
{
  "key": "countryCallingCode",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.cellPhoneCountryCode"
},
{
  "key": "dateOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "countryOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "placeOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "stateOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "prevEmploymentInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "businessType",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "salary",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "payFrequency",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "jobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "jobDuties",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "currentEmployer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentInfo"
},
{
  "key": "countryOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "provinceOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "provinceOfBirthDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "locationOfBirth",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "countryOfCitizenship",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "countryOfCitizenshipDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "passportNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "passportExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "countryId",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.allIssuedPassportData"
},
{
  "key": "countryDetails",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.allIssuedPassportData"
},
{
  "key": "number",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.allIssuedPassportData"
},
{
  "key": "issuedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.allIssuedPassportData"
},
{
  "key": "expiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.allIssuedPassportData"
},
{
  "key": "I94",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "I94ExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "sevisNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "eadNumber",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},

{
  "key": "isI94DSExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "currentStatus",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "statusExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "SSN",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "firstArrivalDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "lastArrivalDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "mannerOfLastArrival",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "stateDetailsOfLastEntryInUS",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "currentAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "physicalAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "mailingAddressIsSameAsAddress",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},

{
  "key": "addressOutsideUSMoreThanYear",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "addressOfLastNYears",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "caseIssuedDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "caseExpiryDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "placeOfCaseIssued",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "dateFromWhichResideInUs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "curNonImmCaseNo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "classification",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "applyI485AdjOrConsuProcess",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "adjustmentOfI485Status",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "consularProcessing",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "adjustmentStatusToPermResidenceI485",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "height",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "weight",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "eyeColor",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "hairColor",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "nameDiffFromBirthCert",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "birthCertHaveNamePobDob",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "have2AffidavitsOfBirthFamily",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "i140PriorityDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "name",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "highestDegree",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "majorFieldOfStudy",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "attendedFrom",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "attendedTo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "graduatedYear",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "isAccredited",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "isForProfit",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.educations"
},
{
  "key": "currentJobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "currentAnnualSalary",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "fatherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.fatherInfo"
},
{
  "key": "motherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.spouse.motherInfo"
},
{
  "key": "employerName",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "address",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "businessType",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "jobTitle",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "jobDuties",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "startDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "endDate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "currentEmployer",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.prevEmploymentOutsideUS"
},
{
  "key": "assets",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "financials",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "liabilitiesDebts",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "publicBenefits",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "fatherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "motherInfo",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens"
},
{
  "key": "passport",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "visa",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "formI94",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "birthCertificate",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "approvalNotice",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "approvalNoticeOfPrevH4",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "other",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "photographs",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "medicalExamins",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "dependentForI134",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "dependentTaxReturns",
  "lebel": "",
  "required": false,
  "description": "",
  "fieldRequired": false,
  "section": "dependentsInfo.childrens.documents"
},
{
  "key": "w2",
  "lebel": "",
  "required": false,
  "description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "bankStatements",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "evidenceOfContinuVisaStatus",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "evidenceOfFilePetitionBefore30Apr2001",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "proofOfIncomeOrAsset",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "proofOfMedicalInsurence",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "recentCreditReport",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "permResidence",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "empAuth",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "I140ApprovalNotice",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "slgPrevLaborApplications",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "dependentsInfo.childrens.documents"
},
{
"key": "resume",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "education",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "expLetters",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "INSNotices",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "I140ApprovalNotice",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "passportVisaI94",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "formI20",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "socialSecurityCardAndProfLicense",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "other",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "payStubs",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "offerLetter",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "clientLetter",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "vendorLetter",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "msa",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "po",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "h4Ead",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "beneficiaryDocs",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "h1bRegSelectionNotice",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "employmentAgreement",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "primeVendor",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "priorFormI797",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "I797NoticeofApprovalforI140",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "w2",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "birthCertificate",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "photographs",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "medicalExamins",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "dependentForI134",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "dependentTaxReturns",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "bankStatements",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "evidenceOfContinuVisaStatus",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "evidenceOfFilePetitionBefore30Apr2001",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "proofOfIncomeOrAsset",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "proofOfMedicalInsurence",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "recentCreditReport",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "permResidence",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "empAuth",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "capSelectNotice",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgResume",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgCollegeDegreesCert",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgTransScripts",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgExpLetters",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgPassportAndVisa",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgI94",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgPrevNonimmApprovalNotices",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgPrevImmApprovalNotices",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgI140OrPermNoties",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgPrevLaborApplications",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgAckOfPrevLaborApplications",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgPaystubs",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgI20",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgEad",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgEvalOfEduCredentials",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
},
{
"key": "slgEvalOfEduExpCredentials",
"lebel": "",
"required": false,
"description": "",
"fieldRequired": false,
"section": "documents"
}
      ],
      dbFields: [],
      responseFields: [],
      PayloadData: {
        name: "",
        questionnaireId: "",
        fields: [],
        sections: [],
      },
      configId: null,
      configDetails: null,
      updating:false,
    };
  },

  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  components: {
    VuePhoneNumberInput,
    Datepicker,
    selectField,
    immiPhone,
    datepickerField,
    immiMask,
    immiyesorno,
    immiuploader,
    addressField,
    Trash2Icon,
    InfoIcon,
    EyeIcon,
    immiswitchyesno,
    immitextarea,
    //genderField,
    immiInput,
    Multiselect,
  },
  methods: {
    
    cccheckFieldRequired({section= '',key= ''}){
    

    let item = _.find(this.h4fields,{section:section , key:key});
    if(item.fieldRequired){
     return true;
    }else{
      return false;
    }
  

   },
   showOrHideField({section= '',key= ''}){
    let localSection = section
    let localKey = key
    if(this.isEdit){
      return true
    }else if(this.checkProperty(this.dbFields, "length") > 0) {
      let dbItem = _.find(this.dbFields, {'section':localSection,'key':localKey})
      if(dbItem){
        return true
      }
      else {
        return false
      }
    }else{
      return true
    }

   },
    toogleFields({section= '',key= ''}){
      //alert("section ===  "+section+" key== "+key)
      _.map(this.h4fields,(item)=>{
        if(item.section==section && item.key==key ){
          item.fieldRequired?item.fieldRequired=false:item.fieldRequired =true
          if(item.fieldRequired == false || item.fieldRequired == 'false' ){
            _.update(this, section + "." + key, () => false);
          }
        }
      });
     
      this.h4fields = _.cloneDeep(this.h4fields);

      //alert('sairam')
    },
    updateTablist() {
                if (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.maritalStatusDetails && this.petition.beneficiaryInfo.maritalStatusDetails.id == 2) {
    
                    var index = _.find(this.tabslist, function (item) {
    
                        return item.key == "dependentsinfo"
                    })
                    if (index) {
    
                    } else {
                        this.tabslist.push({
                            key: "dependentsinfo",
                            name: "Dependents Info"
                        })
                    }
    
                } else {
    
                    this.tabslist = _.filter(this.tabslist, function (item) {
    
                        return item.key != "dependentsinfo"
                    })
                }
    
            },
    goBack() {
                this.setActiveTab(this.tabslist[this.getIndexOfActivetab - 2].key)
    
            },
    selectCheck({ section = "", subSection = "", key = "" }) {
      
      let fieldIndex = _.findIndex(this.h4fields, { section: section, key: key });
     

      if (fieldIndex > -1) {
        let Item = _.cloneDeep(this.h4fields[fieldIndex]);
       Item["required"] =  _.get(this ,section+'.'+key ,true);
       this.h4fields[fieldIndex] = Item;
      } else {
        let newItem = {
          key: key,
          lebel: "First Name",
          required: _.get(this ,section+'.'+key ,true),
          description: "",
          section: section,
        };
        this.h4fields.push(newItem);
      }
      this.h4fields = _.cloneDeep(this.h4fields);
    },
    finalSubmit() {
      this.showFinalsubmitPopup = true;
    },
    // processDbFields() {
    //   let self = this;
     
    //   if (this.checkProperty(this.dbFields, "length") > 0) {
    //     _.forEach(this.dbFields, (dbItem) => {
    //       let dbsection = this.checkProperty(dbItem,'section')
    //       let dbkeyFiled = this.checkProperty(dbItem,'key')
    //       if (dbsection && dbkeyFiled) {
    //         _.map(self.h4fields, (item) => {
    //           if (dbkeyFiled == item['key'] && dbsection == item['section']) {
    //             item['required'] = dbItem['required'];
    //             item['fieldRequired'] =true;
                
    //           }else{
    //             item['fieldRequired'] =false;
    //             item['required'] = true;

    //           }
    //         });
    //         _.update(self,dbsection+'.'+dbkeyFiled ,()=>dbItem['required'])   
    //       }
    //     });
    //     this.h4fields =_.cloneDeep(this.h4fields);
    //   }
    // },
    processDataFields(){
      let self = this;
      try{
        if (this.checkProperty(this.dbFields, "length") > 0) {

          

        _.forEach(self.h4fields, (item)=>{
          let localItem = item
          let localSection = this.checkProperty(localItem,'section')
          let localKey = this.checkProperty(localItem,'key')
          let dbItem = _.find(this.dbFields, {'section':localSection,'key':localKey})
          item['fieldRequired'] = false;
          item['required'] = false;
          _.update(self,localSection+'.'+localKey ,()=>false)
          if(dbItem){
            item['fieldRequired'] = true;
            if(this.checkProperty(dbItem, 'required') || this.checkProperty(dbItem, 'required') == 'true' ){
              item['required'] = true;
            }
            else{
              item['required'] = false;
            }
            

              _.update(self,localSection+'.'+localKey ,()=>dbItem['required'])

            

           
          }
        })
        this.isEveryThingLoaded = true
        this.$vs.loading.close()
      }
      this.isEveryThingLoaded = true
      this.$vs.loading.close()
      }
      catch{
        this.isEveryThingLoaded = true
        this.$vs.loading.close()
      }
      
    },
    getConfigDetails() {
      let postData = { questionnaireId: this.configId };
      this.isEveryThingLoaded = false
      this.$vs.loading();
      this.$store
        .dispatch("commonAction", { data: postData, path: "/questionnaire/details" })
        .then((res) => {
          this.configDetails = res;
         
         
          this.PayloadData["name"] = res.name;
          this.PayloadData["questionnaireId"] = this.configId;
          this.dbFields = this.configDetails.fields;
          //this.processDbFields();
          this.processDataFields();
        }).catch((err)=>{
          this.isEveryThingLoaded = true
          this.$vs.loading.close()
        });
    },
    saveMe(isFinalSUbmit = false) {
      
      let PayloadData = _.cloneDeep(this.PayloadData);
      if (_.has(PayloadData, "questionnaireId")) {
        PayloadData["questionnaireId"] = this.configId;
      }
      if (_.has(PayloadData, "name")) {
        PayloadData["name"] = this.PayloadData["name"];
      }
      // if (_.has(PayloadData, "fields")) {
      //   PayloadData["fields"] = _.sortedUniq(this.h4fields);
      // }
      if (_.has(PayloadData, "sections")) {
        PayloadData["sections"] = _.sortedUniq(PayloadData.sections);
      }
      if (isFinalSUbmit) {
        PayloadData = Object.assign(PayloadData, { configCompleted: true });
        PayloadData["configCompleted"] = true;
      }
      if (this.configDetails.tenantId) {
        PayloadData = Object.assign(PayloadData, {
          tenantId: this.configDetails.tenantId,
        });
      }
      
        PayloadData["fields"] = _.filter(this.h4fields ,(item)=>{
          return item['fieldRequired'] == true || item['fieldRequired'] == 'true' ;
        })
      
      this.updating =true;
      this.$store
        .dispatch("commonAction", {
          data: PayloadData,
          path: "/questionnaire/update",
        })
        .then((res) => {
          this.updating =false;
          this.showToster({ message: res.message, isError: false });
          this.showFinalsubmitPopup = false;
          this.getConfigDetails();

          setTimeout(() => {
            if (this.templateId) {
              this.$emit("gotoList");
            } else {
              this.$router.push("/questionnaire-templates-list");
            }
          }, 10);
        })
        .catch((err) => {
          this.updating =false;
          this.showToster({ message: err, isError: true });
        });
    },
    //createTemplate(){},
  },
  mounted() {
    
    this.updating =false;
    this.configId = this.$route.params.id;
    if (this.templateId) {
      this.configId = this.templateId;
    }
    this.getConfigDetails();
    //this.processDbFields();
  },
  computed: {
    checkSpouseLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['obtainPermResidenceThroughSpouse','marriageEndedOtherInfo','marriageEndedDueTo','locationOfMarriageTermination','provinceOfMarriageTermination',
          'countryOfMarriageTermination','locationOfMarriage','provinceOfMarriage','countryOfMarriage','dateOfMarriageEnd','dateOfMarriage',
          'dateOfBirth','maidenName','lastName','middleName','firstName']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkFieldRequired(){
     return (data)=>{

      let item = _.find(this.h4fields,{"section":data.section , "key":data.key});
     
      if(item && _.has(item ,"fieldRequired") && item.fieldRequired){
        return true;
      }else{
        return false;
      }
  }

},
            checkActiveTab(){
              return  _.findIndex(this.tabslist ,{"key":this.currentTab});
            },  
          
          getIndexOfActivetab() {
                var $self = this;
                return _.findIndex(this.tabslist, (e) => {
                    return e.key == $self.currentTab;
                }) + 1;
            },
            actiontype() {
                if (this.getIndexOfActivetab == this.tabslist.length) {
                    if (this.petition.questionnaireFilled) {
                        return "Update";
                    }
                    if (!this.petition.questionnaireFilled) {
                        return "Review & Submit";
                    }
                    return "Submit";
                }
                return "Next";
            }
          }
};
</script>